/*
 * ==========================================
 * |          GENERATED BY SUPAZOD          |
 * ==========================================
 */
import {z} from 'zod';

import {type Json} from './../types/database.types';

export const publicApplicationStatusEnumSchema = z.union([
  z.literal('pending'),
  z.literal('approved'),
  z.literal('rejected'),
]);

export const publicBillingHistoryEventTypesSchema = z.union([
  z.literal('invoice_created'),
  z.literal('payment_captured'),
  z.literal('payment_failed'),
  z.literal('payment_pending'),
  z.literal('refund'),
  z.literal('chargeback'),
  z.literal('credit_issued'),
  z.literal('manual_adjust'),
]);

export const publicChatTypesSchema = z.union([
  z.literal('product_list'),
  z.literal('text'),
  z.literal('image'),
  z.literal('link'),
]);

export const publicDataPaymentProvidersSchema = z.union([z.literal('straddle'), z.literal('authorize_net')]);

export const publicDataSassDiscountTypesSchema = z.union([z.literal('percentage'), z.literal('fixed_amount')]);

export const publicDataSassSubscriptionStatusSchema = z.union([
  z.literal('active'),
  z.literal('canceled'),
  z.literal('past_due'),
  z.literal('pending'),
]);

export const publicDataSassSubscriptionTypesSchema = z.union([
  z.literal('base'),
  z.literal('additional_location'),
  z.literal('seat'),
  z.literal('renewal'),
]);

export const publicDataSassSubscriptionTypesOldVersionToBeDroppedSchema = z.union([
  z.literal('base'),
  z.literal('additional_location'),
  z.literal('seat'),
]);

export const publicInventoryTypeSchema = z.union([z.literal('brand'), z.literal('distributor'), z.literal('retailer')]);

export const publicInventorytypeSchema = z.union([z.literal('brand'), z.literal('distributor'), z.literal('retailer')]);

export const publicInvoiceFrequencySchema = z.union([
  z.literal('weekly'),
  z.literal('monthly'),
  z.literal('quarterly'),
  z.literal('yearly'),
]);

export const publicInvoiceItemPriceTypeSchema = z.union([
  z.literal('wholesale'),
  z.literal('factored'),
  z.literal('custom'),
]);

export const publicInvoicePaymentMethodSchema = z.union([
  z.literal('cod'),
  z.literal('ach'),
  z.literal('debit'),
  z.literal('credit'),
]);

export const publicInvoiceStatusSchema = z.union([
  z.literal('pending'),
  z.literal('paid'),
  z.literal('cancelled'),
  z.literal('failed'),
]);

export const publicMatchMethodTypeSchema = z.union([
  z.literal('address+geo'),
  z.literal('single_source_iheartjane'),
  z.literal('single_source_dutchie'),
  z.literal('single_source_weedmaps'),
  z.literal('phone+geo'),
  z.literal('name_similarity+geo'),
]);

export const publicNotificationStatusSchema = z.union([z.literal('unread'), z.literal('read'), z.literal('archived')]);

export const publicNotificationTypeSchema = z.union([
  z.literal('info'),
  z.literal('success'),
  z.literal('warning'),
  z.literal('error'),
]);

export const publicOrderPaymentMethodSchema = z.union([
  z.literal('cash'),
  z.literal('card'),
  z.literal('ach'),
  z.literal('credit'),
]);

export const publicOrderPaymentTermsSchema = z.union([
  z.literal('cod'),
  z.literal('net15'),
  z.literal('net30'),
  z.literal('net60'),
]);

export const publicOrderStatusSchema = z.union([
  z.literal('pending'),
  z.literal('accepted'),
  z.literal('rejected'),
  z.literal('in-progress'),
  z.literal('closed'),
  z.literal('draft'),
]);

export const publicOrderpaymentmethodSchema = z.union([
  z.literal('cash'),
  z.literal('card'),
  z.literal('ach'),
  z.literal('credit'),
]);

export const publicOrderpaymenttermsSchema = z.union([
  z.literal('cod'),
  z.literal('net15'),
  z.literal('net30'),
  z.literal('net60'),
]);

export const publicOrderstatusSchema = z.union([
  z.literal('pending'),
  z.literal('accepted'),
  z.literal('rejected'),
  z.literal('in_progress'),
  z.literal('closed'),
]);

export const publicOrdertypeSchema = z.union([
  z.literal('Distributor'),
  z.literal('Retailer'),
  z.literal('distributor_return'),
  z.literal('retailer_return'),
]);

export const publicPaymentChargeTypeSchema = z.union([z.literal('card'), z.literal('ach'), z.literal('crypto')]);

export const publicPaymentMethodTypeSchema = z.union([z.literal('credit'), z.literal('debit'), z.literal('ach')]);

export const publicPaymentmethodtypeSchema = z.union([z.literal('credit'), z.literal('debit'), z.literal('ach')]);

export const publicPlaidBankAccountTypeSchema = z.union([z.literal('checking'), z.literal('savings')]);

export const publicPlaidbankaccounttypeSchema = z.union([z.literal('checking'), z.literal('savings')]);

export const publicPointOfSalesSchema = z.union([
  z.literal('flowhub'),
  z.literal('cova'),
  z.literal('blaze'),
  z.literal('treez'),
  z.literal('iheartjane'),
  z.literal('dutchie'),
]);

export const publicPosCategoryTypeSchema = z.union([z.literal('primary_category'), z.literal('sub_category')]);

export const publicPosDataScrapeFrequencySchema = z.union([
  z.literal('1hour'),
  z.literal('12hour'),
  z.literal('1day'),
  z.literal('1week'),
  z.literal('2week'),
  z.literal('1month'),
  z.literal('6month'),
]);

export const publicPosDataScrapeStatusSchema = z.union([
  z.literal('pending'),
  z.literal('success'),
  z.literal('failed'),
  z.literal('timeout'),
]);

export const publicPosDataWmProductIdTypesSchema = z.union([
  z.literal('external_id'),
  z.literal('item_id'),
  z.literal('product_id'),
  z.literal('item_name'),
  z.literal('product_name'),
]);

export const publicPosProductLinkTypeSchema = z.union([z.literal('override'), z.literal('tnc_sync')]);

export const publicPositionExchangeOrderTypesSchema = z.union([
  z.literal('wholesale'),
  z.literal('buy'),
  z.literal('sell'),
  z.literal('cherry'),
]);

export const publicPositionSpecificOrderTypeSchema = z.union([z.literal('market'), z.literal('limit')]);

export const publicPositionStatusSchema = z.union([z.literal('pending'), z.literal('active'), z.literal('closed')]);

export const publicPositionTypeSchema = z.union([
  z.literal('wholesale'),
  z.literal('market'),
  z.literal('shelf'),
  z.literal('limit'),
]);

export const publicPositionstatusSchema = z.union([z.literal('pending'), z.literal('active'), z.literal('closed')]);

export const publicProductContentUnitSchema = z.union([
  z.literal('mg'),
  z.literal('g'),
  z.literal('kg'),
  z.literal('ml'),
  z.literal('oz'),
  z.literal('lb'),
  z.literal('gallon'),
  z.literal('liter'),
  z.literal('percentage'),
]);

export const publicProductcontentunitSchema = z.union([
  z.literal('mg'),
  z.literal('g'),
  z.literal('kg'),
  z.literal('ml'),
  z.literal('oz'),
  z.literal('lb'),
  z.literal('gallon'),
  z.literal('liter'),
  z.literal('percentage'),
]);

export const publicReferralcampaignapplicationtypeenumSchema = z.union([
  z.literal('exchange_web'),
  z.literal('tnc_mobile'),
  z.literal('shop_web'),
]);

export const publicRetailerstatusSchema = z.union([
  z.literal('pending'),
  z.literal('accepted'),
  z.literal('rejected'),
  z.literal('in-progress'),
  z.literal('closed'),
  z.literal('draft'),
]);

export const publicRoleEntityTypeSchema = z.union([
  z.literal('brand'),
  z.literal('distributor'),
  z.literal('retailer'),
]);

export const publicRoleTypeEntityTypeSchema = z.union([
  z.literal('speculator'),
  z.literal('admin'),
  z.literal('super-admin'),
  z.literal('brand-user'),
  z.literal('brand-manager'),
  z.literal('brand-admin'),
  z.literal('distributor-user'),
  z.literal('distributor-manager'),
  z.literal('distributor-admin'),
  z.literal('retailer-user'),
  z.literal('retailer-manager'),
  z.literal('retailer-admin'),
]);

export const publicRoletypeentitytypeSchema = z.union([
  z.literal('speculator'),
  z.literal('admin'),
  z.literal('super_admin'),
  z.literal('brand_user'),
  z.literal('brand_manager'),
  z.literal('brand_admin'),
  z.literal('distributor_user'),
  z.literal('distributor_manager'),
  z.literal('distributor_admin'),
  z.literal('retailer_user'),
  z.literal('retailer_manager'),
  z.literal('retailer_admin'),
]);

export const publicSeatRoleSchema = z.union([
  z.literal('viewer'),
  z.literal('member'),
  z.literal('admin'),
  z.literal('owner'),
]);

export const publicSiteProfileEnumsSchema = z.union([
  z.literal('exchange'),
  z.literal('data'),
  z.literal('tnc_mobile'),
]);

export const publicStraddlePaymentStatusSchema = z.union([
  z.literal('created'),
  z.literal('scheduled'),
  z.literal('failed'),
  z.literal('cancelled'),
  z.literal('on_hold'),
  z.literal('pending'),
  z.literal('paid'),
  z.literal('reversed'),
]);

export const publicTransactionStatusSchema = z.union([
  z.literal('pending'),
  z.literal('success'),
  z.literal('failed'),
  z.literal('canceled'),
]);

export const publicTransactionTypeSchema = z.union([
  z.literal('deposit'),
  z.literal('withdraw'),
  z.literal('transfer'),
  z.literal('hold'),
  z.literal('release_hold'),
  z.literal('wholesale_credit'),
]);

export const jsonSchema: z.ZodSchema<Json> = z.lazy(() =>
  z
    .union([z.string(), z.number(), z.boolean(), z.record(z.union([jsonSchema, z.undefined()])), z.array(jsonSchema)])
    .nullable()
);

export const publicReceivedQuantityRowSchemaSchema = z.object({
  received_quantity: z.number().nullable(),
});

export const publicReceivedQuantityInsertSchemaSchema = z.object({
  received_quantity: z.number().optional().nullable(),
});

export const publicReceivedQuantityUpdateSchemaSchema = z.object({
  received_quantity: z.number().optional().nullable(),
});

export const publicAdminRowSchemaSchema = z.object({
  admin_id: z.number(),
  admin_speculator_id: z.number().nullable(),
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  is_active: z.boolean(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
  role: z.string().nullable(),
  uid: z.string(),
});

export const publicAdminInsertSchemaSchema = z.object({
  admin_id: z.number().optional(),
  admin_speculator_id: z.number().optional().nullable(),
  created_by: z.string(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  is_active: z.boolean(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  role: z.string().optional().nullable(),
  uid: z.string(),
});

export const publicAdminUpdateSchemaSchema = z.object({
  admin_id: z.number().optional(),
  admin_speculator_id: z.number().optional().nullable(),
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  is_active: z.boolean().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  role: z.string().optional().nullable(),
  uid: z.string().optional(),
});

export const publicAdminRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_from_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_to_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Speculator'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_dashboard_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_position_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_accounts_view'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
]);

export const publicAffiliatesRowSchemaSchema = z.object({
  branch_link: z.string(),
  created_at: z.string().nullable(),
  id: z.string(),
  last_payout_date: z.string().nullable(),
  payout_status: z.string().nullable(),
  referral_code: z.string(),
  referral_count: z.number().nullable(),
  referred_by: z.string().nullable(),
  total_earnings: z.number().nullable(),
  updated_at: z.string().nullable(),
  user_id: z.string(),
});

export const publicAffiliatesInsertSchemaSchema = z.object({
  branch_link: z.string(),
  created_at: z.string().optional().nullable(),
  id: z.string().optional(),
  last_payout_date: z.string().optional().nullable(),
  payout_status: z.string().optional().nullable(),
  referral_code: z.string(),
  referral_count: z.number().optional().nullable(),
  referred_by: z.string().optional().nullable(),
  total_earnings: z.number().optional().nullable(),
  updated_at: z.string().optional().nullable(),
  user_id: z.string(),
});

export const publicAffiliatesUpdateSchemaSchema = z.object({
  branch_link: z.string().optional(),
  created_at: z.string().optional().nullable(),
  id: z.string().optional(),
  last_payout_date: z.string().optional().nullable(),
  payout_status: z.string().optional().nullable(),
  referral_code: z.string().optional(),
  referral_count: z.number().optional().nullable(),
  referred_by: z.string().optional().nullable(),
  total_earnings: z.number().optional().nullable(),
  updated_at: z.string().optional().nullable(),
  user_id: z.string().optional(),
});

export const publicAffiliatesRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Affiliates_referred_by_fkey'),
    columns: z.tuple([z.literal('referred_by')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Affiliates'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicAnalyticEventsRowSchemaSchema = z.object({
  created_at: z.string(),
  event: z.string(),
  id: z.number(),
  properties: jsonSchema,
  user_id: z.string(),
});

export const publicAnalyticEventsInsertSchemaSchema = z.object({
  created_at: z.string().optional(),
  event: z.string(),
  id: z.number().optional(),
  properties: jsonSchema.optional(),
  user_id: z.string(),
});

export const publicAnalyticEventsUpdateSchemaSchema = z.object({
  created_at: z.string().optional(),
  event: z.string().optional(),
  id: z.number().optional(),
  properties: jsonSchema.optional(),
  user_id: z.string().optional(),
});

export const publicApplicationsRowSchemaSchema = z.object({
  application_contact_email: z.string().nullable(),
  application_contact_number: z.string().nullable(),
  application_entity_id: z.number(),
  application_entity_type: publicRoleEntityTypeSchema,
  application_id: z.number(),
  application_notes: z.string().nullable(),
  application_status: publicApplicationStatusEnumSchema,
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_speculator_id: z.number(),
});

export const publicApplicationsInsertSchemaSchema = z.object({
  application_contact_email: z.string().optional().nullable(),
  application_contact_number: z.string().optional().nullable(),
  application_entity_id: z.number(),
  application_entity_type: publicRoleEntityTypeSchema,
  application_id: z.number().optional(),
  application_notes: z.string().optional().nullable(),
  application_status: publicApplicationStatusEnumSchema,
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_speculator_id: z.number(),
});

export const publicApplicationsUpdateSchemaSchema = z.object({
  application_contact_email: z.string().optional().nullable(),
  application_contact_number: z.string().optional().nullable(),
  application_entity_id: z.number().optional(),
  application_entity_type: publicRoleEntityTypeSchema.optional(),
  application_id: z.number().optional(),
  application_notes: z.string().optional().nullable(),
  application_status: publicApplicationStatusEnumSchema.optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_speculator_id: z.number().optional(),
});

export const publicApplicationsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Applications_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_from_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Applications_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_to_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Applications_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Speculator'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Applications_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_dashboard_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Applications_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_position_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Applications_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_accounts_view'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
]);

export const publicBrandRowSchemaSchema = z.object({
  brand_address: z.string().nullable(),
  brand_address2: z.string().nullable(),
  brand_city: z.string().nullable(),
  brand_description: z.string().nullable(),
  brand_email: z.string().nullable(),
  brand_id: z.number(),
  brand_license_number: z.string().nullable(),
  brand_logo_url: z.string().nullable(),
  brand_name: z.string(),
  brand_phone: z.string().nullable(),
  brand_postal_code: z.string().nullable(),
  brand_state: z.string().nullable(),
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  fk_weedmap_brand_id: z.number().nullable(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
  status: publicApplicationStatusEnumSchema,
});

export const publicBrandInsertSchemaSchema = z.object({
  brand_address: z.string().optional().nullable(),
  brand_address2: z.string().optional().nullable(),
  brand_city: z.string().optional().nullable(),
  brand_description: z.string().optional().nullable(),
  brand_email: z.string().optional().nullable(),
  brand_id: z.number().optional(),
  brand_license_number: z.string().optional().nullable(),
  brand_logo_url: z.string().optional().nullable(),
  brand_name: z.string(),
  brand_phone: z.string().optional().nullable(),
  brand_postal_code: z.string().optional().nullable(),
  brand_state: z.string().optional().nullable(),
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  fk_weedmap_brand_id: z.number().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  status: publicApplicationStatusEnumSchema.optional(),
});

export const publicBrandUpdateSchemaSchema = z.object({
  brand_address: z.string().optional().nullable(),
  brand_address2: z.string().optional().nullable(),
  brand_city: z.string().optional().nullable(),
  brand_description: z.string().optional().nullable(),
  brand_email: z.string().optional().nullable(),
  brand_id: z.number().optional(),
  brand_license_number: z.string().optional().nullable(),
  brand_logo_url: z.string().optional().nullable(),
  brand_name: z.string().optional(),
  brand_phone: z.string().optional().nullable(),
  brand_postal_code: z.string().optional().nullable(),
  brand_state: z.string().optional().nullable(),
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  fk_weedmap_brand_id: z.number().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  status: publicApplicationStatusEnumSchema.optional(),
});

export const publicDataSassDiscountCodeUsageRowSchemaSchema = z.object({
  applied_amount: z.number(),
  date_used: z.string().nullable(),
  fk_billing_history_id: z.number().nullable(),
  fk_discount_code_id: z.number().nullable(),
  fk_user_id: z.number().nullable(),
  id: z.number(),
});

export const publicDataSassDiscountCodeUsageInsertSchemaSchema = z.object({
  applied_amount: z.number(),
  date_used: z.string().optional().nullable(),
  fk_billing_history_id: z.number().optional().nullable(),
  fk_discount_code_id: z.number().optional().nullable(),
  fk_user_id: z.number().optional().nullable(),
  id: z.number().optional(),
});

export const publicDataSassDiscountCodeUsageUpdateSchemaSchema = z.object({
  applied_amount: z.number().optional(),
  date_used: z.string().optional().nullable(),
  fk_billing_history_id: z.number().optional().nullable(),
  fk_discount_code_id: z.number().optional().nullable(),
  fk_user_id: z.number().optional().nullable(),
  id: z.number().optional(),
});

export const publicDataSassDiscountCodeUsageRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('data_sass_discount_code_usage_fk_discount_code_id_fkey'),
    columns: z.tuple([z.literal('fk_discount_code_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_discount_code_usage_view'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_discount_code_usage_fk_discount_code_id_fkey'),
    columns: z.tuple([z.literal('fk_discount_code_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_discount_codes'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicDataSassDiscountCodesRowSchemaSchema = z.object({
  applies_to: publicDataSassSubscriptionTypesSchema,
  code: z.string(),
  created_by: z.string(),
  currency: z.string().nullable(),
  current_uses: z.number().nullable(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  description: z.string().nullable(),
  discount_type: publicDataSassDiscountTypesSchema,
  discount_value: z.number(),
  effective_date: z.string(),
  expiration_date: z.string().nullable(),
  id: z.number(),
  is_active: z.boolean(),
  max_uses: z.number().nullable(),
  min_purchase_amount: z.number().nullable(),
});

export const publicDataSassDiscountCodesInsertSchemaSchema = z.object({
  applies_to: publicDataSassSubscriptionTypesSchema,
  code: z.string(),
  created_by: z.string(),
  currency: z.string().optional().nullable(),
  current_uses: z.number().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  discount_type: publicDataSassDiscountTypesSchema,
  discount_value: z.number(),
  effective_date: z.string(),
  expiration_date: z.string().optional().nullable(),
  id: z.number().optional(),
  is_active: z.boolean().optional(),
  max_uses: z.number().optional().nullable(),
  min_purchase_amount: z.number().optional().nullable(),
});

export const publicDataSassDiscountCodesUpdateSchemaSchema = z.object({
  applies_to: publicDataSassSubscriptionTypesSchema.optional(),
  code: z.string().optional(),
  created_by: z.string().optional(),
  currency: z.string().optional().nullable(),
  current_uses: z.number().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  discount_type: publicDataSassDiscountTypesSchema.optional(),
  discount_value: z.number().optional(),
  effective_date: z.string().optional(),
  expiration_date: z.string().optional().nullable(),
  id: z.number().optional(),
  is_active: z.boolean().optional(),
  max_uses: z.number().optional().nullable(),
  min_purchase_amount: z.number().optional().nullable(),
});

export const publicDataSassInvoicesRowSchemaSchema = z.object({
  additional_access_users: z.array(z.string()).nullable(),
  amount: z.number(),
  created_at: z.string(),
  description: z.string(),
  due_date: z.string(),
  id: z.string(),
  invoice_number: z.string(),
  is_admin_subscription_creation: z.boolean(),
  is_recurring: z.boolean(),
  metadata: jsonSchema,
  parent_invoice_id: z.string().nullable(),
  payment_processed_at: z.string().nullable(),
  payment_token: z.string().nullable(),
  recurring_end_date: z.string().nullable(),
  recurring_frequency: publicInvoiceFrequencySchema.nullable(),
  recurring_start_date: z.string().nullable(),
  status: publicInvoiceStatusSchema,
  token_expires_at: z.string().nullable(),
  token_generated_at: z.string().nullable(),
  transaction_id: z.string().nullable(),
  updated_at: z.string(),
  user_id: z.string(),
});

export const publicDataSassInvoicesInsertSchemaSchema = z.object({
  additional_access_users: z.array(z.string()).optional().nullable(),
  amount: z.number(),
  created_at: z.string().optional(),
  description: z.string(),
  due_date: z.string(),
  id: z.string().optional(),
  invoice_number: z.string(),
  is_admin_subscription_creation: z.boolean().optional(),
  is_recurring: z.boolean().optional(),
  metadata: jsonSchema.optional(),
  parent_invoice_id: z.string().optional().nullable(),
  payment_processed_at: z.string().optional().nullable(),
  payment_token: z.string().optional().nullable(),
  recurring_end_date: z.string().optional().nullable(),
  recurring_frequency: publicInvoiceFrequencySchema.optional().nullable(),
  recurring_start_date: z.string().optional().nullable(),
  status: publicInvoiceStatusSchema.optional(),
  token_expires_at: z.string().optional().nullable(),
  token_generated_at: z.string().optional().nullable(),
  transaction_id: z.string().optional().nullable(),
  updated_at: z.string().optional(),
  user_id: z.string(),
});

export const publicDataSassInvoicesUpdateSchemaSchema = z.object({
  additional_access_users: z.array(z.string()).optional().nullable(),
  amount: z.number().optional(),
  created_at: z.string().optional(),
  description: z.string().optional(),
  due_date: z.string().optional(),
  id: z.string().optional(),
  invoice_number: z.string().optional(),
  is_admin_subscription_creation: z.boolean().optional(),
  is_recurring: z.boolean().optional(),
  metadata: jsonSchema.optional(),
  parent_invoice_id: z.string().optional().nullable(),
  payment_processed_at: z.string().optional().nullable(),
  payment_token: z.string().optional().nullable(),
  recurring_end_date: z.string().optional().nullable(),
  recurring_frequency: publicInvoiceFrequencySchema.optional().nullable(),
  recurring_start_date: z.string().optional().nullable(),
  status: publicInvoiceStatusSchema.optional(),
  token_expires_at: z.string().optional().nullable(),
  token_generated_at: z.string().optional().nullable(),
  transaction_id: z.string().optional().nullable(),
  updated_at: z.string().optional(),
  user_id: z.string().optional(),
});

export const publicDataSassInvoicesRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('data_sass_invoices_parent_invoice_id_fkey'),
    columns: z.tuple([z.literal('parent_invoice_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_invoices'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicDataSassLocationsRowSchemaSchema = z.object({
  auto_renew: z.boolean().nullable(),
  date_created: z.string().nullable(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  end_date: z.string().nullable(),
  fk_billing_charge_id: z.string().nullable(),
  fk_billing_history_id: z.number().nullable(),
  fk_invoice_id: z.string().nullable(),
  fk_listing_id: z.number().nullable(),
  fk_pricing_id: z.number().nullable(),
  fk_subscription_id: z.number(),
  id: z.number(),
  is_active: z.boolean().nullable(),
  metadata: jsonSchema.nullable(),
  start_date: z.string().nullable(),
  status: publicDataSassSubscriptionStatusSchema.nullable(),
  stripe_subscription_item_id: z.string().nullable(),
  unique_uid: z.string(),
});

export const publicDataSassLocationsInsertSchemaSchema = z.object({
  auto_renew: z.boolean().optional().nullable(),
  date_created: z.string().optional().nullable(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  end_date: z.string().optional().nullable(),
  fk_billing_charge_id: z.string().optional().nullable(),
  fk_billing_history_id: z.number().optional().nullable(),
  fk_invoice_id: z.string().optional().nullable(),
  fk_listing_id: z.number().optional().nullable(),
  fk_pricing_id: z.number().optional().nullable(),
  fk_subscription_id: z.number(),
  id: z.number().optional(),
  is_active: z.boolean().optional().nullable(),
  metadata: jsonSchema.optional().nullable(),
  start_date: z.string().optional().nullable(),
  status: publicDataSassSubscriptionStatusSchema.optional().nullable(),
  stripe_subscription_item_id: z.string().optional().nullable(),
  unique_uid: z.string().optional(),
});

export const publicDataSassLocationsUpdateSchemaSchema = z.object({
  auto_renew: z.boolean().optional().nullable(),
  date_created: z.string().optional().nullable(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  end_date: z.string().optional().nullable(),
  fk_billing_charge_id: z.string().optional().nullable(),
  fk_billing_history_id: z.number().optional().nullable(),
  fk_invoice_id: z.string().optional().nullable(),
  fk_listing_id: z.number().optional().nullable(),
  fk_pricing_id: z.number().optional().nullable(),
  fk_subscription_id: z.number().optional(),
  id: z.number().optional(),
  is_active: z.boolean().optional().nullable(),
  metadata: jsonSchema.optional().nullable(),
  start_date: z.string().optional().nullable(),
  status: publicDataSassSubscriptionStatusSchema.optional().nullable(),
  stripe_subscription_item_id: z.string().optional().nullable(),
  unique_uid: z.string().optional(),
});

export const publicDataSassLocationsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('data_sass_locations_fk_invoice_id_fkey'),
    columns: z.tuple([z.literal('fk_invoice_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_invoices'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_locations_fk_listing_id_fkey'),
    columns: z.tuple([z.literal('fk_listing_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Tnc_Listings'),
    referencedColumns: z.tuple([z.literal('tnc_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_locations_fk_pricing_id_fkey'),
    columns: z.tuple([z.literal('fk_pricing_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_pricing'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_locations_fk_subscription_id_fkey'),
    columns: z.tuple([z.literal('fk_subscription_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_subscriptions'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('fk_subscription_id_constraint'),
    columns: z.tuple([z.literal('fk_subscription_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_subscriptions'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicDataSassPricingRowSchemaSchema = z.object({
  amount: z.number(),
  currency: z.string().nullable(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  deprecated_at: z.string().nullable(),
  effective_date: z.string(),
  id: z.number(),
  is_active: z.boolean().nullable(),
  is_unique: z.boolean(),
  item_type: publicDataSassSubscriptionTypesSchema,
});

export const publicDataSassPricingInsertSchemaSchema = z.object({
  amount: z.number(),
  currency: z.string().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  deprecated_at: z.string().optional().nullable(),
  effective_date: z.string().optional(),
  id: z.number().optional(),
  is_active: z.boolean().optional().nullable(),
  is_unique: z.boolean().optional(),
  item_type: publicDataSassSubscriptionTypesSchema,
});

export const publicDataSassPricingUpdateSchemaSchema = z.object({
  amount: z.number().optional(),
  currency: z.string().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  deprecated_at: z.string().optional().nullable(),
  effective_date: z.string().optional(),
  id: z.number().optional(),
  is_active: z.boolean().optional().nullable(),
  is_unique: z.boolean().optional(),
  item_type: publicDataSassSubscriptionTypesSchema.optional(),
});

export const publicDataSassReferralCodesRowSchemaSchema = z.object({
  code: z.string(),
  date_created: z.string(),
  id: z.number(),
  is_active: z.boolean(),
});

export const publicDataSassReferralCodesInsertSchemaSchema = z.object({
  code: z.string(),
  date_created: z.string().optional(),
  id: z.number().optional(),
  is_active: z.boolean(),
});

export const publicDataSassReferralCodesUpdateSchemaSchema = z.object({
  code: z.string().optional(),
  date_created: z.string().optional(),
  id: z.number().optional(),
  is_active: z.boolean().optional(),
});

export const publicDataSassReferralsRowSchemaSchema = z.object({
  date_created: z.string(),
  fk_referral_code_id: z.number(),
  fk_referred_user_id: z.number().nullable(),
  id: z.number(),
});

export const publicDataSassReferralsInsertSchemaSchema = z.object({
  date_created: z.string().optional(),
  fk_referral_code_id: z.number(),
  fk_referred_user_id: z.number().optional().nullable(),
  id: z.number().optional(),
});

export const publicDataSassReferralsUpdateSchemaSchema = z.object({
  date_created: z.string().optional(),
  fk_referral_code_id: z.number().optional(),
  fk_referred_user_id: z.number().optional().nullable(),
  id: z.number().optional(),
});

export const publicDataSassReferralsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('data_sass_referrals_fk_referral_code_id_fkey'),
    columns: z.tuple([z.literal('fk_referral_code_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_referral_codes'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_referrals_fk_referred_user_id_fkey'),
    columns: z.tuple([z.literal('fk_referred_user_id')]),
    isOneToOne: z.literal(true),
    referencedRelation: z.literal('user_profiles'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicDataSassSeatsRowSchemaSchema = z.object({
  auto_renew: z.boolean().nullable(),
  can_make_purchases: z.boolean(),
  can_manage_integrations: z.boolean(),
  can_manage_locations: z.boolean(),
  can_manage_team: z.boolean(),
  can_view_analytics: z.boolean(),
  can_view_billing: z.boolean(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  email: z.string(),
  end_date: z.string().nullable(),
  fk_base_subscription_id: z.number(),
  fk_billing_charge_id: z.string().nullable(),
  fk_billing_history_id: z.number().nullable(),
  fk_invoice_id: z.string().nullable(),
  fk_owner_user_id: z.number(),
  fk_pricing_id: z.number().nullable(),
  fk_seat_user_id: z.number().nullable(),
  fk_subscription_id: z.number(),
  id: z.number(),
  invitation_status: z.string(),
  invitation_token: z.string(),
  is_active: z.boolean().nullable(),
  permissions: jsonSchema,
  permissions_updated_at: z.string().nullable(),
  permissions_updated_by: z.number().nullable(),
  role: publicSeatRoleSchema,
  start_date: z.string().nullable(),
  status: publicDataSassSubscriptionStatusSchema.nullable(),
  stripe_subscription_item_id: z.string().nullable(),
});

export const publicDataSassSeatsInsertSchemaSchema = z.object({
  auto_renew: z.boolean().optional().nullable(),
  can_make_purchases: z.boolean().optional(),
  can_manage_integrations: z.boolean().optional(),
  can_manage_locations: z.boolean().optional(),
  can_manage_team: z.boolean().optional(),
  can_view_analytics: z.boolean().optional(),
  can_view_billing: z.boolean().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  email: z.string(),
  end_date: z.string().optional().nullable(),
  fk_base_subscription_id: z.number(),
  fk_billing_charge_id: z.string().optional().nullable(),
  fk_billing_history_id: z.number().optional().nullable(),
  fk_invoice_id: z.string().optional().nullable(),
  fk_owner_user_id: z.number(),
  fk_pricing_id: z.number().optional().nullable(),
  fk_seat_user_id: z.number().optional().nullable(),
  fk_subscription_id: z.number(),
  id: z.number().optional(),
  invitation_status: z.string().optional(),
  invitation_token: z.string(),
  is_active: z.boolean().optional().nullable(),
  permissions: jsonSchema.optional(),
  permissions_updated_at: z.string().optional().nullable(),
  permissions_updated_by: z.number().optional().nullable(),
  role: publicSeatRoleSchema.optional(),
  start_date: z.string().optional().nullable(),
  status: publicDataSassSubscriptionStatusSchema.optional().nullable(),
  stripe_subscription_item_id: z.string().optional().nullable(),
});

export const publicDataSassSeatsUpdateSchemaSchema = z.object({
  auto_renew: z.boolean().optional().nullable(),
  can_make_purchases: z.boolean().optional(),
  can_manage_integrations: z.boolean().optional(),
  can_manage_locations: z.boolean().optional(),
  can_manage_team: z.boolean().optional(),
  can_view_analytics: z.boolean().optional(),
  can_view_billing: z.boolean().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  email: z.string().optional(),
  end_date: z.string().optional().nullable(),
  fk_base_subscription_id: z.number().optional(),
  fk_billing_charge_id: z.string().optional().nullable(),
  fk_billing_history_id: z.number().optional().nullable(),
  fk_invoice_id: z.string().optional().nullable(),
  fk_owner_user_id: z.number().optional(),
  fk_pricing_id: z.number().optional().nullable(),
  fk_seat_user_id: z.number().optional().nullable(),
  fk_subscription_id: z.number().optional(),
  id: z.number().optional(),
  invitation_status: z.string().optional(),
  invitation_token: z.string().optional(),
  is_active: z.boolean().optional().nullable(),
  permissions: jsonSchema.optional(),
  permissions_updated_at: z.string().optional().nullable(),
  permissions_updated_by: z.number().optional().nullable(),
  role: publicSeatRoleSchema.optional(),
  start_date: z.string().optional().nullable(),
  status: publicDataSassSubscriptionStatusSchema.optional().nullable(),
  stripe_subscription_item_id: z.string().optional().nullable(),
});

export const publicDataSassSeatsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('data_sass_seats_fk_base_subscription_id_fkey'),
    columns: z.tuple([z.literal('fk_base_subscription_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_subscriptions'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_seats_fk_invoice_id_fkey'),
    columns: z.tuple([z.literal('fk_invoice_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_invoices'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_seats_fk_owner_user_id_fkey'),
    columns: z.tuple([z.literal('fk_owner_user_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_profiles'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_seats_fk_pricing_id_fkey'),
    columns: z.tuple([z.literal('fk_pricing_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_pricing'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_seats_fk_pricing_id_fkey1'),
    columns: z.tuple([z.literal('fk_pricing_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_pricing'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_seats_fk_seat_user_id_fkey'),
    columns: z.tuple([z.literal('fk_seat_user_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_profiles'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_seats_fk_subscription_id_fkey'),
    columns: z.tuple([z.literal('fk_subscription_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_subscriptions'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_seats_permissions_updated_by_fkey'),
    columns: z.tuple([z.literal('permissions_updated_by')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_profiles'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicDataSassSubscriptionsRowSchemaSchema = z.object({
  adn_subscription_id: z.string().nullable(),
  auto_renew: z.boolean().nullable(),
  avatar_url: z.string().nullable(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  end_date: z.string(),
  fk_billing_charge_id: z.string().nullable(),
  fk_billing_history_id: z.number().nullable(),
  fk_invoice_id: z.string().nullable(),
  fk_pricing_id: z.number().nullable(),
  fk_user_profile_id: z.number(),
  id: z.number(),
  is_active: z.boolean().nullable(),
  is_trial: z.boolean(),
  kibana_space_id: z.string().nullable(),
  parent_subscription_id: z.number().nullable(),
  renewal_anchor_date: z.string().nullable(),
  start_date: z.string(),
  status: publicDataSassSubscriptionStatusSchema,
  trial_end_date: z.string().nullable(),
  trial_metadata: jsonSchema.nullable(),
  visible_space_name: z.string().nullable(),
});

export const publicDataSassSubscriptionsInsertSchemaSchema = z.object({
  adn_subscription_id: z.string().optional().nullable(),
  auto_renew: z.boolean().optional().nullable(),
  avatar_url: z.string().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  end_date: z.string(),
  fk_billing_charge_id: z.string().optional().nullable(),
  fk_billing_history_id: z.number().optional().nullable(),
  fk_invoice_id: z.string().optional().nullable(),
  fk_pricing_id: z.number().optional().nullable(),
  fk_user_profile_id: z.number(),
  id: z.number().optional(),
  is_active: z.boolean().optional().nullable(),
  is_trial: z.boolean().optional(),
  kibana_space_id: z.string().optional().nullable(),
  parent_subscription_id: z.number().optional().nullable(),
  renewal_anchor_date: z.string().optional().nullable(),
  start_date: z.string(),
  status: publicDataSassSubscriptionStatusSchema,
  trial_end_date: z.string().optional().nullable(),
  trial_metadata: jsonSchema.optional().nullable(),
  visible_space_name: z.string().optional().nullable(),
});

export const publicDataSassSubscriptionsUpdateSchemaSchema = z.object({
  adn_subscription_id: z.string().optional().nullable(),
  auto_renew: z.boolean().optional().nullable(),
  avatar_url: z.string().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  end_date: z.string().optional(),
  fk_billing_charge_id: z.string().optional().nullable(),
  fk_billing_history_id: z.number().optional().nullable(),
  fk_invoice_id: z.string().optional().nullable(),
  fk_pricing_id: z.number().optional().nullable(),
  fk_user_profile_id: z.number().optional(),
  id: z.number().optional(),
  is_active: z.boolean().optional().nullable(),
  is_trial: z.boolean().optional(),
  kibana_space_id: z.string().optional().nullable(),
  parent_subscription_id: z.number().optional().nullable(),
  renewal_anchor_date: z.string().optional().nullable(),
  start_date: z.string().optional(),
  status: publicDataSassSubscriptionStatusSchema.optional(),
  trial_end_date: z.string().optional().nullable(),
  trial_metadata: jsonSchema.optional().nullable(),
  visible_space_name: z.string().optional().nullable(),
});

export const publicDataSassSubscriptionsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('data_sass_subscriptions_fk_invoice_id_fkey'),
    columns: z.tuple([z.literal('fk_invoice_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_invoices'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_subscriptions_fk_pricing_id_fkey'),
    columns: z.tuple([z.literal('fk_pricing_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_pricing'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_subscriptions_fk_user_profile_id_fkey'),
    columns: z.tuple([z.literal('fk_user_profile_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_profiles'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('data_sass_subscriptions_parent_subscription_id_fkey'),
    columns: z.tuple([z.literal('parent_subscription_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_subscriptions'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicDistributorRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  distributor_address: z.string(),
  distributor_address2: z.string().nullable(),
  distributor_city: z.string(),
  distributor_email: z.string(),
  distributor_geo_points: jsonSchema,
  distributor_id: z.number(),
  distributor_license_number: z.string(),
  distributor_metrc_api_key: z.string(),
  distributor_name: z.string(),
  distributor_phone: z.string(),
  distributor_postal_code: z.string(),
  distributor_state: z.string(),
  distributor_status: publicApplicationStatusEnumSchema,
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
});

export const publicDistributorInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  distributor_address: z.string(),
  distributor_address2: z.string().optional().nullable(),
  distributor_city: z.string(),
  distributor_email: z.string(),
  distributor_geo_points: jsonSchema,
  distributor_id: z.number().optional(),
  distributor_license_number: z.string(),
  distributor_metrc_api_key: z.string(),
  distributor_name: z.string(),
  distributor_phone: z.string(),
  distributor_postal_code: z.string(),
  distributor_state: z.string(),
  distributor_status: publicApplicationStatusEnumSchema.optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicDistributorUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  distributor_address: z.string().optional(),
  distributor_address2: z.string().optional().nullable(),
  distributor_city: z.string().optional(),
  distributor_email: z.string().optional(),
  distributor_geo_points: jsonSchema.optional(),
  distributor_id: z.number().optional(),
  distributor_license_number: z.string().optional(),
  distributor_metrc_api_key: z.string().optional(),
  distributor_name: z.string().optional(),
  distributor_phone: z.string().optional(),
  distributor_postal_code: z.string().optional(),
  distributor_state: z.string().optional(),
  distributor_status: publicApplicationStatusEnumSchema.optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicDistributorBrandRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  distributor_brand_id: z.number(),
  fk_brand_id: z.number(),
  fk_distributor_id: z.number(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
});

export const publicDistributorBrandInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  distributor_brand_id: z.number().optional(),
  fk_brand_id: z.number(),
  fk_distributor_id: z.number(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicDistributorBrandUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  distributor_brand_id: z.number().optional(),
  fk_brand_id: z.number().optional(),
  fk_distributor_id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicDistributorBrandRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Distributor_Brand_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Brand'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Distributor_Brand_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('brand_market_info'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Distributor_Brand_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Distributor_Brand_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Distributor_Brand_fk_distributor_id_fkey'),
    columns: z.tuple([z.literal('fk_distributor_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Distributor'),
    referencedColumns: z.tuple([z.literal('distributor_id')]),
  }),
]);

export const publicDutchieBrandRowSchemaSchema = z.object({
  brand_name: z.string(),
  dutchie_brand_id: z.number(),
  retailer_id: z.number(),
});

export const publicDutchieBrandInsertSchemaSchema = z.object({
  brand_name: z.string(),
  dutchie_brand_id: z.number().optional(),
  retailer_id: z.number(),
});

export const publicDutchieBrandUpdateSchemaSchema = z.object({
  brand_name: z.string().optional(),
  dutchie_brand_id: z.number().optional(),
  retailer_id: z.number().optional(),
});

export const publicDutchieBrandRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Dutchie_Brand_retailer_id_fkey'),
    columns: z.tuple([z.literal('retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Retailer'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Dutchie_Brand_retailer_id_fkey'),
    columns: z.tuple([z.literal('retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
]);

export const publicDutchieCustomerRowSchemaSchema = z.object({
  address_1: z.string(),
  address_2: z.string(),
  cell_phone: z.string(),
  city: z.string(),
  created_at_location: z.string(),
  created_by_integrator: z.string(),
  creation_date: z.string(),
  custom_identifier: z.string(),
  customer_type: z.string(),
  date_of_birth: z.string(),
  discount_groups: z.string(),
  drivers_license_hash: z.string(),
  dutchie_customer_id: z.number(),
  email_address: z.string(),
  external_customer_id: z.string(),
  first_name: z.string(),
  gender: z.string(),
  is_anonymous: z.string(),
  is_loyalty_member: z.string(),
  last_modified_date_utc: z.string(),
  last_name: z.string(),
  merged_into_customer_id: z.number().nullable(),
  middle_name: z.string(),
  mmjid_expiration_date: z.string().nullable(),
  mmjid_numbertext: z.string(),
  name: z.string(),
  name_prefix: z.string(),
  name_suffix: z.string(),
  notes: z.string(),
  other_referral_source: z.string(),
  phone: z.string(),
  postal_code: z.string(),
  primary_qualifying_condition: z.string(),
  referral_source: z.string(),
  retailer_id: z.string(),
  secondary_qualifying_conditions: z.string(),
  spring_big_member_id: z.string(),
  state: z.string(),
  status: z.string(),
});

export const publicDutchieCustomerInsertSchemaSchema = z.object({
  address_1: z.string(),
  address_2: z.string(),
  cell_phone: z.string(),
  city: z.string(),
  created_at_location: z.string(),
  created_by_integrator: z.string(),
  creation_date: z.string(),
  custom_identifier: z.string(),
  customer_type: z.string(),
  date_of_birth: z.string(),
  discount_groups: z.string(),
  drivers_license_hash: z.string(),
  dutchie_customer_id: z.number().optional(),
  email_address: z.string(),
  external_customer_id: z.string(),
  first_name: z.string(),
  gender: z.string(),
  is_anonymous: z.string(),
  is_loyalty_member: z.string(),
  last_modified_date_utc: z.string(),
  last_name: z.string(),
  merged_into_customer_id: z.number().optional().nullable(),
  middle_name: z.string(),
  mmjid_expiration_date: z.string().optional().nullable(),
  mmjid_numbertext: z.string(),
  name: z.string(),
  name_prefix: z.string(),
  name_suffix: z.string(),
  notes: z.string(),
  other_referral_source: z.string(),
  phone: z.string(),
  postal_code: z.string(),
  primary_qualifying_condition: z.string(),
  referral_source: z.string(),
  retailer_id: z.string(),
  secondary_qualifying_conditions: z.string(),
  spring_big_member_id: z.string(),
  state: z.string(),
  status: z.string(),
});

export const publicDutchieCustomerUpdateSchemaSchema = z.object({
  address_1: z.string().optional(),
  address_2: z.string().optional(),
  cell_phone: z.string().optional(),
  city: z.string().optional(),
  created_at_location: z.string().optional(),
  created_by_integrator: z.string().optional(),
  creation_date: z.string().optional(),
  custom_identifier: z.string().optional(),
  customer_type: z.string().optional(),
  date_of_birth: z.string().optional(),
  discount_groups: z.string().optional(),
  drivers_license_hash: z.string().optional(),
  dutchie_customer_id: z.number().optional(),
  email_address: z.string().optional(),
  external_customer_id: z.string().optional(),
  first_name: z.string().optional(),
  gender: z.string().optional(),
  is_anonymous: z.string().optional(),
  is_loyalty_member: z.string().optional(),
  last_modified_date_utc: z.string().optional(),
  last_name: z.string().optional(),
  merged_into_customer_id: z.number().optional().nullable(),
  middle_name: z.string().optional(),
  mmjid_expiration_date: z.string().optional().nullable(),
  mmjid_numbertext: z.string().optional(),
  name: z.string().optional(),
  name_prefix: z.string().optional(),
  name_suffix: z.string().optional(),
  notes: z.string().optional(),
  other_referral_source: z.string().optional(),
  phone: z.string().optional(),
  postal_code: z.string().optional(),
  primary_qualifying_condition: z.string().optional(),
  referral_source: z.string().optional(),
  retailer_id: z.string().optional(),
  secondary_qualifying_conditions: z.string().optional(),
  spring_big_member_id: z.string().optional(),
  state: z.string().optional(),
  status: z.string().optional(),
});

export const publicDutchieDutchieListingsRowSchemaSchema = z.object({
  created_at: z.string().nullable(),
  document: jsonSchema,
  id: z.string(),
  row_id: z.number(),
  updated_at: z.string().nullable(),
});

export const publicDutchieDutchieListingsInsertSchemaSchema = z.object({
  created_at: z.string().optional().nullable(),
  document: jsonSchema,
  id: z.string(),
  row_id: z.number().optional(),
  updated_at: z.string().optional().nullable(),
});

export const publicDutchieDutchieListingsUpdateSchemaSchema = z.object({
  created_at: z.string().optional().nullable(),
  document: jsonSchema.optional(),
  id: z.string().optional(),
  row_id: z.number().optional(),
  updated_at: z.string().optional().nullable(),
});

export const publicDutchieInventoryTransactionRowSchemaSchema = z.object({
  batch_id: z.number().nullable(),
  batch_name: z.string().nullable(),
  conversion_transaction_id: z.number().nullable(),
  external_package_id: z.string().nullable(),
  from_location: z.string().nullable(),
  from_quantity: z.number().nullable(),
  from_room: z.string().nullable(),
  inventory_id: z.number().nullable(),
  inventory_transaction_id: z.number(),
  package_id: z.string().nullable(),
  product: z.string().nullable(),
  product_id: z.number().nullable(),
  purchase_order_id: z.number().nullable(),
  quantity: z.number().nullable(),
  reason: z.string().nullable(),
  receive_inventory_history_id: z.number().nullable(),
  retailer_id: z.string().nullable(),
  sku: z.string().nullable(),
  to_location: z.string().nullable(),
  to_quantity: z.number().nullable(),
  to_room: z.string().nullable(),
  transaction_by: z.string().nullable(),
  transaction_date: z.string().nullable(),
  transaction_type: z.string().nullable(),
  unit: z.string().nullable(),
  unit_cost: z.number().nullable(),
});

export const publicDutchieInventoryTransactionInsertSchemaSchema = z.object({
  batch_id: z.number().optional().nullable(),
  batch_name: z.string().optional().nullable(),
  conversion_transaction_id: z.number().optional().nullable(),
  external_package_id: z.string().optional().nullable(),
  from_location: z.string().optional().nullable(),
  from_quantity: z.number().optional().nullable(),
  from_room: z.string().optional().nullable(),
  inventory_id: z.number().optional().nullable(),
  inventory_transaction_id: z.number(),
  package_id: z.string().optional().nullable(),
  product: z.string().optional().nullable(),
  product_id: z.number().optional().nullable(),
  purchase_order_id: z.number().optional().nullable(),
  quantity: z.number().optional().nullable(),
  reason: z.string().optional().nullable(),
  receive_inventory_history_id: z.number().optional().nullable(),
  retailer_id: z.string().optional().nullable(),
  sku: z.string().optional().nullable(),
  to_location: z.string().optional().nullable(),
  to_quantity: z.number().optional().nullable(),
  to_room: z.string().optional().nullable(),
  transaction_by: z.string().optional().nullable(),
  transaction_date: z.string().optional().nullable(),
  transaction_type: z.string().optional().nullable(),
  unit: z.string().optional().nullable(),
  unit_cost: z.number().optional().nullable(),
});

export const publicDutchieInventoryTransactionUpdateSchemaSchema = z.object({
  batch_id: z.number().optional().nullable(),
  batch_name: z.string().optional().nullable(),
  conversion_transaction_id: z.number().optional().nullable(),
  external_package_id: z.string().optional().nullable(),
  from_location: z.string().optional().nullable(),
  from_quantity: z.number().optional().nullable(),
  from_room: z.string().optional().nullable(),
  inventory_id: z.number().optional().nullable(),
  inventory_transaction_id: z.number().optional(),
  package_id: z.string().optional().nullable(),
  product: z.string().optional().nullable(),
  product_id: z.number().optional().nullable(),
  purchase_order_id: z.number().optional().nullable(),
  quantity: z.number().optional().nullable(),
  reason: z.string().optional().nullable(),
  receive_inventory_history_id: z.number().optional().nullable(),
  retailer_id: z.string().optional().nullable(),
  sku: z.string().optional().nullable(),
  to_location: z.string().optional().nullable(),
  to_quantity: z.number().optional().nullable(),
  to_room: z.string().optional().nullable(),
  transaction_by: z.string().optional().nullable(),
  transaction_date: z.string().optional().nullable(),
  transaction_type: z.string().optional().nullable(),
  unit: z.string().optional().nullable(),
  unit_cost: z.number().optional().nullable(),
});

export const publicDutchieNormalizedListingsRowSchemaSchema = z.object({
  address_ln1: z.string().nullable(),
  address_ln2: z.string().nullable(),
  city: z.string().nullable(),
  cname: z.string().nullable(),
  country: z.string().nullable(),
  county: z.string().nullable(),
  delivery_hours: jsonSchema.nullable(),
  dispensary_id: z.string().nullable(),
  geog: z.unknown().nullable(),
  last_processed_at: z.string(),
  latitude: z.number().nullable(),
  list_image_url: z.string().nullable(),
  longitude: z.number().nullable(),
  med_dispensary: z.boolean().nullable(),
  name: z.string().nullable(),
  offer_delivery: z.boolean().nullable(),
  offer_pickup: z.boolean().nullable(),
  payment_types_accepted: jsonSchema.nullable(),
  pickup_hours: jsonSchema.nullable(),
  raw_created_at: z.string().nullable(),
  raw_updated_at: z.string().nullable(),
  rec_dispensary: z.boolean().nullable(),
  row_id: z.number(),
  source_id: z.string(),
  state: z.string().nullable(),
  status: z.string().nullable(),
  timezone: z.string().nullable(),
  zipcode: z.string().nullable(),
});

export const publicDutchieNormalizedListingsInsertSchemaSchema = z.object({
  address_ln1: z.string().optional().nullable(),
  address_ln2: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  cname: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  county: z.string().optional().nullable(),
  delivery_hours: jsonSchema.optional().nullable(),
  dispensary_id: z.string().optional().nullable(),
  geog: z.unknown().optional().nullable(),
  last_processed_at: z.string().optional(),
  latitude: z.number().optional().nullable(),
  list_image_url: z.string().optional().nullable(),
  longitude: z.number().optional().nullable(),
  med_dispensary: z.boolean().optional().nullable(),
  name: z.string().optional().nullable(),
  offer_delivery: z.boolean().optional().nullable(),
  offer_pickup: z.boolean().optional().nullable(),
  payment_types_accepted: jsonSchema.optional().nullable(),
  pickup_hours: jsonSchema.optional().nullable(),
  raw_created_at: z.string().optional().nullable(),
  raw_updated_at: z.string().optional().nullable(),
  rec_dispensary: z.boolean().optional().nullable(),
  row_id: z.number(),
  source_id: z.string(),
  state: z.string().optional().nullable(),
  status: z.string().optional().nullable(),
  timezone: z.string().optional().nullable(),
  zipcode: z.string().optional().nullable(),
});

export const publicDutchieNormalizedListingsUpdateSchemaSchema = z.object({
  address_ln1: z.string().optional().nullable(),
  address_ln2: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  cname: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  county: z.string().optional().nullable(),
  delivery_hours: jsonSchema.optional().nullable(),
  dispensary_id: z.string().optional().nullable(),
  geog: z.unknown().optional().nullable(),
  last_processed_at: z.string().optional(),
  latitude: z.number().optional().nullable(),
  list_image_url: z.string().optional().nullable(),
  longitude: z.number().optional().nullable(),
  med_dispensary: z.boolean().optional().nullable(),
  name: z.string().optional().nullable(),
  offer_delivery: z.boolean().optional().nullable(),
  offer_pickup: z.boolean().optional().nullable(),
  payment_types_accepted: jsonSchema.optional().nullable(),
  pickup_hours: jsonSchema.optional().nullable(),
  raw_created_at: z.string().optional().nullable(),
  raw_updated_at: z.string().optional().nullable(),
  rec_dispensary: z.boolean().optional().nullable(),
  row_id: z.number().optional(),
  source_id: z.string().optional(),
  state: z.string().optional().nullable(),
  status: z.string().optional().nullable(),
  timezone: z.string().optional().nullable(),
  zipcode: z.string().optional().nullable(),
});

export const publicDutchieProductRowSchemaSchema = z.object({
  abbreviation: z.string().nullable(),
  administration_method: z.string().nullable(),
  allergens: z.string().nullable(),
  allow_automatic_discounts: z.boolean().nullable(),
  alternate_name: z.string().nullable(),
  approval_date_utc: z.string().nullable(),
  brand_id: z.number().nullable(),
  brand_name: z.string().nullable(),
  category: z.string().nullable(),
  category_id: z.number().nullable(),
  cbd_content: z.number().nullable(),
  cbd_content_unit: z.string().nullable(),
  created_date: z.string().nullable(),
  days_supply: z.number().nullable(),
  default_unit: z.string().nullable(),
  description: z.string().nullable(),
  distillation_name: z.string().nullable(),
  dosage: z.string().nullable(),
  expiration_days: z.number().nullable(),
  external_category: z.string().nullable(),
  flavor: z.string().nullable(),
  flower_equivalent: z.number().nullable(),
  gross_weight: z.number().nullable(),
  id: z.number(),
  illinois_tax_category: z.string().nullable(),
  image_url: z.string().nullable(),
  image_urls: z.array(z.string()).nullable(),
  ingredient_list: z.string().nullable(),
  instructions: z.string().nullable(),
  internal_name: z.string().nullable(),
  is_active: z.boolean().nullable(),
  is_cannabis: z.boolean().nullable(),
  is_coupon: z.boolean().nullable(),
  is_finished: z.boolean().nullable(),
  is_medical_only: z.boolean().nullable(),
  is_nutrient: z.boolean().nullable(),
  is_taxable: z.boolean().nullable(),
  is_test_product: z.boolean().nullable(),
  last_modified_date_utc: z.string().nullable(),
  lineage_name: z.string().nullable(),
  low_inventory_threshold: z.number().nullable(),
  master_category: z.string().nullable(),
  max_purchaseable_per_transaction: z.number().nullable(),
  med_price: z.number().nullable(),
  ndc: z.string().nullable(),
  net_weight: z.number().nullable(),
  net_weight_unit: z.string().nullable(),
  net_weight_unit_id: z.number().nullable(),
  oil_volume: z.number().nullable(),
  online_available: z.boolean().nullable(),
  online_description: z.string().nullable(),
  online_product: z.boolean().nullable(),
  online_title: z.string().nullable(),
  pos_products: z.boolean().nullable(),
  price: z.number().nullable(),
  pricing_tier: z.number().nullable(),
  pricing_tier_description: z.string().nullable(),
  pricing_tier_name: z.string().nullable(),
  producer_id: z.number().nullable(),
  producer_name: z.string().nullable(),
  product_grams: z.number().nullable(),
  product_id: z.number(),
  product_name: z.string().nullable(),
  rec_flower_equivalent: z.number().nullable(),
  rec_price: z.number().nullable(),
  regulatory_category: z.string().nullable(),
  regulatory_name: z.string().nullable(),
  retailer_id: z.string().nullable(),
  serving_size: z.string().nullable(),
  serving_size_per_unit: z.number().nullable(),
  size: z.string().nullable(),
  sku: z.string().nullable(),
  strain: z.string().nullable(),
  strain_id: z.number().nullable(),
  strain_type: z.string().nullable(),
  sync_externally: z.boolean().nullable(),
  tax_categories: z.array(z.string()).nullable(),
  thc_content: z.number().nullable(),
  thc_content_unit: z.string().nullable(),
  unit_cbd_content_dose: z.number().nullable(),
  unit_cost: z.number().nullable(),
  unit_thc_content_dose: z.number().nullable(),
  unit_type: z.string().nullable(),
  upc: z.string().nullable(),
  vendor_id: z.number().nullable(),
  vendor_name: z.string().nullable(),
});

export const publicDutchieProductInsertSchemaSchema = z.object({
  abbreviation: z.string().optional().nullable(),
  administration_method: z.string().optional().nullable(),
  allergens: z.string().optional().nullable(),
  allow_automatic_discounts: z.boolean().optional().nullable(),
  alternate_name: z.string().optional().nullable(),
  approval_date_utc: z.string().optional().nullable(),
  brand_id: z.number().optional().nullable(),
  brand_name: z.string().optional().nullable(),
  category: z.string().optional().nullable(),
  category_id: z.number().optional().nullable(),
  cbd_content: z.number().optional().nullable(),
  cbd_content_unit: z.string().optional().nullable(),
  created_date: z.string().optional().nullable(),
  days_supply: z.number().optional().nullable(),
  default_unit: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  distillation_name: z.string().optional().nullable(),
  dosage: z.string().optional().nullable(),
  expiration_days: z.number().optional().nullable(),
  external_category: z.string().optional().nullable(),
  flavor: z.string().optional().nullable(),
  flower_equivalent: z.number().optional().nullable(),
  gross_weight: z.number().optional().nullable(),
  id: z.number().optional(),
  illinois_tax_category: z.string().optional().nullable(),
  image_url: z.string().optional().nullable(),
  image_urls: z.array(z.string()).optional().nullable(),
  ingredient_list: z.string().optional().nullable(),
  instructions: z.string().optional().nullable(),
  internal_name: z.string().optional().nullable(),
  is_active: z.boolean().optional().nullable(),
  is_cannabis: z.boolean().optional().nullable(),
  is_coupon: z.boolean().optional().nullable(),
  is_finished: z.boolean().optional().nullable(),
  is_medical_only: z.boolean().optional().nullable(),
  is_nutrient: z.boolean().optional().nullable(),
  is_taxable: z.boolean().optional().nullable(),
  is_test_product: z.boolean().optional().nullable(),
  last_modified_date_utc: z.string().optional().nullable(),
  lineage_name: z.string().optional().nullable(),
  low_inventory_threshold: z.number().optional().nullable(),
  master_category: z.string().optional().nullable(),
  max_purchaseable_per_transaction: z.number().optional().nullable(),
  med_price: z.number().optional().nullable(),
  ndc: z.string().optional().nullable(),
  net_weight: z.number().optional().nullable(),
  net_weight_unit: z.string().optional().nullable(),
  net_weight_unit_id: z.number().optional().nullable(),
  oil_volume: z.number().optional().nullable(),
  online_available: z.boolean().optional().nullable(),
  online_description: z.string().optional().nullable(),
  online_product: z.boolean().optional().nullable(),
  online_title: z.string().optional().nullable(),
  pos_products: z.boolean().optional().nullable(),
  price: z.number().optional().nullable(),
  pricing_tier: z.number().optional().nullable(),
  pricing_tier_description: z.string().optional().nullable(),
  pricing_tier_name: z.string().optional().nullable(),
  producer_id: z.number().optional().nullable(),
  producer_name: z.string().optional().nullable(),
  product_grams: z.number().optional().nullable(),
  product_id: z.number(),
  product_name: z.string().optional().nullable(),
  rec_flower_equivalent: z.number().optional().nullable(),
  rec_price: z.number().optional().nullable(),
  regulatory_category: z.string().optional().nullable(),
  regulatory_name: z.string().optional().nullable(),
  retailer_id: z.string().optional().nullable(),
  serving_size: z.string().optional().nullable(),
  serving_size_per_unit: z.number().optional().nullable(),
  size: z.string().optional().nullable(),
  sku: z.string().optional().nullable(),
  strain: z.string().optional().nullable(),
  strain_id: z.number().optional().nullable(),
  strain_type: z.string().optional().nullable(),
  sync_externally: z.boolean().optional().nullable(),
  tax_categories: z.array(z.string()).optional().nullable(),
  thc_content: z.number().optional().nullable(),
  thc_content_unit: z.string().optional().nullable(),
  unit_cbd_content_dose: z.number().optional().nullable(),
  unit_cost: z.number().optional().nullable(),
  unit_thc_content_dose: z.number().optional().nullable(),
  unit_type: z.string().optional().nullable(),
  upc: z.string().optional().nullable(),
  vendor_id: z.number().optional().nullable(),
  vendor_name: z.string().optional().nullable(),
});

export const publicDutchieProductUpdateSchemaSchema = z.object({
  abbreviation: z.string().optional().nullable(),
  administration_method: z.string().optional().nullable(),
  allergens: z.string().optional().nullable(),
  allow_automatic_discounts: z.boolean().optional().nullable(),
  alternate_name: z.string().optional().nullable(),
  approval_date_utc: z.string().optional().nullable(),
  brand_id: z.number().optional().nullable(),
  brand_name: z.string().optional().nullable(),
  category: z.string().optional().nullable(),
  category_id: z.number().optional().nullable(),
  cbd_content: z.number().optional().nullable(),
  cbd_content_unit: z.string().optional().nullable(),
  created_date: z.string().optional().nullable(),
  days_supply: z.number().optional().nullable(),
  default_unit: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  distillation_name: z.string().optional().nullable(),
  dosage: z.string().optional().nullable(),
  expiration_days: z.number().optional().nullable(),
  external_category: z.string().optional().nullable(),
  flavor: z.string().optional().nullable(),
  flower_equivalent: z.number().optional().nullable(),
  gross_weight: z.number().optional().nullable(),
  id: z.number().optional(),
  illinois_tax_category: z.string().optional().nullable(),
  image_url: z.string().optional().nullable(),
  image_urls: z.array(z.string()).optional().nullable(),
  ingredient_list: z.string().optional().nullable(),
  instructions: z.string().optional().nullable(),
  internal_name: z.string().optional().nullable(),
  is_active: z.boolean().optional().nullable(),
  is_cannabis: z.boolean().optional().nullable(),
  is_coupon: z.boolean().optional().nullable(),
  is_finished: z.boolean().optional().nullable(),
  is_medical_only: z.boolean().optional().nullable(),
  is_nutrient: z.boolean().optional().nullable(),
  is_taxable: z.boolean().optional().nullable(),
  is_test_product: z.boolean().optional().nullable(),
  last_modified_date_utc: z.string().optional().nullable(),
  lineage_name: z.string().optional().nullable(),
  low_inventory_threshold: z.number().optional().nullable(),
  master_category: z.string().optional().nullable(),
  max_purchaseable_per_transaction: z.number().optional().nullable(),
  med_price: z.number().optional().nullable(),
  ndc: z.string().optional().nullable(),
  net_weight: z.number().optional().nullable(),
  net_weight_unit: z.string().optional().nullable(),
  net_weight_unit_id: z.number().optional().nullable(),
  oil_volume: z.number().optional().nullable(),
  online_available: z.boolean().optional().nullable(),
  online_description: z.string().optional().nullable(),
  online_product: z.boolean().optional().nullable(),
  online_title: z.string().optional().nullable(),
  pos_products: z.boolean().optional().nullable(),
  price: z.number().optional().nullable(),
  pricing_tier: z.number().optional().nullable(),
  pricing_tier_description: z.string().optional().nullable(),
  pricing_tier_name: z.string().optional().nullable(),
  producer_id: z.number().optional().nullable(),
  producer_name: z.string().optional().nullable(),
  product_grams: z.number().optional().nullable(),
  product_id: z.number().optional(),
  product_name: z.string().optional().nullable(),
  rec_flower_equivalent: z.number().optional().nullable(),
  rec_price: z.number().optional().nullable(),
  regulatory_category: z.string().optional().nullable(),
  regulatory_name: z.string().optional().nullable(),
  retailer_id: z.string().optional().nullable(),
  serving_size: z.string().optional().nullable(),
  serving_size_per_unit: z.number().optional().nullable(),
  size: z.string().optional().nullable(),
  sku: z.string().optional().nullable(),
  strain: z.string().optional().nullable(),
  strain_id: z.number().optional().nullable(),
  strain_type: z.string().optional().nullable(),
  sync_externally: z.boolean().optional().nullable(),
  tax_categories: z.array(z.string()).optional().nullable(),
  thc_content: z.number().optional().nullable(),
  thc_content_unit: z.string().optional().nullable(),
  unit_cbd_content_dose: z.number().optional().nullable(),
  unit_cost: z.number().optional().nullable(),
  unit_thc_content_dose: z.number().optional().nullable(),
  unit_type: z.string().optional().nullable(),
  upc: z.string().optional().nullable(),
  vendor_id: z.number().optional().nullable(),
  vendor_name: z.string().optional().nullable(),
});

export const publicDutchieProductRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Dutchie_Product_brandId_fkey'),
    columns: z.tuple([z.literal('brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Dutchie_Brand'),
    referencedColumns: z.tuple([z.literal('dutchie_brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Dutchie_Product_categoryId_fkey'),
    columns: z.tuple([z.literal('category_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Dutchie_Product_Category'),
    referencedColumns: z.tuple([z.literal('product_category_id')]),
  }),
]);

export const publicDutchieProductCategoryRowSchemaSchema = z.object({
  dutchie_product_category_id: z.number(),
  master_category: z.string(),
  product_category_id: z.number(),
  product_category_name: z.string(),
  retailer_id: z.number(),
});

export const publicDutchieProductCategoryInsertSchemaSchema = z.object({
  dutchie_product_category_id: z.number().optional(),
  master_category: z.string(),
  product_category_id: z.number(),
  product_category_name: z.string(),
  retailer_id: z.number(),
});

export const publicDutchieProductCategoryUpdateSchemaSchema = z.object({
  dutchie_product_category_id: z.number().optional(),
  master_category: z.string().optional(),
  product_category_id: z.number().optional(),
  product_category_name: z.string().optional(),
  retailer_id: z.number().optional(),
});

export const publicDutchieProductCategoryRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Dutchie_Product_Category_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Retailer'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Dutchie_Product_Category_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
]);

export const publicDutchieStrainRowSchemaSchema = z.object({
  dutchie_strain_id: z.number(),
  external_id: z.string(),
  retailer_id: z.number(),
  strain_abbreviation: z.string(),
  strain_description: z.string(),
  strain_id: z.number(),
  strain_name: z.string(),
  strain_type: z.string(),
});

export const publicDutchieStrainInsertSchemaSchema = z.object({
  dutchie_strain_id: z.number().optional(),
  external_id: z.string(),
  retailer_id: z.number(),
  strain_abbreviation: z.string(),
  strain_description: z.string(),
  strain_id: z.number(),
  strain_name: z.string(),
  strain_type: z.string(),
});

export const publicDutchieStrainUpdateSchemaSchema = z.object({
  dutchie_strain_id: z.number().optional(),
  external_id: z.string().optional(),
  retailer_id: z.number().optional(),
  strain_abbreviation: z.string().optional(),
  strain_description: z.string().optional(),
  strain_id: z.number().optional(),
  strain_name: z.string().optional(),
  strain_type: z.string().optional(),
});

export const publicDutchieStrainRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Dutchie_Strain_retailer_id_fkey'),
    columns: z.tuple([z.literal('retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Retailer'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Dutchie_Strain_retailer_id_fkey'),
    columns: z.tuple([z.literal('retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
]);

export const publicDutchieTransactionRowSchemaSchema = z.object({
  adjustment_for_transaction_id: z.number().nullable(),
  auth_code: z.string().nullable(),
  cash_paid: z.number(),
  change_due: z.number(),
  check_in_date: z.string(),
  check_paid: z.number().nullable(),
  completed_by_user: z.string(),
  credit_paid: z.number().nullable(),
  customer_type_id: z.number(),
  debit_paid: z.number(),
  discounts: jsonSchema,
  dutchie_transaction_id: z.number(),
  electronic_paid: z.number(),
  electronic_payment_method: z.string().nullable(),
  est_delivery_date_local: z.string(),
  est_time_arrival_local_time: z.string().nullable(),
  fees_donations: z.number().nullable(),
  fk_customer_id: z.number().nullable(),
  fk_employee_id: z.number(),
  gift_paid: z.number().nullable(),
  invoice_name: z.string().nullable(),
  invoice_number: z.string().nullable(),
  is_medical: z.boolean(),
  is_return: z.boolean(),
  is_tax_inclusive: z.boolean(),
  is_void: z.boolean(),
  last_modified_date_utc: z.string(),
  loyalty_earned: z.number(),
  loyalty_spent: z.number(),
  manual_paid: z.number(),
  manual_payments: jsonSchema.nullable(),
  mmj_paid: z.number().nullable(),
  non_revenue_fees_donations: z.number(),
  order_ids: jsonSchema.nullable(),
  order_method: z.string().nullable(),
  order_source: z.string(),
  order_type: z.string(),
  paid: z.number(),
  pre_payment_amount: z.number().nullable(),
  reference_id: z.string(),
  responsible_for_sale_user_id: z.number(),
  retailer_id: z.number(),
  return_on_transaction_id: z.number().nullable(),
  revenue_fees_donations: z.number(),
  subtotal: z.number(),
  tax: z.number(),
  tax_summary: jsonSchema,
  terminal_name: z.string(),
  tip_amount: z.number().nullable(),
  total: z.number(),
  total_before_tax: z.number(),
  total_credit: z.number(),
  total_discount: z.number(),
  total_items: z.number(),
  transaction_date: z.string(),
  transaction_date_local_time: z.string(),
  transaction_type: z.string(),
  void_date: z.string().nullable(),
  was_pre_ordered: z.boolean(),
});

export const publicDutchieTransactionInsertSchemaSchema = z.object({
  adjustment_for_transaction_id: z.number().optional().nullable(),
  auth_code: z.string().optional().nullable(),
  cash_paid: z.number(),
  change_due: z.number(),
  check_in_date: z.string(),
  check_paid: z.number().optional().nullable(),
  completed_by_user: z.string(),
  credit_paid: z.number().optional().nullable(),
  customer_type_id: z.number(),
  debit_paid: z.number(),
  discounts: jsonSchema,
  dutchie_transaction_id: z.number().optional(),
  electronic_paid: z.number(),
  electronic_payment_method: z.string().optional().nullable(),
  est_delivery_date_local: z.string(),
  est_time_arrival_local_time: z.string().optional().nullable(),
  fees_donations: z.number().optional().nullable(),
  fk_customer_id: z.number().optional().nullable(),
  fk_employee_id: z.number(),
  gift_paid: z.number().optional().nullable(),
  invoice_name: z.string().optional().nullable(),
  invoice_number: z.string().optional().nullable(),
  is_medical: z.boolean(),
  is_return: z.boolean(),
  is_tax_inclusive: z.boolean(),
  is_void: z.boolean(),
  last_modified_date_utc: z.string(),
  loyalty_earned: z.number(),
  loyalty_spent: z.number(),
  manual_paid: z.number(),
  manual_payments: jsonSchema.optional().nullable(),
  mmj_paid: z.number().optional().nullable(),
  non_revenue_fees_donations: z.number(),
  order_ids: jsonSchema.optional().nullable(),
  order_method: z.string().optional().nullable(),
  order_source: z.string(),
  order_type: z.string(),
  paid: z.number(),
  pre_payment_amount: z.number().optional().nullable(),
  reference_id: z.string(),
  responsible_for_sale_user_id: z.number(),
  retailer_id: z.number(),
  return_on_transaction_id: z.number().optional().nullable(),
  revenue_fees_donations: z.number(),
  subtotal: z.number(),
  tax: z.number(),
  tax_summary: jsonSchema,
  terminal_name: z.string(),
  tip_amount: z.number().optional().nullable(),
  total: z.number(),
  total_before_tax: z.number(),
  total_credit: z.number(),
  total_discount: z.number(),
  total_items: z.number(),
  transaction_date: z.string(),
  transaction_date_local_time: z.string(),
  transaction_type: z.string(),
  void_date: z.string().optional().nullable(),
  was_pre_ordered: z.boolean(),
});

export const publicDutchieTransactionUpdateSchemaSchema = z.object({
  adjustment_for_transaction_id: z.number().optional().nullable(),
  auth_code: z.string().optional().nullable(),
  cash_paid: z.number().optional(),
  change_due: z.number().optional(),
  check_in_date: z.string().optional(),
  check_paid: z.number().optional().nullable(),
  completed_by_user: z.string().optional(),
  credit_paid: z.number().optional().nullable(),
  customer_type_id: z.number().optional(),
  debit_paid: z.number().optional(),
  discounts: jsonSchema.optional(),
  dutchie_transaction_id: z.number().optional(),
  electronic_paid: z.number().optional(),
  electronic_payment_method: z.string().optional().nullable(),
  est_delivery_date_local: z.string().optional(),
  est_time_arrival_local_time: z.string().optional().nullable(),
  fees_donations: z.number().optional().nullable(),
  fk_customer_id: z.number().optional().nullable(),
  fk_employee_id: z.number().optional(),
  gift_paid: z.number().optional().nullable(),
  invoice_name: z.string().optional().nullable(),
  invoice_number: z.string().optional().nullable(),
  is_medical: z.boolean().optional(),
  is_return: z.boolean().optional(),
  is_tax_inclusive: z.boolean().optional(),
  is_void: z.boolean().optional(),
  last_modified_date_utc: z.string().optional(),
  loyalty_earned: z.number().optional(),
  loyalty_spent: z.number().optional(),
  manual_paid: z.number().optional(),
  manual_payments: jsonSchema.optional().nullable(),
  mmj_paid: z.number().optional().nullable(),
  non_revenue_fees_donations: z.number().optional(),
  order_ids: jsonSchema.optional().nullable(),
  order_method: z.string().optional().nullable(),
  order_source: z.string().optional(),
  order_type: z.string().optional(),
  paid: z.number().optional(),
  pre_payment_amount: z.number().optional().nullable(),
  reference_id: z.string().optional(),
  responsible_for_sale_user_id: z.number().optional(),
  retailer_id: z.number().optional(),
  return_on_transaction_id: z.number().optional().nullable(),
  revenue_fees_donations: z.number().optional(),
  subtotal: z.number().optional(),
  tax: z.number().optional(),
  tax_summary: jsonSchema.optional(),
  terminal_name: z.string().optional(),
  tip_amount: z.number().optional().nullable(),
  total: z.number().optional(),
  total_before_tax: z.number().optional(),
  total_credit: z.number().optional(),
  total_discount: z.number().optional(),
  total_items: z.number().optional(),
  transaction_date: z.string().optional(),
  transaction_date_local_time: z.string().optional(),
  transaction_type: z.string().optional(),
  void_date: z.string().optional().nullable(),
  was_pre_ordered: z.boolean().optional(),
});

export const publicDutchieTransactionItemRowSchemaSchema = z.object({
  batch_name: z.string(),
  discounts: jsonSchema,
  dutchie_transaction_item_id: z.number(),
  fk_inventory_id: z.number(),
  fk_product_id: z.number(),
  fk_transaction_id: z.number(),
  flower_equivalent: z.number().nullable(),
  flower_equivalent_unit: z.string().nullable(),
  is_returned: z.boolean(),
  package_id: z.string(),
  quantity: z.number(),
  return_date: z.string().nullable(),
  return_reason: z.string().nullable(),
  returned_by_transaction_id: z.number().nullable(),
  source_package_id: z.string(),
  taxes: jsonSchema,
  total_discount: z.number(),
  total_price: z.number(),
  transaction_item_id: z.number(),
  unit_id: z.number(),
  unit_price: z.number(),
  unit_weight: z.number().nullable(),
  unit_weight_unit: z.string(),
  vendor: z.string().nullable(),
});

export const publicDutchieTransactionItemInsertSchemaSchema = z.object({
  batch_name: z.string(),
  discounts: jsonSchema,
  dutchie_transaction_item_id: z.number().optional(),
  fk_inventory_id: z.number(),
  fk_product_id: z.number(),
  fk_transaction_id: z.number(),
  flower_equivalent: z.number().optional().nullable(),
  flower_equivalent_unit: z.string().optional().nullable(),
  is_returned: z.boolean(),
  package_id: z.string(),
  quantity: z.number(),
  return_date: z.string().optional().nullable(),
  return_reason: z.string().optional().nullable(),
  returned_by_transaction_id: z.number().optional().nullable(),
  source_package_id: z.string(),
  taxes: jsonSchema,
  total_discount: z.number(),
  total_price: z.number(),
  transaction_item_id: z.number(),
  unit_id: z.number(),
  unit_price: z.number(),
  unit_weight: z.number().optional().nullable(),
  unit_weight_unit: z.string(),
  vendor: z.string().optional().nullable(),
});

export const publicDutchieTransactionItemUpdateSchemaSchema = z.object({
  batch_name: z.string().optional(),
  discounts: jsonSchema.optional(),
  dutchie_transaction_item_id: z.number().optional(),
  fk_inventory_id: z.number().optional(),
  fk_product_id: z.number().optional(),
  fk_transaction_id: z.number().optional(),
  flower_equivalent: z.number().optional().nullable(),
  flower_equivalent_unit: z.string().optional().nullable(),
  is_returned: z.boolean().optional(),
  package_id: z.string().optional(),
  quantity: z.number().optional(),
  return_date: z.string().optional().nullable(),
  return_reason: z.string().optional().nullable(),
  returned_by_transaction_id: z.number().optional().nullable(),
  source_package_id: z.string().optional(),
  taxes: jsonSchema.optional(),
  total_discount: z.number().optional(),
  total_price: z.number().optional(),
  transaction_item_id: z.number().optional(),
  unit_id: z.number().optional(),
  unit_price: z.number().optional(),
  unit_weight: z.number().optional().nullable(),
  unit_weight_unit: z.string().optional(),
  vendor: z.string().optional().nullable(),
});

export const publicDutchieTransactionItemRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Dutchie_Transaction_Item_fk_transaction_id_fkey'),
    columns: z.tuple([z.literal('fk_transaction_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Dutchie_Transaction'),
    referencedColumns: z.tuple([z.literal('dutchie_transaction_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('fk_transaction'),
    columns: z.tuple([z.literal('fk_transaction_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Dutchie_Transaction'),
    referencedColumns: z.tuple([z.literal('dutchie_transaction_id')]),
  }),
]);

export const publicExchangeTransferRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  from_position_id: z.number(),
  from_user_uid: z.string(),
  id: z.number(),
  item_distributor_quantity: z.number(),
  item_pending_quantity: z.number(),
  item_retail_quantity: z.number(),
  modified_by: z.string(),
  removed_by: z.string().nullable(),
  sale_price: z.number(),
  to_position_id: z.number(),
  to_user_uid: z.string(),
  transaction_id: z.number(),
});

export const publicExchangeTransferInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string().optional(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  from_position_id: z.number(),
  from_user_uid: z.string(),
  id: z.number().optional(),
  item_distributor_quantity: z.number(),
  item_pending_quantity: z.number(),
  item_retail_quantity: z.number(),
  modified_by: z.string(),
  removed_by: z.string().optional().nullable(),
  sale_price: z.number(),
  to_position_id: z.number(),
  to_user_uid: z.string(),
  transaction_id: z.number(),
});

export const publicExchangeTransferUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  from_position_id: z.number().optional(),
  from_user_uid: z.string().optional(),
  id: z.number().optional(),
  item_distributor_quantity: z.number().optional(),
  item_pending_quantity: z.number().optional(),
  item_retail_quantity: z.number().optional(),
  modified_by: z.string().optional(),
  removed_by: z.string().optional().nullable(),
  sale_price: z.number().optional(),
  to_position_id: z.number().optional(),
  to_user_uid: z.string().optional(),
  transaction_id: z.number().optional(),
});

export const publicExchangeTransferRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('exchange_transfer_from_position_id_fkey'),
    columns: z.tuple([z.literal('from_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('market_available_items'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_from_position_id_fkey'),
    columns: z.tuple([z.literal('from_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Position'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_from_position_id_fkey'),
    columns: z.tuple([z.literal('from_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('position_detail_stats'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_from_position_id_fkey'),
    columns: z.tuple([z.literal('from_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('position_market_info'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_from_position_id_fkey'),
    columns: z.tuple([z.literal('from_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_positions_summary_view'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_to_position_id_fkey'),
    columns: z.tuple([z.literal('to_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('market_available_items'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_to_position_id_fkey'),
    columns: z.tuple([z.literal('to_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Position'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_to_position_id_fkey'),
    columns: z.tuple([z.literal('to_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('position_detail_stats'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_to_position_id_fkey'),
    columns: z.tuple([z.literal('to_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('position_market_info'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_to_position_id_fkey'),
    columns: z.tuple([z.literal('to_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_positions_summary_view'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_transaction_id_fkey'),
    columns: z.tuple([z.literal('transaction_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('transaction_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_transaction_id_fkey'),
    columns: z.tuple([z.literal('transaction_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('debug_balance_calc'),
    referencedColumns: z.tuple([z.literal('transaction_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('exchange_transfer_transaction_id_fkey'),
    columns: z.tuple([z.literal('transaction_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Transaction'),
    referencedColumns: z.tuple([z.literal('transaction_id')]),
  }),
]);

export const publicIheartjaneNormalizedListingsRowSchemaSchema = z.object({
  city: z.string().nullable(),
  current_deals: jsonSchema.nullable(),
  delivery: z.boolean().nullable(),
  delivery_hours: jsonSchema.nullable(),
  full_address: z.string().nullable(),
  geog: z.unknown().nullable(),
  last_processed_at: z.string(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  medical: z.boolean().nullable(),
  name: z.string().nullable(),
  open_now: z.boolean().nullable(),
  open_now_text: z.string().nullable(),
  phone: z.string().nullable(),
  photo_url: z.string().nullable(),
  pickup: z.boolean().nullable(),
  pickup_hours: jsonSchema.nullable(),
  product_count: z.number().nullable(),
  rating: z.number().nullable(),
  raw_created_at: z.string().nullable(),
  raw_updated_at: z.string().nullable(),
  recreational: z.boolean().nullable(),
  reviews_count: z.number().nullable(),
  row_id: z.number(),
  source_id: z.string(),
  state: z.string().nullable(),
  store_options: jsonSchema.nullable(),
  time_zone_identifier: z.string().nullable(),
  type: jsonSchema.nullable(),
  url_slug: z.string().nullable(),
  working_hours: jsonSchema.nullable(),
});

export const publicIheartjaneNormalizedListingsInsertSchemaSchema = z.object({
  city: z.string().optional().nullable(),
  current_deals: jsonSchema.optional().nullable(),
  delivery: z.boolean().optional().nullable(),
  delivery_hours: jsonSchema.optional().nullable(),
  full_address: z.string().optional().nullable(),
  geog: z.unknown().optional().nullable(),
  last_processed_at: z.string().optional(),
  latitude: z.number().optional().nullable(),
  longitude: z.number().optional().nullable(),
  medical: z.boolean().optional().nullable(),
  name: z.string().optional().nullable(),
  open_now: z.boolean().optional().nullable(),
  open_now_text: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  photo_url: z.string().optional().nullable(),
  pickup: z.boolean().optional().nullable(),
  pickup_hours: jsonSchema.optional().nullable(),
  product_count: z.number().optional().nullable(),
  rating: z.number().optional().nullable(),
  raw_created_at: z.string().optional().nullable(),
  raw_updated_at: z.string().optional().nullable(),
  recreational: z.boolean().optional().nullable(),
  reviews_count: z.number().optional().nullable(),
  row_id: z.number(),
  source_id: z.string(),
  state: z.string().optional().nullable(),
  store_options: jsonSchema.optional().nullable(),
  time_zone_identifier: z.string().optional().nullable(),
  type: jsonSchema.optional().nullable(),
  url_slug: z.string().optional().nullable(),
  working_hours: jsonSchema.optional().nullable(),
});

export const publicIheartjaneNormalizedListingsUpdateSchemaSchema = z.object({
  city: z.string().optional().nullable(),
  current_deals: jsonSchema.optional().nullable(),
  delivery: z.boolean().optional().nullable(),
  delivery_hours: jsonSchema.optional().nullable(),
  full_address: z.string().optional().nullable(),
  geog: z.unknown().optional().nullable(),
  last_processed_at: z.string().optional(),
  latitude: z.number().optional().nullable(),
  longitude: z.number().optional().nullable(),
  medical: z.boolean().optional().nullable(),
  name: z.string().optional().nullable(),
  open_now: z.boolean().optional().nullable(),
  open_now_text: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  photo_url: z.string().optional().nullable(),
  pickup: z.boolean().optional().nullable(),
  pickup_hours: jsonSchema.optional().nullable(),
  product_count: z.number().optional().nullable(),
  rating: z.number().optional().nullable(),
  raw_created_at: z.string().optional().nullable(),
  raw_updated_at: z.string().optional().nullable(),
  recreational: z.boolean().optional().nullable(),
  reviews_count: z.number().optional().nullable(),
  row_id: z.number().optional(),
  source_id: z.string().optional(),
  state: z.string().optional().nullable(),
  store_options: jsonSchema.optional().nullable(),
  time_zone_identifier: z.string().optional().nullable(),
  type: jsonSchema.optional().nullable(),
  url_slug: z.string().optional().nullable(),
  working_hours: jsonSchema.optional().nullable(),
});

export const publicInvoiceItemsRowSchemaSchema = z.object({
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_invoice_id: z.number(),
  fk_product_id: z.number(),
  fk_rate_id: z.number(),
  invoice_item_description: z.string().nullable(),
  invoice_item_id: z.number(),
  invoice_item_price_type: publicInvoiceItemPriceTypeSchema,
  invoice_item_quantity: z.number(),
  invoice_item_title: z.string().nullable(),
  invoice_item_total_cost: z.number(),
  invoice_item_unit_price: z.number(),
});

export const publicInvoiceItemsInsertSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_invoice_id: z.number(),
  fk_product_id: z.number(),
  fk_rate_id: z.number(),
  invoice_item_description: z.string().optional().nullable(),
  invoice_item_id: z.number().optional(),
  invoice_item_price_type: publicInvoiceItemPriceTypeSchema,
  invoice_item_quantity: z.number(),
  invoice_item_title: z.string().optional().nullable(),
  invoice_item_total_cost: z.number(),
  invoice_item_unit_price: z.number(),
});

export const publicInvoiceItemsUpdateSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_invoice_id: z.number().optional(),
  fk_product_id: z.number().optional(),
  fk_rate_id: z.number().optional(),
  invoice_item_description: z.string().optional().nullable(),
  invoice_item_id: z.number().optional(),
  invoice_item_price_type: publicInvoiceItemPriceTypeSchema.optional(),
  invoice_item_quantity: z.number().optional(),
  invoice_item_title: z.string().optional().nullable(),
  invoice_item_total_cost: z.number().optional(),
  invoice_item_unit_price: z.number().optional(),
});

export const publicInvoiceItemsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('invoice_items_fk_invoice_id_fkey'),
    columns: z.tuple([z.literal('fk_invoice_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Invoices'),
    referencedColumns: z.tuple([z.literal('invoice_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('invoice_items_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('invoice_items_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Product'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('invoice_items_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('product_market_info'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('invoice_items_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('invoice_items_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('shop_available_retail_products'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('invoice_items_fk_rate_id_fkey'),
    columns: z.tuple([z.literal('fk_rate_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Rates'),
    referencedColumns: z.tuple([z.literal('rate_id')]),
  }),
]);

export const publicInvoicesRowSchemaSchema = z.object({
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  invoice_contact_address: z.string().nullable(),
  invoice_contact_email: z.string(),
  invoice_contact_name: z.string(),
  invoice_contact_phone: z.string(),
  invoice_contact_zip_code: z.string().nullable(),
  invoice_date_issued: z.string().nullable(),
  invoice_description: z.string().nullable(),
  invoice_due_amount: z.number(),
  invoice_due_date: z.string().nullable(),
  invoice_id: z.number(),
  invoice_location_id: z.number(),
  invoice_location_type: publicInventoryTypeSchema,
  invoice_name: z.string().nullable(),
  invoice_payment_method: publicInvoicePaymentMethodSchema.nullable(),
  invoice_status: publicTransactionStatusSchema,
});

export const publicInvoicesInsertSchemaSchema = z.object({
  date_created: z.string(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  invoice_contact_address: z.string().optional().nullable(),
  invoice_contact_email: z.string(),
  invoice_contact_name: z.string(),
  invoice_contact_phone: z.string(),
  invoice_contact_zip_code: z.string().optional().nullable(),
  invoice_date_issued: z.string().optional().nullable(),
  invoice_description: z.string().optional().nullable(),
  invoice_due_amount: z.number(),
  invoice_due_date: z.string().optional().nullable(),
  invoice_id: z.number().optional(),
  invoice_location_id: z.number(),
  invoice_location_type: publicInventoryTypeSchema,
  invoice_name: z.string().optional().nullable(),
  invoice_payment_method: publicInvoicePaymentMethodSchema.optional().nullable(),
  invoice_status: publicTransactionStatusSchema,
});

export const publicInvoicesUpdateSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  invoice_contact_address: z.string().optional().nullable(),
  invoice_contact_email: z.string().optional(),
  invoice_contact_name: z.string().optional(),
  invoice_contact_phone: z.string().optional(),
  invoice_contact_zip_code: z.string().optional().nullable(),
  invoice_date_issued: z.string().optional().nullable(),
  invoice_description: z.string().optional().nullable(),
  invoice_due_amount: z.number().optional(),
  invoice_due_date: z.string().optional().nullable(),
  invoice_id: z.number().optional(),
  invoice_location_id: z.number().optional(),
  invoice_location_type: publicInventoryTypeSchema.optional(),
  invoice_name: z.string().optional().nullable(),
  invoice_payment_method: publicInvoicePaymentMethodSchema.optional().nullable(),
  invoice_status: publicTransactionStatusSchema.optional(),
});

export const publicInvoicesRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('invoices_parent_invoice_id_fkey'),
    columns: z.tuple([z.literal('parent_invoice_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('invoices'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicItemRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  dutchie_pre_order_id: z.number().nullable(),
  dutchie_product_id: z.number().nullable(),
  dutchie_retailer_id: z.number().nullable(),
  dutchie_taxes_total: z.number().nullable(),
  dutchie_transaction_price: z.number().nullable(),
  dutchie_transaction_sale_price: z.string().nullable(),
  fk_brand_id: z.number(),
  fk_distributor_metric_package_id: z.number().nullable(),
  fk_distributor_order_id: z.number().nullable(),
  fk_dutchie_transaction_item_id: z.number().nullable(),
  fk_inventory_location_id: z.number().nullable(),
  fk_invoice_item_id: z.number().nullable(),
  fk_market_id: z.number(),
  fk_metrc_item_id: z.number().nullable(),
  fk_metric_package_id: z.number().nullable(),
  fk_position_id: z.number(),
  fk_product_id: z.number(),
  fk_rate_id: z.number(),
  fk_retailer_metric_package_id: z.number().nullable(),
  fk_retailer_order_id: z.number().nullable(),
  fk_transaction_id: z.number().nullable(),
  item_discount_price: z.number().nullable(),
  item_expiration_date: z.string().nullable(),
  item_id: z.number(),
  item_inventory_type: publicInventoryTypeSchema.nullable(),
  item_manufactured_date: z.string().nullable(),
  item_package_date: z.string().nullable(),
  item_proddcut_unique_id: z.string().nullable(),
  item_sku: z.string().nullable(),
  metrc_batch_id: z.string().nullable(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
});

export const publicItemInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  dutchie_pre_order_id: z.number().optional().nullable(),
  dutchie_product_id: z.number().optional().nullable(),
  dutchie_retailer_id: z.number().optional().nullable(),
  dutchie_taxes_total: z.number().optional().nullable(),
  dutchie_transaction_price: z.number().optional().nullable(),
  dutchie_transaction_sale_price: z.string().optional().nullable(),
  fk_brand_id: z.number(),
  fk_distributor_metric_package_id: z.number().optional().nullable(),
  fk_distributor_order_id: z.number().optional().nullable(),
  fk_dutchie_transaction_item_id: z.number().optional().nullable(),
  fk_inventory_location_id: z.number().optional().nullable(),
  fk_invoice_item_id: z.number().optional().nullable(),
  fk_market_id: z.number(),
  fk_metrc_item_id: z.number().optional().nullable(),
  fk_metric_package_id: z.number().optional().nullable(),
  fk_position_id: z.number(),
  fk_product_id: z.number(),
  fk_rate_id: z.number(),
  fk_retailer_metric_package_id: z.number().optional().nullable(),
  fk_retailer_order_id: z.number().optional().nullable(),
  fk_transaction_id: z.number().optional().nullable(),
  item_discount_price: z.number().optional().nullable(),
  item_expiration_date: z.string().optional().nullable(),
  item_id: z.number().optional(),
  item_inventory_type: publicInventoryTypeSchema.optional().nullable(),
  item_manufactured_date: z.string().optional().nullable(),
  item_package_date: z.string().optional().nullable(),
  item_proddcut_unique_id: z.string().optional().nullable(),
  item_sku: z.string().optional().nullable(),
  metrc_batch_id: z.string().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicItemUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  dutchie_pre_order_id: z.number().optional().nullable(),
  dutchie_product_id: z.number().optional().nullable(),
  dutchie_retailer_id: z.number().optional().nullable(),
  dutchie_taxes_total: z.number().optional().nullable(),
  dutchie_transaction_price: z.number().optional().nullable(),
  dutchie_transaction_sale_price: z.string().optional().nullable(),
  fk_brand_id: z.number().optional(),
  fk_distributor_metric_package_id: z.number().optional().nullable(),
  fk_distributor_order_id: z.number().optional().nullable(),
  fk_dutchie_transaction_item_id: z.number().optional().nullable(),
  fk_inventory_location_id: z.number().optional().nullable(),
  fk_invoice_item_id: z.number().optional().nullable(),
  fk_market_id: z.number().optional(),
  fk_metrc_item_id: z.number().optional().nullable(),
  fk_metric_package_id: z.number().optional().nullable(),
  fk_position_id: z.number().optional(),
  fk_product_id: z.number().optional(),
  fk_rate_id: z.number().optional(),
  fk_retailer_metric_package_id: z.number().optional().nullable(),
  fk_retailer_order_id: z.number().optional().nullable(),
  fk_transaction_id: z.number().optional().nullable(),
  item_discount_price: z.number().optional().nullable(),
  item_expiration_date: z.string().optional().nullable(),
  item_id: z.number().optional(),
  item_inventory_type: publicInventoryTypeSchema.optional().nullable(),
  item_manufactured_date: z.string().optional().nullable(),
  item_package_date: z.string().optional().nullable(),
  item_proddcut_unique_id: z.string().optional().nullable(),
  item_sku: z.string().optional().nullable(),
  metrc_batch_id: z.string().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicItemRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('fk_distributor_metric_package'),
    columns: z.tuple([z.literal('fk_distributor_metric_package_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Metric_Packages'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('fk_metric_package'),
    columns: z.tuple([z.literal('fk_metric_package_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Metric_Packages'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('fk_retailer_metric_package'),
    columns: z.tuple([z.literal('fk_retailer_metric_package_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Metric_Packages'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Brand'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('brand_market_info'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_distributor_order_id_fkey'),
    columns: z.tuple([z.literal('fk_distributor_order_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Order'),
    referencedColumns: z.tuple([z.literal('order_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_distributor_order_id_fkey'),
    columns: z.tuple([z.literal('fk_distributor_order_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('orders_with_item_count'),
    referencedColumns: z.tuple([z.literal('order_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_invoice_item_id_fkey'),
    columns: z.tuple([z.literal('fk_invoice_item_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Invoice_Items'),
    referencedColumns: z.tuple([z.literal('invoice_item_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_market_id_fkey'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_metrc_item_id_fkey'),
    columns: z.tuple([z.literal('fk_metrc_item_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Metrc_Items'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_position_id_fkey'),
    columns: z.tuple([z.literal('fk_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('market_available_items'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_position_id_fkey'),
    columns: z.tuple([z.literal('fk_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Position'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_position_id_fkey'),
    columns: z.tuple([z.literal('fk_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('position_detail_stats'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_position_id_fkey'),
    columns: z.tuple([z.literal('fk_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('position_market_info'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_position_id_fkey'),
    columns: z.tuple([z.literal('fk_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_positions_summary_view'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Product'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('product_market_info'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('shop_available_retail_products'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_rate_id_fkey'),
    columns: z.tuple([z.literal('fk_rate_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Rates'),
    referencedColumns: z.tuple([z.literal('rate_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_retailer_order_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_order_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Order'),
    referencedColumns: z.tuple([z.literal('order_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_retailer_order_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_order_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('orders_with_item_count'),
    referencedColumns: z.tuple([z.literal('order_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_transaction_id_fkey'),
    columns: z.tuple([z.literal('fk_transaction_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('transaction_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_transaction_id_fkey'),
    columns: z.tuple([z.literal('fk_transaction_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('debug_balance_calc'),
    referencedColumns: z.tuple([z.literal('transaction_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_transaction_id_fkey'),
    columns: z.tuple([z.literal('fk_transaction_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Transaction'),
    referencedColumns: z.tuple([z.literal('transaction_id')]),
  }),
]);

export const publicMarketRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  market_geo_points: jsonSchema,
  market_id: z.number(),
  market_name: z.string(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
});

export const publicMarketInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  market_geo_points: jsonSchema,
  market_id: z.number().optional(),
  market_name: z.string(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicMarketUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  market_geo_points: jsonSchema.optional(),
  market_id: z.number().optional(),
  market_name: z.string().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicMarketDistributorRowSchemaSchema = z.object({
  created_by: z.string().nullable(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_distributor_id: z.number(),
  fk_market_id: z.number(),
  market_distributor_id: z.number(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
});

export const publicMarketDistributorInsertSchemaSchema = z.object({
  created_by: z.string().optional().nullable(),
  date_created: z.string(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_distributor_id: z.number(),
  fk_market_id: z.number(),
  market_distributor_id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicMarketDistributorUpdateSchemaSchema = z.object({
  created_by: z.string().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_distributor_id: z.number().optional(),
  fk_market_id: z.number().optional(),
  market_distributor_id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicMarketDistributorRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('fk_distributor'),
    columns: z.tuple([z.literal('fk_distributor_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Distributor'),
    referencedColumns: z.tuple([z.literal('distributor_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('fk_market'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
]);

export const publicMarketRetailerRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  fk_market_id: z.number(),
  fk_retailer_id: z.number(),
  market_retailer_id: z.number(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
});

export const publicMarketRetailerInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  fk_market_id: z.number(),
  fk_retailer_id: z.number(),
  market_retailer_id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicMarketRetailerUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  fk_market_id: z.number().optional(),
  fk_retailer_id: z.number().optional(),
  market_retailer_id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicMarketRetailerRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Market_Retailer_fk_market_id_fkey'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Market_Retailer_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Retailer'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Market_Retailer_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
]);

export const publicMediaRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  media_alt: z.string().nullable(),
  media_bucket: z.string(),
  media_file_extension: z.string(),
  media_file_name: z.string(),
  media_full_path: z.string(),
  media_id: z.number(),
  media_path: z.string(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
});

export const publicMediaInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  media_alt: z.string().optional().nullable(),
  media_bucket: z.string(),
  media_file_extension: z.string(),
  media_file_name: z.string(),
  media_full_path: z.string(),
  media_id: z.number().optional(),
  media_path: z.string(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicMediaUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  media_alt: z.string().optional().nullable(),
  media_bucket: z.string().optional(),
  media_file_extension: z.string().optional(),
  media_file_name: z.string().optional(),
  media_full_path: z.string().optional(),
  media_id: z.number().optional(),
  media_path: z.string().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicMetrcItemsRowSchemaSchema = z.object({
  administration_method: z.string().nullable(),
  allergens: z.string().nullable(),
  approval_status: z.string().nullable(),
  approval_status_date_time: z.string().nullable(),
  default_lab_testing_state: z.string().nullable(),
  description: z.string().nullable(),
  has_expiration_date: z.boolean().nullable(),
  has_sell_by_date: z.boolean().nullable(),
  has_use_by_date: z.boolean().nullable(),
  id: z.number(),
  is_expiration_date_required: z.boolean().nullable(),
  is_sell_by_date_required: z.boolean().nullable(),
  is_use_by_date_required: z.boolean().nullable(),
  is_used: z.boolean().nullable(),
  item_brand_id: z.number().nullable(),
  item_brand_name: z.string().nullable(),
  lab_test_batch_names: jsonSchema.nullable(),
  label_images: jsonSchema.nullable(),
  label_photo_description: z.string().nullable(),
  metric_item_id: z.number(),
  name: z.string().nullable(),
  number_of_doses: z.number().nullable(),
  packaging_images: jsonSchema.nullable(),
  packaging_photo_description: z.string().nullable(),
  processing_job_category_name: z.string().nullable(),
  product_brand_name: z.string().nullable(),
  product_category_name: z.string().nullable(),
  product_category_type: z.string().nullable(),
  product_images: jsonSchema.nullable(),
  product_pdf_documents: jsonSchema.nullable(),
  product_photo_description: z.string().nullable(),
  public_ingredients: z.string().nullable(),
  quantity_type: z.string().nullable(),
  serving_size: z.number().nullable(),
  strain_id: z.number().nullable(),
  strain_name: z.string().nullable(),
  unit_cbd_content: z.number().nullable(),
  unit_cbd_content_dose: z.number().nullable(),
  unit_cbd_content_dose_unit_of_measure_name: z.string().nullable(),
  unit_cbd_content_unit_of_measure_name: z.string().nullable(),
  unit_cbd_percent: z.number().nullable(),
  unit_of_measure_name: z.string().nullable(),
  unit_quantity: z.number().nullable(),
  unit_quantity_unit_of_measure_name: z.string().nullable(),
  unit_thc_content: z.number().nullable(),
  unit_thc_content_dose: z.number().nullable(),
  unit_thc_content_dose_unit_of_measure_id: z.number().nullable(),
  unit_thc_content_dose_unit_of_measure_name: z.string().nullable(),
  unit_thc_content_unit_of_measure_name: z.string().nullable(),
  unit_thc_percent: z.number().nullable(),
  unit_volume: z.number().nullable(),
  unit_volume_unit_of_measure_name: z.string().nullable(),
  unit_weight: z.number().nullable(),
  unit_weight_unit_of_measure_name: z.string().nullable(),
});

export const publicMetrcItemsInsertSchemaSchema = z.object({
  administration_method: z.string().optional().nullable(),
  allergens: z.string().optional().nullable(),
  approval_status: z.string().optional().nullable(),
  approval_status_date_time: z.string().optional().nullable(),
  default_lab_testing_state: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  has_expiration_date: z.boolean().optional().nullable(),
  has_sell_by_date: z.boolean().optional().nullable(),
  has_use_by_date: z.boolean().optional().nullable(),
  id: z.number().optional(),
  is_expiration_date_required: z.boolean().optional().nullable(),
  is_sell_by_date_required: z.boolean().optional().nullable(),
  is_use_by_date_required: z.boolean().optional().nullable(),
  is_used: z.boolean().optional().nullable(),
  item_brand_id: z.number().optional().nullable(),
  item_brand_name: z.string().optional().nullable(),
  lab_test_batch_names: jsonSchema.optional().nullable(),
  label_images: jsonSchema.optional().nullable(),
  label_photo_description: z.string().optional().nullable(),
  metric_item_id: z.number(),
  name: z.string().optional().nullable(),
  number_of_doses: z.number().optional().nullable(),
  packaging_images: jsonSchema.optional().nullable(),
  packaging_photo_description: z.string().optional().nullable(),
  processing_job_category_name: z.string().optional().nullable(),
  product_brand_name: z.string().optional().nullable(),
  product_category_name: z.string().optional().nullable(),
  product_category_type: z.string().optional().nullable(),
  product_images: jsonSchema.optional().nullable(),
  product_pdf_documents: jsonSchema.optional().nullable(),
  product_photo_description: z.string().optional().nullable(),
  public_ingredients: z.string().optional().nullable(),
  quantity_type: z.string().optional().nullable(),
  serving_size: z.number().optional().nullable(),
  strain_id: z.number().optional().nullable(),
  strain_name: z.string().optional().nullable(),
  unit_cbd_content: z.number().optional().nullable(),
  unit_cbd_content_dose: z.number().optional().nullable(),
  unit_cbd_content_dose_unit_of_measure_name: z.string().optional().nullable(),
  unit_cbd_content_unit_of_measure_name: z.string().optional().nullable(),
  unit_cbd_percent: z.number().optional().nullable(),
  unit_of_measure_name: z.string().optional().nullable(),
  unit_quantity: z.number().optional().nullable(),
  unit_quantity_unit_of_measure_name: z.string().optional().nullable(),
  unit_thc_content: z.number().optional().nullable(),
  unit_thc_content_dose: z.number().optional().nullable(),
  unit_thc_content_dose_unit_of_measure_id: z.number().optional().nullable(),
  unit_thc_content_dose_unit_of_measure_name: z.string().optional().nullable(),
  unit_thc_content_unit_of_measure_name: z.string().optional().nullable(),
  unit_thc_percent: z.number().optional().nullable(),
  unit_volume: z.number().optional().nullable(),
  unit_volume_unit_of_measure_name: z.string().optional().nullable(),
  unit_weight: z.number().optional().nullable(),
  unit_weight_unit_of_measure_name: z.string().optional().nullable(),
});

export const publicMetrcItemsUpdateSchemaSchema = z.object({
  administration_method: z.string().optional().nullable(),
  allergens: z.string().optional().nullable(),
  approval_status: z.string().optional().nullable(),
  approval_status_date_time: z.string().optional().nullable(),
  default_lab_testing_state: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  has_expiration_date: z.boolean().optional().nullable(),
  has_sell_by_date: z.boolean().optional().nullable(),
  has_use_by_date: z.boolean().optional().nullable(),
  id: z.number().optional(),
  is_expiration_date_required: z.boolean().optional().nullable(),
  is_sell_by_date_required: z.boolean().optional().nullable(),
  is_use_by_date_required: z.boolean().optional().nullable(),
  is_used: z.boolean().optional().nullable(),
  item_brand_id: z.number().optional().nullable(),
  item_brand_name: z.string().optional().nullable(),
  lab_test_batch_names: jsonSchema.optional().nullable(),
  label_images: jsonSchema.optional().nullable(),
  label_photo_description: z.string().optional().nullable(),
  metric_item_id: z.number().optional(),
  name: z.string().optional().nullable(),
  number_of_doses: z.number().optional().nullable(),
  packaging_images: jsonSchema.optional().nullable(),
  packaging_photo_description: z.string().optional().nullable(),
  processing_job_category_name: z.string().optional().nullable(),
  product_brand_name: z.string().optional().nullable(),
  product_category_name: z.string().optional().nullable(),
  product_category_type: z.string().optional().nullable(),
  product_images: jsonSchema.optional().nullable(),
  product_pdf_documents: jsonSchema.optional().nullable(),
  product_photo_description: z.string().optional().nullable(),
  public_ingredients: z.string().optional().nullable(),
  quantity_type: z.string().optional().nullable(),
  serving_size: z.number().optional().nullable(),
  strain_id: z.number().optional().nullable(),
  strain_name: z.string().optional().nullable(),
  unit_cbd_content: z.number().optional().nullable(),
  unit_cbd_content_dose: z.number().optional().nullable(),
  unit_cbd_content_dose_unit_of_measure_name: z.string().optional().nullable(),
  unit_cbd_content_unit_of_measure_name: z.string().optional().nullable(),
  unit_cbd_percent: z.number().optional().nullable(),
  unit_of_measure_name: z.string().optional().nullable(),
  unit_quantity: z.number().optional().nullable(),
  unit_quantity_unit_of_measure_name: z.string().optional().nullable(),
  unit_thc_content: z.number().optional().nullable(),
  unit_thc_content_dose: z.number().optional().nullable(),
  unit_thc_content_dose_unit_of_measure_id: z.number().optional().nullable(),
  unit_thc_content_dose_unit_of_measure_name: z.string().optional().nullable(),
  unit_thc_content_unit_of_measure_name: z.string().optional().nullable(),
  unit_thc_percent: z.number().optional().nullable(),
  unit_volume: z.number().optional().nullable(),
  unit_volume_unit_of_measure_name: z.string().optional().nullable(),
  unit_weight: z.number().optional().nullable(),
  unit_weight_unit_of_measure_name: z.string().optional().nullable(),
});

export const publicMetricDeliveryRowSchemaSchema = z.object({
  actual_arrival_date_time: z.string().nullable(),
  actual_departure_date_time: z.string().nullable(),
  actual_return_arrival_date_time: z.string().nullable(),
  actual_return_departure_date_time: z.string().nullable(),
  date_created: z.string().nullable(),
  delivery_package_count: z.number(),
  delivery_received_package_count: z.number(),
  estimated_arrival_date_time: z.string().nullable(),
  estimated_departure_date_time: z.string().nullable(),
  estimated_return_arrival_date_time: z.string().nullable(),
  estimated_return_departure_date_time: z.string().nullable(),
  fk_metrc_transfer_id: z.number(),
  gross_unit_of_weight_id: z.number().nullable(),
  gross_unit_of_weight_name: z.string().nullable(),
  gross_weight: z.number().nullable(),
  id: z.number(),
  metric_delivery_id: z.number(),
  planned_route: z.string().nullable(),
  received_date_time: z.string().nullable(),
  recipient_facility_license_number: z.string(),
  recipient_facility_name: z.string(),
  rejected_packages_returned: z.boolean(),
  shipment_transaction_type: z.string(),
  shipment_type_name: z.string(),
});

export const publicMetricDeliveryInsertSchemaSchema = z.object({
  actual_arrival_date_time: z.string().optional().nullable(),
  actual_departure_date_time: z.string().optional().nullable(),
  actual_return_arrival_date_time: z.string().optional().nullable(),
  actual_return_departure_date_time: z.string().optional().nullable(),
  date_created: z.string().optional().nullable(),
  delivery_package_count: z.number(),
  delivery_received_package_count: z.number(),
  estimated_arrival_date_time: z.string().optional().nullable(),
  estimated_departure_date_time: z.string().optional().nullable(),
  estimated_return_arrival_date_time: z.string().optional().nullable(),
  estimated_return_departure_date_time: z.string().optional().nullable(),
  fk_metrc_transfer_id: z.number(),
  gross_unit_of_weight_id: z.number().optional().nullable(),
  gross_unit_of_weight_name: z.string().optional().nullable(),
  gross_weight: z.number().optional().nullable(),
  id: z.number().optional(),
  metric_delivery_id: z.number(),
  planned_route: z.string().optional().nullable(),
  received_date_time: z.string().optional().nullable(),
  recipient_facility_license_number: z.string(),
  recipient_facility_name: z.string(),
  rejected_packages_returned: z.boolean(),
  shipment_transaction_type: z.string(),
  shipment_type_name: z.string(),
});

export const publicMetricDeliveryUpdateSchemaSchema = z.object({
  actual_arrival_date_time: z.string().optional().nullable(),
  actual_departure_date_time: z.string().optional().nullable(),
  actual_return_arrival_date_time: z.string().optional().nullable(),
  actual_return_departure_date_time: z.string().optional().nullable(),
  date_created: z.string().optional().nullable(),
  delivery_package_count: z.number().optional(),
  delivery_received_package_count: z.number().optional(),
  estimated_arrival_date_time: z.string().optional().nullable(),
  estimated_departure_date_time: z.string().optional().nullable(),
  estimated_return_arrival_date_time: z.string().optional().nullable(),
  estimated_return_departure_date_time: z.string().optional().nullable(),
  fk_metrc_transfer_id: z.number().optional(),
  gross_unit_of_weight_id: z.number().optional().nullable(),
  gross_unit_of_weight_name: z.string().optional().nullable(),
  gross_weight: z.number().optional().nullable(),
  id: z.number().optional(),
  metric_delivery_id: z.number().optional(),
  planned_route: z.string().optional().nullable(),
  received_date_time: z.string().optional().nullable(),
  recipient_facility_license_number: z.string().optional(),
  recipient_facility_name: z.string().optional(),
  rejected_packages_returned: z.boolean().optional(),
  shipment_transaction_type: z.string().optional(),
  shipment_type_name: z.string().optional(),
});

export const publicMetricDeliveryRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Metric_Delivery_fk_metrc_transfer_id_fkey'),
    columns: z.tuple([z.literal('fk_metrc_transfer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Metric_Transfer'),
    referencedColumns: z.tuple([z.literal('metrc_transfer_id')]),
  }),
]);

export const publicMetricPackagesRowSchemaSchema = z.object({
  contains_remediated_product: z.boolean(),
  date_created: z.string().nullable(),
  expiration_date: z.string().nullable(),
  fk_metrc_delivery_id: z.number(),
  gross_unit_of_weight_name: z.string().nullable(),
  id: z.number(),
  is_donation: z.boolean(),
  is_testing_sample: z.boolean(),
  is_trade_sample: z.boolean(),
  is_trade_sample_persistent: z.boolean(),
  lab_testing_state: z.string().nullable(),
  manifest_number: z.string(),
  metrc_item_brand_name: z.string().nullable(),
  metrc_item_cbd_content: z.number().nullable(),
  metrc_item_cbd_content_dose: z.number().nullable(),
  metrc_item_cbd_content_dose_unit_of_measure_name: z.string().nullable(),
  metrc_item_cbd_content_unit_of_measure_name: z.string().nullable(),
  metrc_item_cbd_percent: z.number().nullable(),
  metrc_item_id: z.number(),
  metrc_item_serving_size: z.number().nullable(),
  metrc_item_supply_duration_days: z.number().nullable(),
  metrc_item_thc_content: z.number().nullable(),
  metrc_item_thc_content_dose: z.number().nullable(),
  metrc_item_thc_content_dose_unit_of_measure_name: z.string().nullable(),
  metrc_item_thc_content_unit_of_measure_name: z.string().nullable(),
  metrc_item_thc_percent: z.number().nullable(),
  metrc_item_unit_quantity: z.number().nullable(),
  metrc_item_unit_quantity_unit_of_measure_name: z.string().nullable(),
  metrc_item_volume: z.number().nullable(),
  metrc_item_volume_unit_of_measure_name: z.string().nullable(),
  metrc_item_weight: z.number().nullable(),
  metrc_item_weight_unit_of_measure_name: z.string().nullable(),
  metric_package_id: z.number(),
  package_label: z.string(),
  package_type: z.string(),
  packaged_date: z.string().nullable(),
  product_category_name: z.string(),
  product_name: z.string(),
  product_requires_remediation: z.boolean(),
  product_strain_name: z.string().nullable(),
  production_batch_number: z.string().nullable(),
  quantity: z.number().nullable(),
  received_quantity: z.number().nullable(),
  received_unit_of_measure_name: z.string().nullable(),
  remediation_date: z.string().nullable(),
  sell_by_date: z.string().nullable(),
  shipment_package_state: z.string().nullable(),
  shipped_quantity: z.number(),
  shipped_unit_of_measure_name: z.string(),
  source_harvest_names: z.string().nullable(),
  source_package_is_donation: z.boolean(),
  source_package_is_trade_sample: z.boolean(),
  source_production_batch_numbers: z.string().nullable(),
  unit_of_measure_name: z.string().nullable(),
  use_by_date: z.string().nullable(),
});

export const publicMetricPackagesInsertSchemaSchema = z.object({
  contains_remediated_product: z.boolean().optional(),
  date_created: z.string().optional().nullable(),
  expiration_date: z.string().optional().nullable(),
  fk_metrc_delivery_id: z.number(),
  gross_unit_of_weight_name: z.string().optional().nullable(),
  id: z.number().optional(),
  is_donation: z.boolean().optional(),
  is_testing_sample: z.boolean().optional(),
  is_trade_sample: z.boolean().optional(),
  is_trade_sample_persistent: z.boolean().optional(),
  lab_testing_state: z.string().optional().nullable(),
  manifest_number: z.string(),
  metrc_item_brand_name: z.string().optional().nullable(),
  metrc_item_cbd_content: z.number().optional().nullable(),
  metrc_item_cbd_content_dose: z.number().optional().nullable(),
  metrc_item_cbd_content_dose_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_cbd_content_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_cbd_percent: z.number().optional().nullable(),
  metrc_item_id: z.number(),
  metrc_item_serving_size: z.number().optional().nullable(),
  metrc_item_supply_duration_days: z.number().optional().nullable(),
  metrc_item_thc_content: z.number().optional().nullable(),
  metrc_item_thc_content_dose: z.number().optional().nullable(),
  metrc_item_thc_content_dose_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_thc_content_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_thc_percent: z.number().optional().nullable(),
  metrc_item_unit_quantity: z.number().optional().nullable(),
  metrc_item_unit_quantity_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_volume: z.number().optional().nullable(),
  metrc_item_volume_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_weight: z.number().optional().nullable(),
  metrc_item_weight_unit_of_measure_name: z.string().optional().nullable(),
  metric_package_id: z.number(),
  package_label: z.string(),
  package_type: z.string(),
  packaged_date: z.string().optional().nullable(),
  product_category_name: z.string(),
  product_name: z.string(),
  product_requires_remediation: z.boolean().optional(),
  product_strain_name: z.string().optional().nullable(),
  production_batch_number: z.string().optional().nullable(),
  quantity: z.number().optional().nullable(),
  received_quantity: z.number().optional().nullable(),
  received_unit_of_measure_name: z.string().optional().nullable(),
  remediation_date: z.string().optional().nullable(),
  sell_by_date: z.string().optional().nullable(),
  shipment_package_state: z.string().optional().nullable(),
  shipped_quantity: z.number(),
  shipped_unit_of_measure_name: z.string(),
  source_harvest_names: z.string().optional().nullable(),
  source_package_is_donation: z.boolean().optional(),
  source_package_is_trade_sample: z.boolean().optional(),
  source_production_batch_numbers: z.string().optional().nullable(),
  unit_of_measure_name: z.string().optional().nullable(),
  use_by_date: z.string().optional().nullable(),
});

export const publicMetricPackagesUpdateSchemaSchema = z.object({
  contains_remediated_product: z.boolean().optional(),
  date_created: z.string().optional().nullable(),
  expiration_date: z.string().optional().nullable(),
  fk_metrc_delivery_id: z.number().optional(),
  gross_unit_of_weight_name: z.string().optional().nullable(),
  id: z.number().optional(),
  is_donation: z.boolean().optional(),
  is_testing_sample: z.boolean().optional(),
  is_trade_sample: z.boolean().optional(),
  is_trade_sample_persistent: z.boolean().optional(),
  lab_testing_state: z.string().optional().nullable(),
  manifest_number: z.string().optional(),
  metrc_item_brand_name: z.string().optional().nullable(),
  metrc_item_cbd_content: z.number().optional().nullable(),
  metrc_item_cbd_content_dose: z.number().optional().nullable(),
  metrc_item_cbd_content_dose_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_cbd_content_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_cbd_percent: z.number().optional().nullable(),
  metrc_item_id: z.number().optional(),
  metrc_item_serving_size: z.number().optional().nullable(),
  metrc_item_supply_duration_days: z.number().optional().nullable(),
  metrc_item_thc_content: z.number().optional().nullable(),
  metrc_item_thc_content_dose: z.number().optional().nullable(),
  metrc_item_thc_content_dose_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_thc_content_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_thc_percent: z.number().optional().nullable(),
  metrc_item_unit_quantity: z.number().optional().nullable(),
  metrc_item_unit_quantity_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_volume: z.number().optional().nullable(),
  metrc_item_volume_unit_of_measure_name: z.string().optional().nullable(),
  metrc_item_weight: z.number().optional().nullable(),
  metrc_item_weight_unit_of_measure_name: z.string().optional().nullable(),
  metric_package_id: z.number().optional(),
  package_label: z.string().optional(),
  package_type: z.string().optional(),
  packaged_date: z.string().optional().nullable(),
  product_category_name: z.string().optional(),
  product_name: z.string().optional(),
  product_requires_remediation: z.boolean().optional(),
  product_strain_name: z.string().optional().nullable(),
  production_batch_number: z.string().optional().nullable(),
  quantity: z.number().optional().nullable(),
  received_quantity: z.number().optional().nullable(),
  received_unit_of_measure_name: z.string().optional().nullable(),
  remediation_date: z.string().optional().nullable(),
  sell_by_date: z.string().optional().nullable(),
  shipment_package_state: z.string().optional().nullable(),
  shipped_quantity: z.number().optional(),
  shipped_unit_of_measure_name: z.string().optional(),
  source_harvest_names: z.string().optional().nullable(),
  source_package_is_donation: z.boolean().optional(),
  source_package_is_trade_sample: z.boolean().optional(),
  source_production_batch_numbers: z.string().optional().nullable(),
  unit_of_measure_name: z.string().optional().nullable(),
  use_by_date: z.string().optional().nullable(),
});

export const publicMetricPackagesRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Metric_Packages_manifest_number_fkey'),
    columns: z.tuple([z.literal('manifest_number')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Metric_Transfer'),
    referencedColumns: z.tuple([z.literal('manifest_number')]),
  }),
]);

export const publicMetricTransferRowSchemaSchema = z.object({
  actual_return_arrival_date_time: z.string().nullable(),
  actual_return_departure_date_time: z.string().nullable(),
  created_date_time: z.string(),
  delivery_date_time: z.string().nullable(),
  driver_name: z.string(),
  driver_occupational_license_number: z.string(),
  driver_vehicle_license_number: z.string(),
  id: z.number(),
  manifest_number: z.string(),
  metrc_delivery_id: z.number().nullable(),
  metrc_transfer_id: z.number(),
  received_by_facility_name: z.string().nullable(),
  received_by_license_number: z.string().nullable(),
  received_date_time: z.string().nullable(),
  shipper_facility_license_number: z.string(),
  shipper_facility_name: z.string(),
  transporter_facility_license_number: z.string(),
  vehicle_license_plate_number: z.string(),
  vehicle_make: z.string(),
  vehicle_model: z.string(),
});

export const publicMetricTransferInsertSchemaSchema = z.object({
  actual_return_arrival_date_time: z.string().optional().nullable(),
  actual_return_departure_date_time: z.string().optional().nullable(),
  created_date_time: z.string(),
  delivery_date_time: z.string().optional().nullable(),
  driver_name: z.string(),
  driver_occupational_license_number: z.string(),
  driver_vehicle_license_number: z.string(),
  id: z.number().optional(),
  manifest_number: z.string(),
  metrc_delivery_id: z.number().optional().nullable(),
  metrc_transfer_id: z.number(),
  received_by_facility_name: z.string().optional().nullable(),
  received_by_license_number: z.string().optional().nullable(),
  received_date_time: z.string().optional().nullable(),
  shipper_facility_license_number: z.string(),
  shipper_facility_name: z.string(),
  transporter_facility_license_number: z.string(),
  vehicle_license_plate_number: z.string(),
  vehicle_make: z.string(),
  vehicle_model: z.string(),
});

export const publicMetricTransferUpdateSchemaSchema = z.object({
  actual_return_arrival_date_time: z.string().optional().nullable(),
  actual_return_departure_date_time: z.string().optional().nullable(),
  created_date_time: z.string().optional(),
  delivery_date_time: z.string().optional().nullable(),
  driver_name: z.string().optional(),
  driver_occupational_license_number: z.string().optional(),
  driver_vehicle_license_number: z.string().optional(),
  id: z.number().optional(),
  manifest_number: z.string().optional(),
  metrc_delivery_id: z.number().optional().nullable(),
  metrc_transfer_id: z.number().optional(),
  received_by_facility_name: z.string().optional().nullable(),
  received_by_license_number: z.string().optional().nullable(),
  received_date_time: z.string().optional().nullable(),
  shipper_facility_license_number: z.string().optional(),
  shipper_facility_name: z.string().optional(),
  transporter_facility_license_number: z.string().optional(),
  vehicle_license_plate_number: z.string().optional(),
  vehicle_make: z.string().optional(),
  vehicle_model: z.string().optional(),
});

export const publicNotificationRowSchemaSchema = z.object({
  auto_close: z.boolean(),
  auto_close_timeout: z.number(),
  created_at: z.string(),
  hide_progress_bar: z.boolean(),
  icon: z.string(),
  link: z.string().nullable(),
  link_text: z.string(),
  message: z.string(),
  notification_id: z.string(),
  open_in_new_tab: z.boolean(),
  status: publicNotificationStatusSchema,
  title: z.string(),
  type: publicNotificationTypeSchema,
  updated_at: z.string(),
  user_id: z.string(),
});

export const publicNotificationInsertSchemaSchema = z.object({
  auto_close: z.boolean().optional(),
  auto_close_timeout: z.number().optional(),
  created_at: z.string().optional(),
  hide_progress_bar: z.boolean().optional(),
  icon: z.string().optional(),
  link: z.string().optional().nullable(),
  link_text: z.string().optional(),
  message: z.string(),
  notification_id: z.string().optional(),
  open_in_new_tab: z.boolean().optional(),
  status: publicNotificationStatusSchema.optional(),
  title: z.string(),
  type: publicNotificationTypeSchema,
  updated_at: z.string().optional(),
  user_id: z.string(),
});

export const publicNotificationUpdateSchemaSchema = z.object({
  auto_close: z.boolean().optional(),
  auto_close_timeout: z.number().optional(),
  created_at: z.string().optional(),
  hide_progress_bar: z.boolean().optional(),
  icon: z.string().optional(),
  link: z.string().optional().nullable(),
  link_text: z.string().optional(),
  message: z.string().optional(),
  notification_id: z.string().optional(),
  open_in_new_tab: z.boolean().optional(),
  status: publicNotificationStatusSchema.optional(),
  title: z.string().optional(),
  type: publicNotificationTypeSchema.optional(),
  updated_at: z.string().optional(),
  user_id: z.string().optional(),
});

export const publicOrderRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  fk_distributor_id: z.number(),
  fk_market_id: z.number(),
  fk_retailer_id: z.number().nullable(),
  modified_by: z.string().nullable(),
  order_accepted_timestamp: z.string().nullable(),
  order_balance: z.number().nullable(),
  order_cancel_reason: z.string().nullable(),
  order_closed_timestamp: z.string().nullable(),
  order_delivery_address: z.string().nullable(),
  order_delivery_address2: z.string().nullable(),
  order_delivery_city: z.string().nullable(),
  order_delivery_postal_code: z.string().nullable(),
  order_delivery_state: z.string().nullable(),
  order_id: z.number(),
  order_in_progress_timestamp: z.string().nullable(),
  order_payment_method: publicOrderPaymentMethodSchema.nullable(),
  order_payment_received: z.boolean(),
  order_payment_terms: publicOrderPaymentTermsSchema.nullable(),
  order_pending_timestamp: z.string().nullable(),
  order_reject_reason: z.string().nullable(),
  order_rejected_timestamp: z.string().nullable(),
  order_status: publicOrderStatusSchema,
  order_type: publicOrdertypeSchema.nullable(),
  removed_by: z.string().nullable(),
});

export const publicOrderInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  fk_distributor_id: z.number(),
  fk_market_id: z.number(),
  fk_retailer_id: z.number().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  order_accepted_timestamp: z.string().optional().nullable(),
  order_balance: z.number().optional().nullable(),
  order_cancel_reason: z.string().optional().nullable(),
  order_closed_timestamp: z.string().optional().nullable(),
  order_delivery_address: z.string().optional().nullable(),
  order_delivery_address2: z.string().optional().nullable(),
  order_delivery_city: z.string().optional().nullable(),
  order_delivery_postal_code: z.string().optional().nullable(),
  order_delivery_state: z.string().optional().nullable(),
  order_id: z.number().optional(),
  order_in_progress_timestamp: z.string().optional().nullable(),
  order_payment_method: publicOrderPaymentMethodSchema.optional().nullable(),
  order_payment_received: z.boolean().optional(),
  order_payment_terms: publicOrderPaymentTermsSchema.optional().nullable(),
  order_pending_timestamp: z.string().optional().nullable(),
  order_reject_reason: z.string().optional().nullable(),
  order_rejected_timestamp: z.string().optional().nullable(),
  order_status: publicOrderStatusSchema.optional(),
  order_type: publicOrdertypeSchema.optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicOrderUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  fk_distributor_id: z.number().optional(),
  fk_market_id: z.number().optional(),
  fk_retailer_id: z.number().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  order_accepted_timestamp: z.string().optional().nullable(),
  order_balance: z.number().optional().nullable(),
  order_cancel_reason: z.string().optional().nullable(),
  order_closed_timestamp: z.string().optional().nullable(),
  order_delivery_address: z.string().optional().nullable(),
  order_delivery_address2: z.string().optional().nullable(),
  order_delivery_city: z.string().optional().nullable(),
  order_delivery_postal_code: z.string().optional().nullable(),
  order_delivery_state: z.string().optional().nullable(),
  order_id: z.number().optional(),
  order_in_progress_timestamp: z.string().optional().nullable(),
  order_payment_method: publicOrderPaymentMethodSchema.optional().nullable(),
  order_payment_received: z.boolean().optional(),
  order_payment_terms: publicOrderPaymentTermsSchema.optional().nullable(),
  order_pending_timestamp: z.string().optional().nullable(),
  order_reject_reason: z.string().optional().nullable(),
  order_rejected_timestamp: z.string().optional().nullable(),
  order_status: publicOrderStatusSchema.optional(),
  order_type: publicOrdertypeSchema.optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicOrderRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Order_fk_distributor_id_fkey'),
    columns: z.tuple([z.literal('fk_distributor_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Distributor'),
    referencedColumns: z.tuple([z.literal('distributor_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_fk_market_id_fkey'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Retailer'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
]);

export const publicOrderItemRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  fk_item_id: z.number(),
  fk_order_id: z.number(),
  modified_by: z.string().nullable(),
  order_item_id: z.number(),
  removed_by: z.string().nullable(),
});

export const publicOrderItemInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  fk_item_id: z.number(),
  fk_order_id: z.number(),
  modified_by: z.string().optional().nullable(),
  order_item_id: z.number().optional(),
  removed_by: z.string().optional().nullable(),
});

export const publicOrderItemUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  fk_item_id: z.number().optional(),
  fk_order_id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  order_item_id: z.number().optional(),
  removed_by: z.string().optional().nullable(),
});

export const publicOrderItemRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Order_Item_fk_item_id_fkey'),
    columns: z.tuple([z.literal('fk_item_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Item'),
    referencedColumns: z.tuple([z.literal('item_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_Item_fk_item_id_fkey'),
    columns: z.tuple([z.literal('fk_item_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_with_package_and_order'),
    referencedColumns: z.tuple([z.literal('item_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_Item_fk_order_id_fkey'),
    columns: z.tuple([z.literal('fk_order_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Order'),
    referencedColumns: z.tuple([z.literal('order_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_Item_fk_order_id_fkey'),
    columns: z.tuple([z.literal('fk_order_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('orders_with_item_count'),
    referencedColumns: z.tuple([z.literal('order_id')]),
  }),
]);

export const publicOrderMetrcTransfersRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_metrc_transfer_id: z.number(),
  fk_order_id: z.number(),
  id: z.number(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
});

export const publicOrderMetrcTransfersInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_metrc_transfer_id: z.number(),
  fk_order_id: z.number(),
  id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicOrderMetrcTransfersUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_metrc_transfer_id: z.number().optional(),
  fk_order_id: z.number().optional(),
  id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicOrderMetrcTransfersRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Order_Metrc_Transfers_fk_metrc_transfer_id_fkey'),
    columns: z.tuple([z.literal('fk_metrc_transfer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Metric_Transfer'),
    referencedColumns: z.tuple([z.literal('metrc_transfer_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_Metrc_Transfers_fk_order_id_fkey'),
    columns: z.tuple([z.literal('fk_order_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Order'),
    referencedColumns: z.tuple([z.literal('order_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_Metrc_Transfers_fk_order_id_fkey'),
    columns: z.tuple([z.literal('fk_order_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('orders_with_item_count'),
    referencedColumns: z.tuple([z.literal('order_id')]),
  }),
]);

export const publicPaymentMethodRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  fk_speculator_id: z.number(),
  modified_by: z.string().nullable(),
  payment_method_id: z.number(),
  payment_method_type: publicPaymentMethodTypeSchema,
  plaid_account_id: z.string(),
  plaid_bank_account_number: z.string(),
  plaid_bank_account_type: publicPlaidBankAccountTypeSchema,
  plaid_bank_name: z.string(),
  plaid_card_number: z.string(),
  plaid_cardholder_name: z.string(),
  plaid_institution: z.string(),
  plaid_is_active: z.boolean(),
  plaid_routing_number: z.string(),
  plaid_verified: z.boolean(),
  removed_by: z.string().nullable(),
});

export const publicPaymentMethodInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  fk_speculator_id: z.number(),
  modified_by: z.string().optional().nullable(),
  payment_method_id: z.number().optional(),
  payment_method_type: publicPaymentMethodTypeSchema,
  plaid_account_id: z.string(),
  plaid_bank_account_number: z.string(),
  plaid_bank_account_type: publicPlaidBankAccountTypeSchema,
  plaid_bank_name: z.string(),
  plaid_card_number: z.string(),
  plaid_cardholder_name: z.string(),
  plaid_institution: z.string(),
  plaid_is_active: z.boolean(),
  plaid_routing_number: z.string(),
  plaid_verified: z.boolean(),
  removed_by: z.string().optional().nullable(),
});

export const publicPaymentMethodUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  fk_speculator_id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  payment_method_id: z.number().optional(),
  payment_method_type: publicPaymentMethodTypeSchema.optional(),
  plaid_account_id: z.string().optional(),
  plaid_bank_account_number: z.string().optional(),
  plaid_bank_account_type: publicPlaidBankAccountTypeSchema.optional(),
  plaid_bank_name: z.string().optional(),
  plaid_card_number: z.string().optional(),
  plaid_cardholder_name: z.string().optional(),
  plaid_institution: z.string().optional(),
  plaid_is_active: z.boolean().optional(),
  plaid_routing_number: z.string().optional(),
  plaid_verified: z.boolean().optional(),
  removed_by: z.string().optional().nullable(),
});

export const publicPaymentMethodRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Payment_Method_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_from_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Payment_Method_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_to_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Payment_Method_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Speculator'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Payment_Method_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_dashboard_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Payment_Method_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_position_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Payment_Method_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_accounts_view'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
]);

export const publicPositionRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  fk_brand_id: z.number(),
  fk_market_id: z.number(),
  fk_product_id: z.number(),
  fk_rate_id: z.number().nullable(),
  fk_speculator_id: z.number(),
  fk_transaction_id: z.number().nullable(),
  modified_by: z.string().nullable(),
  position_ask_price: z.number().nullable(),
  position_bid_price: z.number().nullable(),
  position_buy_order_quantity: z.number().nullable(),
  position_deposit_total: z.number(),
  position_factored_price_total: z.number(),
  position_id: z.number(),
  position_initial_buy_sell_quantity: z.number(),
  position_is_filled: z.boolean(),
  position_item_unit_factored_cost: z.number(),
  position_item_unit_market_cost: z.number(),
  position_order_sub_type: publicPositionSpecificOrderTypeSchema.nullable(),
  position_order_type: publicPositionExchangeOrderTypesSchema,
  position_sell_order_quantity: z.number().nullable(),
  position_status: publicPositionStatusSchema,
  position_withdrawal_total: z.number(),
  postion_margin_total: z.number(),
  product_sku: z.string().nullable(),
  removed_by: z.string().nullable(),
});

export const publicPositionInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  fk_brand_id: z.number(),
  fk_market_id: z.number(),
  fk_product_id: z.number(),
  fk_rate_id: z.number().optional().nullable(),
  fk_speculator_id: z.number(),
  fk_transaction_id: z.number().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  position_ask_price: z.number().optional().nullable(),
  position_bid_price: z.number().optional().nullable(),
  position_buy_order_quantity: z.number().optional().nullable(),
  position_deposit_total: z.number(),
  position_factored_price_total: z.number(),
  position_id: z.number().optional(),
  position_initial_buy_sell_quantity: z.number().optional(),
  position_is_filled: z.boolean().optional(),
  position_item_unit_factored_cost: z.number(),
  position_item_unit_market_cost: z.number(),
  position_order_sub_type: publicPositionSpecificOrderTypeSchema.optional().nullable(),
  position_order_type: publicPositionExchangeOrderTypesSchema,
  position_sell_order_quantity: z.number().optional().nullable(),
  position_status: publicPositionStatusSchema,
  position_withdrawal_total: z.number(),
  postion_margin_total: z.number(),
  product_sku: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicPositionUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  fk_brand_id: z.number().optional(),
  fk_market_id: z.number().optional(),
  fk_product_id: z.number().optional(),
  fk_rate_id: z.number().optional().nullable(),
  fk_speculator_id: z.number().optional(),
  fk_transaction_id: z.number().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  position_ask_price: z.number().optional().nullable(),
  position_bid_price: z.number().optional().nullable(),
  position_buy_order_quantity: z.number().optional().nullable(),
  position_deposit_total: z.number().optional(),
  position_factored_price_total: z.number().optional(),
  position_id: z.number().optional(),
  position_initial_buy_sell_quantity: z.number().optional(),
  position_is_filled: z.boolean().optional(),
  position_item_unit_factored_cost: z.number().optional(),
  position_item_unit_market_cost: z.number().optional(),
  position_order_sub_type: publicPositionSpecificOrderTypeSchema.optional().nullable(),
  position_order_type: publicPositionExchangeOrderTypesSchema.optional(),
  position_sell_order_quantity: z.number().optional().nullable(),
  position_status: publicPositionStatusSchema.optional(),
  position_withdrawal_total: z.number().optional(),
  postion_margin_total: z.number().optional(),
  product_sku: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicPositionRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Brand'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('brand_market_info'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_market_id_fkey'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Product'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('product_market_info'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('shop_available_retail_products'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_rate_id_fkey'),
    columns: z.tuple([z.literal('fk_rate_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Rates'),
    referencedColumns: z.tuple([z.literal('rate_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_from_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_to_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Speculator'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_dashboard_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_position_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_accounts_view'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_transaction_id_fkey'),
    columns: z.tuple([z.literal('fk_transaction_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('transaction_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_transaction_id_fkey'),
    columns: z.tuple([z.literal('fk_transaction_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('debug_balance_calc'),
    referencedColumns: z.tuple([z.literal('transaction_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_transaction_id_fkey'),
    columns: z.tuple([z.literal('fk_transaction_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Transaction'),
    referencedColumns: z.tuple([z.literal('transaction_id')]),
  }),
]);

export const publicProductRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  fk_brand_id: z.number().nullable(),
  fk_weedmap_brand_id: z.number().nullable(),
  fk_weedmap_product_id: z.number().nullable(),
  genetics_tag: z.string().nullable(),
  modified_by: z.string().nullable(),
  product_ancestor_category: z.string().nullable(),
  product_categories: z.array(z.string()).nullable(),
  product_category: z.string().nullable(),
  product_cbd_content: z.string().nullable(),
  product_cbd_content_unit: publicProductContentUnitSchema.nullable(),
  product_display_name: z.string().nullable(),
  product_factored_price: z.number().nullable(),
  product_flavor: z.string().nullable(),
  product_groups: z.array(z.string()).nullable(),
  product_id: z.number(),
  product_image_url: z.string().nullable(),
  product_is_active: z.boolean().nullable(),
  product_is_cannabis: z.boolean().nullable(),
  product_med_price: z.number().nullable(),
  product_name: z.string().nullable(),
  product_rec_price: z.number().nullable(),
  product_strain: z.string().nullable(),
  product_subcategory: z.string().nullable(),
  product_tags: jsonSchema.nullable(),
  product_thc_content: z.number().nullable(),
  product_thc_content_unit: publicProductContentUnitSchema.nullable(),
  product_unit_type: publicProductContentUnitSchema.nullable(),
  product_wholesale_price: z.number().nullable(),
  removed_by: z.string().nullable(),
});

export const publicProductInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  fk_brand_id: z.number().optional().nullable(),
  fk_weedmap_brand_id: z.number().optional().nullable(),
  fk_weedmap_product_id: z.number().optional().nullable(),
  genetics_tag: z.string().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  product_ancestor_category: z.string().optional().nullable(),
  product_categories: z.array(z.string()).optional().nullable(),
  product_category: z.string().optional().nullable(),
  product_cbd_content: z.string().optional().nullable(),
  product_cbd_content_unit: publicProductContentUnitSchema.optional().nullable(),
  product_display_name: z.string().optional().nullable(),
  product_factored_price: z.number().optional().nullable(),
  product_flavor: z.string().optional().nullable(),
  product_groups: z.array(z.string()).optional().nullable(),
  product_id: z.number().optional(),
  product_image_url: z.string().optional().nullable(),
  product_is_active: z.boolean().optional().nullable(),
  product_is_cannabis: z.boolean().optional().nullable(),
  product_med_price: z.number().optional().nullable(),
  product_name: z.string().optional().nullable(),
  product_rec_price: z.number().optional().nullable(),
  product_strain: z.string().optional().nullable(),
  product_subcategory: z.string().optional().nullable(),
  product_tags: jsonSchema.optional().nullable(),
  product_thc_content: z.number().optional().nullable(),
  product_thc_content_unit: publicProductContentUnitSchema.optional().nullable(),
  product_unit_type: publicProductContentUnitSchema.optional().nullable(),
  product_wholesale_price: z.number().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicProductUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  fk_brand_id: z.number().optional().nullable(),
  fk_weedmap_brand_id: z.number().optional().nullable(),
  fk_weedmap_product_id: z.number().optional().nullable(),
  genetics_tag: z.string().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  product_ancestor_category: z.string().optional().nullable(),
  product_categories: z.array(z.string()).optional().nullable(),
  product_category: z.string().optional().nullable(),
  product_cbd_content: z.string().optional().nullable(),
  product_cbd_content_unit: publicProductContentUnitSchema.optional().nullable(),
  product_display_name: z.string().optional().nullable(),
  product_factored_price: z.number().optional().nullable(),
  product_flavor: z.string().optional().nullable(),
  product_groups: z.array(z.string()).optional().nullable(),
  product_id: z.number().optional(),
  product_image_url: z.string().optional().nullable(),
  product_is_active: z.boolean().optional().nullable(),
  product_is_cannabis: z.boolean().optional().nullable(),
  product_med_price: z.number().optional().nullable(),
  product_name: z.string().optional().nullable(),
  product_rec_price: z.number().optional().nullable(),
  product_strain: z.string().optional().nullable(),
  product_subcategory: z.string().optional().nullable(),
  product_tags: jsonSchema.optional().nullable(),
  product_thc_content: z.number().optional().nullable(),
  product_thc_content_unit: publicProductContentUnitSchema.optional().nullable(),
  product_unit_type: publicProductContentUnitSchema.optional().nullable(),
  product_wholesale_price: z.number().optional().nullable(),
  removed_by: z.string().optional().nullable(),
});

export const publicProductRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('fk_weedmap_product'),
    columns: z.tuple([z.literal('fk_weedmap_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Weedmap_Product'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Brand'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('brand_market_info'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
]);

export const publicProductMediaRowSchemaSchema = z.object({
  media_id: z.number(),
  product_id: z.number(),
});

export const publicProductMediaInsertSchemaSchema = z.object({
  media_id: z.number(),
  product_id: z.number(),
});

export const publicProductMediaUpdateSchemaSchema = z.object({
  media_id: z.number().optional(),
  product_id: z.number().optional(),
});

export const publicProductMediaRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Product_Media_media_id_fkey'),
    columns: z.tuple([z.literal('media_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Media'),
    referencedColumns: z.tuple([z.literal('media_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_Media_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_Media_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Product'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_Media_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('product_market_info'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_Media_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_Media_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('shop_available_retail_products'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
]);

export const publicRateSheetsRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  fk_distributor_id: z.number(),
  fk_market_id: z.number(),
  modified_by: z.string(),
  rate_sheet_id: z.number(),
  rate_sheet_name: z.string(),
  removed_by: z.string().nullable(),
});

export const publicRateSheetsInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string().optional(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  fk_distributor_id: z.number(),
  fk_market_id: z.number(),
  modified_by: z.string(),
  rate_sheet_id: z.number().optional(),
  rate_sheet_name: z.string(),
  removed_by: z.string().optional().nullable(),
});

export const publicRateSheetsUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  fk_distributor_id: z.number().optional(),
  fk_market_id: z.number().optional(),
  modified_by: z.string().optional(),
  rate_sheet_id: z.number().optional(),
  rate_sheet_name: z.string().optional(),
  removed_by: z.string().optional().nullable(),
});

export const publicRateSheetsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Rate_Sheets_fk_distributor_id_fkey'),
    columns: z.tuple([z.literal('fk_distributor_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Distributor'),
    referencedColumns: z.tuple([z.literal('distributor_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Rate_Sheets_fk_market_id_fkey'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
]);

export const publicRatesRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  factored_price: z.number(),
  fk_brand_id: z.number(),
  fk_market_id: z.number(),
  fk_product_id: z.number(),
  fk_rate_sheet_id: z.number(),
  min_quantity: z.number(),
  modified_by: z.string(),
  msrp: z.number().nullable(),
  rate_id: z.number(),
  removed_by: z.string().nullable(),
  tnc_price: z.number(),
  wholesale_price: z.number(),
});

export const publicRatesInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string().optional(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  factored_price: z.number(),
  fk_brand_id: z.number(),
  fk_market_id: z.number(),
  fk_product_id: z.number(),
  fk_rate_sheet_id: z.number(),
  min_quantity: z.number().optional(),
  modified_by: z.string(),
  msrp: z.number().optional().nullable(),
  rate_id: z.number().optional(),
  removed_by: z.string().optional().nullable(),
  tnc_price: z.number(),
  wholesale_price: z.number(),
});

export const publicRatesUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  factored_price: z.number().optional(),
  fk_brand_id: z.number().optional(),
  fk_market_id: z.number().optional(),
  fk_product_id: z.number().optional(),
  fk_rate_sheet_id: z.number().optional(),
  min_quantity: z.number().optional(),
  modified_by: z.string().optional(),
  msrp: z.number().optional().nullable(),
  rate_id: z.number().optional(),
  removed_by: z.string().optional().nullable(),
  tnc_price: z.number().optional(),
  wholesale_price: z.number().optional(),
});

export const publicRatesRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Rates_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Brand'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Rates_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('brand_market_info'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Rates_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Rates_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Rates_fk_market_id_fkey'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Rates_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Rates_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Product'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Rates_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('product_market_info'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Rates_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Rates_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('shop_available_retail_products'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Rates_fk_rate_sheet_id_fkey'),
    columns: z.tuple([z.literal('fk_rate_sheet_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Rate_Sheets'),
    referencedColumns: z.tuple([z.literal('rate_sheet_id')]),
  }),
]);

export const publicReferralCampaignRowSchemaSchema = z.object({
  application_type: publicReferralcampaignapplicationtypeenumSchema,
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  is_active: z.boolean(),
  link: z.string(),
  link_id: z.string(),
  metadata: jsonSchema,
  name: z.string(),
  referral_campaign_id: z.number(),
  referral_code: z.string(),
  uid: z.string(),
});

export const publicReferralCampaignInsertSchemaSchema = z.object({
  application_type: publicReferralcampaignapplicationtypeenumSchema,
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  is_active: z.boolean().optional(),
  link: z.string(),
  link_id: z.string(),
  metadata: jsonSchema.optional(),
  name: z.string(),
  referral_campaign_id: z.number().optional(),
  referral_code: z.string(),
  uid: z.string(),
});

export const publicReferralCampaignUpdateSchemaSchema = z.object({
  application_type: publicReferralcampaignapplicationtypeenumSchema.optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  is_active: z.boolean().optional(),
  link: z.string().optional(),
  link_id: z.string().optional(),
  metadata: jsonSchema.optional(),
  name: z.string().optional(),
  referral_campaign_id: z.number().optional(),
  referral_code: z.string().optional(),
  uid: z.string().optional(),
});

export const publicRetailerRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
  retailer_address: z.string(),
  retailer_address2: z.string(),
  retailer_avatar_url: z.string().nullable(),
  retailer_city: z.string(),
  retailer_dutchie_id: z.number().nullable(),
  retailer_email: z.string(),
  retailer_geo_points: jsonSchema,
  retailer_id: z.number(),
  retailer_is_internal: z.boolean(),
  retailer_license_number: z.string(),
  retailer_name: z.string(),
  retailer_phone: z.string(),
  retailer_postal_code: z.string(),
  retailer_state: z.string(),
  retailer_status: publicRetailerstatusSchema,
});

export const publicRetailerInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  retailer_address: z.string(),
  retailer_address2: z.string(),
  retailer_avatar_url: z.string().optional().nullable(),
  retailer_city: z.string(),
  retailer_dutchie_id: z.number().optional().nullable(),
  retailer_email: z.string(),
  retailer_geo_points: jsonSchema,
  retailer_id: z.number().optional(),
  retailer_is_internal: z.boolean().optional(),
  retailer_license_number: z.string(),
  retailer_name: z.string(),
  retailer_phone: z.string(),
  retailer_postal_code: z.string(),
  retailer_state: z.string(),
  retailer_status: publicRetailerstatusSchema.optional(),
});

export const publicRetailerUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  retailer_address: z.string().optional(),
  retailer_address2: z.string().optional(),
  retailer_avatar_url: z.string().optional().nullable(),
  retailer_city: z.string().optional(),
  retailer_dutchie_id: z.number().optional().nullable(),
  retailer_email: z.string().optional(),
  retailer_geo_points: jsonSchema.optional(),
  retailer_id: z.number().optional(),
  retailer_is_internal: z.boolean().optional(),
  retailer_license_number: z.string().optional(),
  retailer_name: z.string().optional(),
  retailer_phone: z.string().optional(),
  retailer_postal_code: z.string().optional(),
  retailer_state: z.string().optional(),
  retailer_status: publicRetailerstatusSchema.optional(),
});

export const publicRetailerBrandRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  fk_brand_id: z.number(),
  fk_retailer_id: z.number(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
  retailer_brand_id: z.number(),
});

export const publicRetailerBrandInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  fk_brand_id: z.number(),
  fk_retailer_id: z.number(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  retailer_brand_id: z.never().optional(),
});

export const publicRetailerBrandUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  fk_brand_id: z.number().optional(),
  fk_retailer_id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  retailer_brand_id: z.never().optional(),
});

export const publicRetailerBrandRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('retailer_brand_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Brand'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('retailer_brand_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('brand_market_info'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('retailer_brand_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('retailer_brand_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('retailer_brand_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Retailer'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('retailer_brand_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
]);

export const publicRetailerLastProcessedRowSchemaSchema = z.object({
  last_processed_date: z.string(),
  retailer_id: z.number(),
});

export const publicRetailerLastProcessedInsertSchemaSchema = z.object({
  last_processed_date: z.string(),
  retailer_id: z.number(),
});

export const publicRetailerLastProcessedUpdateSchemaSchema = z.object({
  last_processed_date: z.string().optional(),
  retailer_id: z.number().optional(),
});

export const publicRoleRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  fk_speculator_id: z.number(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
  role_entity_id: z.number(),
  role_entity_type: publicRoleEntityTypeSchema,
  role_type_id: z.number(),
});

export const publicRoleInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  fk_speculator_id: z.number(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  role_entity_id: z.number(),
  role_entity_type: publicRoleEntityTypeSchema,
  role_type_id: z.number().optional(),
});

export const publicRoleUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  fk_speculator_id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  role_entity_id: z.number().optional(),
  role_entity_type: publicRoleEntityTypeSchema.optional(),
  role_type_id: z.number().optional(),
});

export const publicRoleRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Role_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_from_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Role_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_to_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Role_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Speculator'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Role_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_dashboard_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Role_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_position_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Role_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_accounts_view'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
]);

export const publicSpatialRefSysRowSchemaSchema = z.object({
  auth_name: z.string().nullable(),
  auth_srid: z.number().nullable(),
  proj4text: z.string().nullable(),
  srid: z.number(),
  srtext: z.string().nullable(),
});

export const publicSpatialRefSysInsertSchemaSchema = z.object({
  auth_name: z.string().optional().nullable(),
  auth_srid: z.number().optional().nullable(),
  proj4text: z.string().optional().nullable(),
  srid: z.number(),
  srtext: z.string().optional().nullable(),
});

export const publicSpatialRefSysUpdateSchemaSchema = z.object({
  auth_name: z.string().optional().nullable(),
  auth_srid: z.number().optional().nullable(),
  proj4text: z.string().optional().nullable(),
  srid: z.number().optional(),
  srtext: z.string().optional().nullable(),
});

export const publicSpeculatorRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
  speculator_address: z.string().nullable(),
  speculator_address2: z.string().nullable(),
  speculator_city: z.string().nullable(),
  speculator_country: z.string().nullable(),
  speculator_dob: z.string().nullable(),
  speculator_email: z.string(),
  speculator_id: z.number(),
  speculator_kyc: z.string().nullable(),
  speculator_last_login: z.string().nullable(),
  speculator_name_first: z.string().nullable(),
  speculator_name_last: z.string().nullable(),
  speculator_name_middle: z.string().nullable(),
  speculator_phone: z.string().nullable(),
  speculator_postal_code: z.string().nullable(),
  speculator_preferred_language: z.string().nullable(),
  speculator_profile_image_url: z.string().nullable(),
  speculator_state: z.string().nullable(),
  speculator_status: z.string().nullable(),
  speculator_stripe_customer_id: z.string().nullable(),
  speculator_timezone: z.string().nullable(),
  speculator_two_factor_enabled: z.boolean().nullable(),
  speculator_username: z.string().nullable(),
  uid: z.string(),
});

export const publicSpeculatorInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  speculator_address: z.string().optional().nullable(),
  speculator_address2: z.string().optional().nullable(),
  speculator_city: z.string().optional().nullable(),
  speculator_country: z.string().optional().nullable(),
  speculator_dob: z.string().optional().nullable(),
  speculator_email: z.string(),
  speculator_id: z.number().optional(),
  speculator_kyc: z.string().optional().nullable(),
  speculator_last_login: z.string().optional().nullable(),
  speculator_name_first: z.string().optional().nullable(),
  speculator_name_last: z.string().optional().nullable(),
  speculator_name_middle: z.string().optional().nullable(),
  speculator_phone: z.string().optional().nullable(),
  speculator_postal_code: z.string().optional().nullable(),
  speculator_preferred_language: z.string().optional().nullable(),
  speculator_profile_image_url: z.string().optional().nullable(),
  speculator_state: z.string().optional().nullable(),
  speculator_status: z.string().optional().nullable(),
  speculator_stripe_customer_id: z.string().optional().nullable(),
  speculator_timezone: z.string().optional().nullable(),
  speculator_two_factor_enabled: z.boolean().optional().nullable(),
  speculator_username: z.string().optional().nullable(),
  uid: z.string(),
});

export const publicSpeculatorUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  speculator_address: z.string().optional().nullable(),
  speculator_address2: z.string().optional().nullable(),
  speculator_city: z.string().optional().nullable(),
  speculator_country: z.string().optional().nullable(),
  speculator_dob: z.string().optional().nullable(),
  speculator_email: z.string().optional(),
  speculator_id: z.number().optional(),
  speculator_kyc: z.string().optional().nullable(),
  speculator_last_login: z.string().optional().nullable(),
  speculator_name_first: z.string().optional().nullable(),
  speculator_name_last: z.string().optional().nullable(),
  speculator_name_middle: z.string().optional().nullable(),
  speculator_phone: z.string().optional().nullable(),
  speculator_postal_code: z.string().optional().nullable(),
  speculator_preferred_language: z.string().optional().nullable(),
  speculator_profile_image_url: z.string().optional().nullable(),
  speculator_state: z.string().optional().nullable(),
  speculator_status: z.string().optional().nullable(),
  speculator_stripe_customer_id: z.string().optional().nullable(),
  speculator_timezone: z.string().optional().nullable(),
  speculator_two_factor_enabled: z.boolean().optional().nullable(),
  speculator_username: z.string().optional().nullable(),
  uid: z.string().optional(),
});

export const publicSuperadminRowSchemaSchema = z.object({
  created_at: z.string(),
  created_by: z.string(),
  date_removed: z.string().nullable(),
  id: z.number(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
  uid: z.string(),
});

export const publicSuperadminInsertSchemaSchema = z.object({
  created_at: z.string(),
  created_by: z.string(),
  date_removed: z.string().optional().nullable(),
  id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  uid: z.string(),
});

export const publicSuperadminUpdateSchemaSchema = z.object({
  created_at: z.string().optional(),
  created_by: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  uid: z.string().optional(),
});

export const publicTncBrandsRowSchemaSchema = z.object({
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_parent_id: z.number().nullable(),
  fk_platform_id: z.number().nullable(),
  id: z.number(),
  origin_source_id: z.string().nullable(),
  source_name: z.string(),
});

export const publicTncBrandsInsertSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_parent_id: z.number().optional().nullable(),
  fk_platform_id: z.number().optional().nullable(),
  id: z.number().optional(),
  origin_source_id: z.string().optional().nullable(),
  source_name: z.string(),
});

export const publicTncBrandsUpdateSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_parent_id: z.number().optional().nullable(),
  fk_platform_id: z.number().optional().nullable(),
  id: z.number().optional(),
  origin_source_id: z.string().optional().nullable(),
  source_name: z.string().optional(),
});

export const publicTncBrandsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('tnc_brands_fk_parent_id_fkey'),
    columns: z.tuple([z.literal('fk_parent_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('tnc_brands'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('tnc_brands_fk_platform_id_fkey'),
    columns: z.tuple([z.literal('fk_platform_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('tnc_platforms'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicTncBrandsLeaflyRowSchemaSchema = z.object({
  available_countries: z.array(z.string()).nullable(),
  brand_licenses: z.array(jsonSchema).nullable(),
  brand_name: z.string(),
  claimed: z.boolean(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  description: z.string().nullable(),
  external_id: z.string(),
  id: z.number(),
  information_website: z.string().nullable(),
  is_paid: z.boolean(),
  is_product_affiliate_links_enabled: z.boolean(),
  logo_url: z.string().nullable(),
  slug: z.string(),
  tagline: z.string().nullable(),
});

export const publicTncBrandsLeaflyInsertSchemaSchema = z.object({
  available_countries: z.array(z.string()).optional().nullable(),
  brand_licenses: z.array(jsonSchema).optional().nullable(),
  brand_name: z.string(),
  claimed: z.boolean(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  external_id: z.string(),
  id: z.number().optional(),
  information_website: z.string().optional().nullable(),
  is_paid: z.boolean(),
  is_product_affiliate_links_enabled: z.boolean(),
  logo_url: z.string().optional().nullable(),
  slug: z.string(),
  tagline: z.string().optional().nullable(),
});

export const publicTncBrandsLeaflyUpdateSchemaSchema = z.object({
  available_countries: z.array(z.string()).optional().nullable(),
  brand_licenses: z.array(jsonSchema).optional().nullable(),
  brand_name: z.string().optional(),
  claimed: z.boolean().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  external_id: z.string().optional(),
  id: z.number().optional(),
  information_website: z.string().optional().nullable(),
  is_paid: z.boolean().optional(),
  is_product_affiliate_links_enabled: z.boolean().optional(),
  logo_url: z.string().optional().nullable(),
  slug: z.string().optional(),
  tagline: z.string().optional().nullable(),
});

export const publicTncBrandsMasterRowSchemaSchema = z.object({
  aliases: jsonSchema.nullable(),
  created_at: z.string().nullable(),
  details: jsonSchema.nullable(),
  last_updated_at: z.string().nullable(),
  tnc_brand_name: z.string().nullable(),
  tnc_brands_master_id: z.number(),
});

export const publicTncBrandsMasterInsertSchemaSchema = z.object({
  aliases: jsonSchema.optional().nullable(),
  created_at: z.string().optional().nullable(),
  details: jsonSchema.optional().nullable(),
  last_updated_at: z.string().optional().nullable(),
  tnc_brand_name: z.string().optional().nullable(),
  tnc_brands_master_id: z.number().optional(),
});

export const publicTncBrandsMasterUpdateSchemaSchema = z.object({
  aliases: jsonSchema.optional().nullable(),
  created_at: z.string().optional().nullable(),
  details: jsonSchema.optional().nullable(),
  last_updated_at: z.string().optional().nullable(),
  tnc_brand_name: z.string().optional().nullable(),
  tnc_brands_master_id: z.number().optional(),
});

export const publicTncBrandsWeedmapsRowSchemaSchema = z.object({
  avatar_image_large_url: z.string().nullable(),
  avatar_image_original_url: z.string().nullable(),
  avatar_image_small_url: z.string().nullable(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  external_id: z.string(),
  id: z.number(),
  is_claimed: z.boolean(),
  is_premium: z.boolean(),
  name: z.string(),
  products_count: z.number(),
  rating: z.number(),
  reviews_count: z.number(),
  slug: z.string(),
});

export const publicTncBrandsWeedmapsInsertSchemaSchema = z.object({
  avatar_image_large_url: z.string().optional().nullable(),
  avatar_image_original_url: z.string().optional().nullable(),
  avatar_image_small_url: z.string().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  external_id: z.string(),
  id: z.number().optional(),
  is_claimed: z.boolean(),
  is_premium: z.boolean(),
  name: z.string(),
  products_count: z.number(),
  rating: z.number(),
  reviews_count: z.number(),
  slug: z.string(),
});

export const publicTncBrandsWeedmapsUpdateSchemaSchema = z.object({
  avatar_image_large_url: z.string().optional().nullable(),
  avatar_image_original_url: z.string().optional().nullable(),
  avatar_image_small_url: z.string().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  external_id: z.string().optional(),
  id: z.number().optional(),
  is_claimed: z.boolean().optional(),
  is_premium: z.boolean().optional(),
  name: z.string().optional(),
  products_count: z.number().optional(),
  rating: z.number().optional(),
  reviews_count: z.number().optional(),
  slug: z.string().optional(),
});

export const publicTncCategoriesRowSchemaSchema = z.object({
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_parent_id: z.number().nullable(),
  fk_platform_id: z.number(),
  fk_primary_category_id: z.number().nullable(),
  id: z.number(),
  name: z.string(),
  origin_id: z.string().nullable(),
  type: publicPosCategoryTypeSchema,
});

export const publicTncCategoriesInsertSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_parent_id: z.number().optional().nullable(),
  fk_platform_id: z.number(),
  fk_primary_category_id: z.number().optional().nullable(),
  id: z.number().optional(),
  name: z.string(),
  origin_id: z.string().optional().nullable(),
  type: publicPosCategoryTypeSchema,
});

export const publicTncCategoriesUpdateSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_parent_id: z.number().optional().nullable(),
  fk_platform_id: z.number().optional(),
  fk_primary_category_id: z.number().optional().nullable(),
  id: z.number().optional(),
  name: z.string().optional(),
  origin_id: z.string().optional().nullable(),
  type: publicPosCategoryTypeSchema.optional(),
});

export const publicTncCategoriesRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('tnc_categories_fk_parent_id_fkey'),
    columns: z.tuple([z.literal('fk_parent_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('tnc_categories'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('tnc_categories_fk_platform_id_fkey'),
    columns: z.tuple([z.literal('fk_platform_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('tnc_platforms'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('tnc_categories_fk_primary_category_id_fkey'),
    columns: z.tuple([z.literal('fk_primary_category_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('tnc_categories'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicTncCategoriesLeaflyRowSchemaSchema = z.object({
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_primary_category_id: z.number().nullable(),
  id: z.number(),
  leafly_id: z.string(),
  name: z.string(),
  type: publicPosCategoryTypeSchema,
});

export const publicTncCategoriesLeaflyInsertSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_primary_category_id: z.number().optional().nullable(),
  id: z.number().optional(),
  leafly_id: z.string(),
  name: z.string(),
  type: publicPosCategoryTypeSchema,
});

export const publicTncCategoriesLeaflyUpdateSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_primary_category_id: z.number().optional().nullable(),
  id: z.number().optional(),
  leafly_id: z.string().optional(),
  name: z.string().optional(),
  type: publicPosCategoryTypeSchema.optional(),
});

export const publicTncCategoriesLeaflyRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('tnc_categories_leafly_fk_primary_category_id_fkey'),
    columns: z.tuple([z.literal('fk_primary_category_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('tnc_categories_leafly'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicTncCategoriesWeedmapsRowSchemaSchema = z.object({
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_primary_category_id: z.number().nullable(),
  id: z.number(),
  name: z.string(),
  type: publicPosCategoryTypeSchema,
  wm_id: z.string(),
});

export const publicTncCategoriesWeedmapsInsertSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_primary_category_id: z.number().optional().nullable(),
  id: z.number().optional(),
  name: z.string(),
  type: publicPosCategoryTypeSchema,
  wm_id: z.string(),
});

export const publicTncCategoriesWeedmapsUpdateSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_primary_category_id: z.number().optional().nullable(),
  id: z.number().optional(),
  name: z.string().optional(),
  type: publicPosCategoryTypeSchema.optional(),
  wm_id: z.string().optional(),
});

export const publicTncCategoriesWeedmapsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('tnc_categories_weedmaps_fk_primary_category_id_fkey'),
    columns: z.tuple([z.literal('fk_primary_category_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('tnc_categories_weedmaps'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicTncListingsRowSchemaSchema = z.object({
  canonical_address: z.string().nullable(),
  canonical_city: z.string().nullable(),
  canonical_country: z.string().nullable(),
  canonical_geog: z.unknown().nullable(),
  canonical_latitude: z.number().nullable(),
  canonical_longitude: z.number().nullable(),
  canonical_name: z.string().nullable(),
  canonical_phone: z.string().nullable(),
  canonical_slug: z.string().nullable(),
  canonical_state: z.string().nullable(),
  canonical_zipcode: z.string().nullable(),
  created_at: z.string().nullable(),
  dutchie_source_id: z.string().nullable(),
  iheartjane_source_id: z.string().nullable(),
  is_custom_addition: z.boolean(),
  last_updated_at: z.string().nullable(),
  match_confidence: z.number().nullable(),
  match_method: z.string().nullable(),
  tnc_id: z.number(),
  weedmaps_wmid: z.number().nullable(),
});

export const publicTncListingsInsertSchemaSchema = z.object({
  canonical_address: z.string().optional().nullable(),
  canonical_city: z.string().optional().nullable(),
  canonical_country: z.string().optional().nullable(),
  canonical_geog: z.unknown().optional().nullable(),
  canonical_latitude: z.number().optional().nullable(),
  canonical_longitude: z.number().optional().nullable(),
  canonical_name: z.string().optional().nullable(),
  canonical_phone: z.string().optional().nullable(),
  canonical_slug: z.string().optional().nullable(),
  canonical_state: z.string().optional().nullable(),
  canonical_zipcode: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  dutchie_source_id: z.string().optional().nullable(),
  iheartjane_source_id: z.string().optional().nullable(),
  is_custom_addition: z.boolean().optional(),
  last_updated_at: z.string().optional().nullable(),
  match_confidence: z.number().optional().nullable(),
  match_method: z.string().optional().nullable(),
  tnc_id: z.number().optional(),
  weedmaps_wmid: z.number().optional().nullable(),
});

export const publicTncListingsUpdateSchemaSchema = z.object({
  canonical_address: z.string().optional().nullable(),
  canonical_city: z.string().optional().nullable(),
  canonical_country: z.string().optional().nullable(),
  canonical_geog: z.unknown().optional().nullable(),
  canonical_latitude: z.number().optional().nullable(),
  canonical_longitude: z.number().optional().nullable(),
  canonical_name: z.string().optional().nullable(),
  canonical_phone: z.string().optional().nullable(),
  canonical_slug: z.string().optional().nullable(),
  canonical_state: z.string().optional().nullable(),
  canonical_zipcode: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  dutchie_source_id: z.string().optional().nullable(),
  iheartjane_source_id: z.string().optional().nullable(),
  is_custom_addition: z.boolean().optional(),
  last_updated_at: z.string().optional().nullable(),
  match_confidence: z.number().optional().nullable(),
  match_method: z.string().optional().nullable(),
  tnc_id: z.number().optional(),
  weedmaps_wmid: z.number().optional().nullable(),
});

export const publicTncListingsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('fk_tnc_dutchie'),
    columns: z.tuple([z.literal('dutchie_source_id')]),
    isOneToOne: z.literal(true),
    referencedRelation: z.literal('dutchie_normalized_listings'),
    referencedColumns: z.tuple([z.literal('source_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('fk_tnc_iheartjane'),
    columns: z.tuple([z.literal('iheartjane_source_id')]),
    isOneToOne: z.literal(true),
    referencedRelation: z.literal('Iheartjane_Normalized_Listings'),
    referencedColumns: z.tuple([z.literal('source_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('fk_tnc_weedmaps'),
    columns: z.tuple([z.literal('weedmaps_wmid')]),
    isOneToOne: z.literal(true),
    referencedRelation: z.literal('Weedmaps_Normalized_Listings'),
    referencedColumns: z.tuple([z.literal('wmid')]),
  }),
]);

export const publicTncListingsTestRowSchemaSchema = z.object({
  canonical_address: z.string().nullable(),
  canonical_city: z.string().nullable(),
  canonical_geog: z.unknown().nullable(),
  canonical_latitude: z.number().nullable(),
  canonical_longitude: z.number().nullable(),
  canonical_name: z.string().nullable(),
  canonical_phone: z.string().nullable(),
  canonical_state: z.string().nullable(),
  canonical_zipcode: z.string().nullable(),
  created_at: z.string().nullable(),
  dutchie_source_id: z.string().nullable(),
  iheartjane_source_id: z.string().nullable(),
  last_updated_at: z.string().nullable(),
  match_confidence: z.number().nullable(),
  match_method: publicMatchMethodTypeSchema.nullable(),
  tnc_id: z.number().nullable(),
  weedmaps_wmid: z.number().nullable(),
});

export const publicTncListingsTestInsertSchemaSchema = z.object({
  canonical_address: z.string().optional().nullable(),
  canonical_city: z.string().optional().nullable(),
  canonical_geog: z.unknown().optional().nullable(),
  canonical_latitude: z.number().optional().nullable(),
  canonical_longitude: z.number().optional().nullable(),
  canonical_name: z.string().optional().nullable(),
  canonical_phone: z.string().optional().nullable(),
  canonical_state: z.string().optional().nullable(),
  canonical_zipcode: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  dutchie_source_id: z.string().optional().nullable(),
  iheartjane_source_id: z.string().optional().nullable(),
  last_updated_at: z.string().optional().nullable(),
  match_confidence: z.number().optional().nullable(),
  match_method: publicMatchMethodTypeSchema.optional().nullable(),
  tnc_id: z.number().optional().nullable(),
  weedmaps_wmid: z.number().optional().nullable(),
});

export const publicTncListingsTestUpdateSchemaSchema = z.object({
  canonical_address: z.string().optional().nullable(),
  canonical_city: z.string().optional().nullable(),
  canonical_geog: z.unknown().optional().nullable(),
  canonical_latitude: z.number().optional().nullable(),
  canonical_longitude: z.number().optional().nullable(),
  canonical_name: z.string().optional().nullable(),
  canonical_phone: z.string().optional().nullable(),
  canonical_state: z.string().optional().nullable(),
  canonical_zipcode: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  dutchie_source_id: z.string().optional().nullable(),
  iheartjane_source_id: z.string().optional().nullable(),
  last_updated_at: z.string().optional().nullable(),
  match_confidence: z.number().optional().nullable(),
  match_method: publicMatchMethodTypeSchema.optional().nullable(),
  tnc_id: z.number().optional().nullable(),
  weedmaps_wmid: z.number().optional().nullable(),
});

export const publicTncPlatformsRowSchemaSchema = z.object({
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  id: z.number(),
  platform_name: z.string(),
});

export const publicTncPlatformsInsertSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  id: z.number().optional(),
  platform_name: z.string(),
});

export const publicTncPlatformsUpdateSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  id: z.number().optional(),
  platform_name: z.string().optional(),
});

export const publicTncStrainsRowSchemaSchema = z.object({
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_parent_id: z.number().nullable(),
  fk_platform_id: z.number().nullable(),
  id: z.number(),
  origin_source_id: z.string().nullable(),
  source_name: z.string(),
});

export const publicTncStrainsInsertSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_parent_id: z.number().optional().nullable(),
  fk_platform_id: z.number().optional().nullable(),
  id: z.number().optional(),
  origin_source_id: z.string().optional().nullable(),
  source_name: z.string(),
});

export const publicTncStrainsUpdateSchemaSchema = z.object({
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  fk_parent_id: z.number().optional().nullable(),
  fk_platform_id: z.number().optional().nullable(),
  id: z.number().optional(),
  origin_source_id: z.string().optional().nullable(),
  source_name: z.string().optional(),
});

export const publicTncStrainsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('tnc_strains_fk_parent_id_fkey'),
    columns: z.tuple([z.literal('fk_parent_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('tnc_strains'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('tnc_strains_fk_platform_id_fkey'),
    columns: z.tuple([z.literal('fk_platform_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('tnc_platforms'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicTncStrainsLeaflyRowSchemaSchema = z.object({
  average_rating: z.number().nullable(),
  cannabinoids: jsonSchema.nullable(),
  category: z.string().nullable(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  effects: jsonSchema.nullable(),
  external_id: z.string(),
  flower_image_svg: z.string().nullable(),
  id: z.number(),
  nug_image: z.string().nullable(),
  phenotype: z.string().nullable(),
  review_count: z.number().nullable(),
  short_description_plain: z.string().nullable(),
  slug: z.string(),
  strain_name: z.string(),
  strain_top_terp: z.string().nullable(),
  terps: jsonSchema.nullable(),
  thc_percentile_50: z.number().nullable(),
  top_effect: z.string().nullable(),
});

export const publicTncStrainsLeaflyInsertSchemaSchema = z.object({
  average_rating: z.number().optional().nullable(),
  cannabinoids: jsonSchema.optional().nullable(),
  category: z.string().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  effects: jsonSchema.optional().nullable(),
  external_id: z.string(),
  flower_image_svg: z.string().optional().nullable(),
  id: z.number().optional(),
  nug_image: z.string().optional().nullable(),
  phenotype: z.string().optional().nullable(),
  review_count: z.number().optional().nullable(),
  short_description_plain: z.string().optional().nullable(),
  slug: z.string(),
  strain_name: z.string(),
  strain_top_terp: z.string().optional().nullable(),
  terps: jsonSchema.optional().nullable(),
  thc_percentile_50: z.number().optional().nullable(),
  top_effect: z.string().optional().nullable(),
});

export const publicTncStrainsLeaflyUpdateSchemaSchema = z.object({
  average_rating: z.number().optional().nullable(),
  cannabinoids: jsonSchema.optional().nullable(),
  category: z.string().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  effects: jsonSchema.optional().nullable(),
  external_id: z.string().optional(),
  flower_image_svg: z.string().optional().nullable(),
  id: z.number().optional(),
  nug_image: z.string().optional().nullable(),
  phenotype: z.string().optional().nullable(),
  review_count: z.number().optional().nullable(),
  short_description_plain: z.string().optional().nullable(),
  slug: z.string().optional(),
  strain_name: z.string().optional(),
  strain_top_terp: z.string().optional().nullable(),
  terps: jsonSchema.optional().nullable(),
  thc_percentile_50: z.number().optional().nullable(),
  top_effect: z.string().optional().nullable(),
});

export const publicTncStrainsWeedmapsRowSchemaSchema = z.object({
  aliases: jsonSchema.nullable(),
  avatar_image_url: z.string().nullable(),
  cbd_max: z.number().nullable(),
  cbd_min: z.number().nullable(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  description: z.string().nullable(),
  effects: jsonSchema.nullable(),
  effects_vote_count: z.number().nullable(),
  external_id: z.string(),
  featured: z.boolean().nullable(),
  flavors: jsonSchema.nullable(),
  flavors_vote_count: z.number().nullable(),
  genetic_cultivation_description: z.string().nullable(),
  hero_image_url: z.string().nullable(),
  id: z.number(),
  medical_conditions: jsonSchema.nullable(),
  medical_conditions_vote_count: z.number().nullable(),
  name: z.string(),
  similar_strains: jsonSchema.nullable(),
  slug: z.string(),
  species: z.string().nullable(),
  thc_max: z.number().nullable(),
  thc_min: z.number().nullable(),
  updated_at: z.string().nullable(),
});

export const publicTncStrainsWeedmapsInsertSchemaSchema = z.object({
  aliases: jsonSchema.optional().nullable(),
  avatar_image_url: z.string().optional().nullable(),
  cbd_max: z.number().optional().nullable(),
  cbd_min: z.number().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  effects: jsonSchema.optional().nullable(),
  effects_vote_count: z.number().optional().nullable(),
  external_id: z.string(),
  featured: z.boolean().optional().nullable(),
  flavors: jsonSchema.optional().nullable(),
  flavors_vote_count: z.number().optional().nullable(),
  genetic_cultivation_description: z.string().optional().nullable(),
  hero_image_url: z.string().optional().nullable(),
  id: z.number().optional(),
  medical_conditions: jsonSchema.optional().nullable(),
  medical_conditions_vote_count: z.number().optional().nullable(),
  name: z.string(),
  similar_strains: jsonSchema.optional().nullable(),
  slug: z.string(),
  species: z.string().optional().nullable(),
  thc_max: z.number().optional().nullable(),
  thc_min: z.number().optional().nullable(),
  updated_at: z.string().optional().nullable(),
});

export const publicTncStrainsWeedmapsUpdateSchemaSchema = z.object({
  aliases: jsonSchema.optional().nullable(),
  avatar_image_url: z.string().optional().nullable(),
  cbd_max: z.number().optional().nullable(),
  cbd_min: z.number().optional().nullable(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  effects: jsonSchema.optional().nullable(),
  effects_vote_count: z.number().optional().nullable(),
  external_id: z.string().optional(),
  featured: z.boolean().optional().nullable(),
  flavors: jsonSchema.optional().nullable(),
  flavors_vote_count: z.number().optional().nullable(),
  genetic_cultivation_description: z.string().optional().nullable(),
  hero_image_url: z.string().optional().nullable(),
  id: z.number().optional(),
  medical_conditions: jsonSchema.optional().nullable(),
  medical_conditions_vote_count: z.number().optional().nullable(),
  name: z.string().optional(),
  similar_strains: jsonSchema.optional().nullable(),
  slug: z.string().optional(),
  species: z.string().optional().nullable(),
  thc_max: z.number().optional().nullable(),
  thc_min: z.number().optional().nullable(),
  updated_at: z.string().optional().nullable(),
});

export const publicTransactionRowSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().nullable(),
  fk_invoice_id: z.number().nullable(),
  fk_invoice_item_id: z.number().nullable(),
  fk_payment_method: z.number().nullable(),
  fk_position_id: z.number().nullable(),
  fk_speculator_id: z.number().nullable(),
  meta_data: jsonSchema.nullable(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
  transaction_account_from: z.string().nullable(),
  transaction_account_to: z.string().nullable(),
  transaction_amount: z.number(),
  transaction_approval_reasoning: z.string().nullable(),
  transaction_id: z.number(),
  transaction_status: publicTransactionStatusSchema,
  transaction_type: publicTransactionTypeSchema,
});

export const publicTransactionInsertSchemaSchema = z.object({
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string(),
  date_removed: z.string().optional().nullable(),
  fk_invoice_id: z.number().optional().nullable(),
  fk_invoice_item_id: z.number().optional().nullable(),
  fk_payment_method: z.number().optional().nullable(),
  fk_position_id: z.number().optional().nullable(),
  fk_speculator_id: z.number().optional().nullable(),
  meta_data: jsonSchema.optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  transaction_account_from: z.string().optional().nullable(),
  transaction_account_to: z.string().optional().nullable(),
  transaction_amount: z.number(),
  transaction_approval_reasoning: z.string().optional().nullable(),
  transaction_id: z.number().optional(),
  transaction_status: publicTransactionStatusSchema,
  transaction_type: publicTransactionTypeSchema,
});

export const publicTransactionUpdateSchemaSchema = z.object({
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional(),
  date_removed: z.string().optional().nullable(),
  fk_invoice_id: z.number().optional().nullable(),
  fk_invoice_item_id: z.number().optional().nullable(),
  fk_payment_method: z.number().optional().nullable(),
  fk_position_id: z.number().optional().nullable(),
  fk_speculator_id: z.number().optional().nullable(),
  meta_data: jsonSchema.optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  transaction_account_from: z.string().optional().nullable(),
  transaction_account_to: z.string().optional().nullable(),
  transaction_amount: z.number().optional(),
  transaction_approval_reasoning: z.string().optional().nullable(),
  transaction_id: z.number().optional(),
  transaction_status: publicTransactionStatusSchema.optional(),
  transaction_type: publicTransactionTypeSchema.optional(),
});

export const publicTransactionRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Transaction_fk_invoice_id_fkey'),
    columns: z.tuple([z.literal('fk_invoice_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Invoices'),
    referencedColumns: z.tuple([z.literal('invoice_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_invoice_item_id_fkey'),
    columns: z.tuple([z.literal('fk_invoice_item_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Invoice_Items'),
    referencedColumns: z.tuple([z.literal('invoice_item_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_payment_method_fkey'),
    columns: z.tuple([z.literal('fk_payment_method')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Payment_Method'),
    referencedColumns: z.tuple([z.literal('payment_method_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_position_id_fkey'),
    columns: z.tuple([z.literal('fk_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('market_available_items'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_position_id_fkey'),
    columns: z.tuple([z.literal('fk_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Position'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_position_id_fkey'),
    columns: z.tuple([z.literal('fk_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('position_detail_stats'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_position_id_fkey'),
    columns: z.tuple([z.literal('fk_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('position_market_info'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_position_id_fkey'),
    columns: z.tuple([z.literal('fk_position_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_positions_summary_view'),
    referencedColumns: z.tuple([z.literal('position_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_from_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_to_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Speculator'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_dashboard_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_position_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_accounts_view'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
]);

export const publicUserProfilesRowSchemaSchema = z.object({
  adn_customer_id: z.string().nullable(),
  billing_info: jsonSchema.nullable(),
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string().nullable(),
  date_of_birth: z.string().nullable(),
  date_removed: z.string().nullable(),
  email: z.string().nullable(),
  id: z.number(),
  modified_by: z.string().nullable(),
  name_first: z.string().nullable(),
  name_last: z.string().nullable(),
  phone: z.string().nullable(),
  removed_by: z.string().nullable(),
  site_type: publicSiteProfileEnumsSchema,
  straddle_customer_id: z.string().nullable(),
  stripe_customer_id: z.string().nullable(),
  uid: z.string(),
  username: z.string().nullable(),
});

export const publicUserProfilesInsertSchemaSchema = z.object({
  adn_customer_id: z.string().optional().nullable(),
  billing_info: jsonSchema.optional().nullable(),
  created_by: z.string(),
  date_created: z.string(),
  date_modified: z.string().optional().nullable(),
  date_of_birth: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  name_first: z.string().optional().nullable(),
  name_last: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  site_type: publicSiteProfileEnumsSchema,
  straddle_customer_id: z.string().optional().nullable(),
  stripe_customer_id: z.string().optional().nullable(),
  uid: z.string().optional(),
  username: z.string().optional().nullable(),
});

export const publicUserProfilesUpdateSchemaSchema = z.object({
  adn_customer_id: z.string().optional().nullable(),
  billing_info: jsonSchema.optional().nullable(),
  created_by: z.string().optional(),
  date_created: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_of_birth: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  id: z.number().optional(),
  modified_by: z.string().optional().nullable(),
  name_first: z.string().optional().nullable(),
  name_last: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  site_type: publicSiteProfileEnumsSchema.optional(),
  straddle_customer_id: z.string().optional().nullable(),
  stripe_customer_id: z.string().optional().nullable(),
  uid: z.string().optional(),
  username: z.string().optional().nullable(),
});

export const publicVAvailableItemsRowSchemaSchema = z.object({
  count: z.number().nullable(),
});

export const publicVAvailableItemsInsertSchemaSchema = z.object({
  count: z.number().optional().nullable(),
});

export const publicVAvailableItemsUpdateSchemaSchema = z.object({
  count: z.number().optional().nullable(),
});

export const publicVerificationRowSchemaSchema = z.object({
  accepted_terms: z.boolean().nullable(),
  created_at: z.string(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  id: z.number(),
  is_kyc_verified: z.boolean().nullable(),
  is_new_user: z.boolean().nullable(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
  user_uid: z.string(),
});

export const publicVerificationInsertSchemaSchema = z.object({
  accepted_terms: z.boolean().optional().nullable(),
  created_at: z.string(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  id: z.number().optional(),
  is_kyc_verified: z.boolean().optional().nullable(),
  is_new_user: z.boolean().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  user_uid: z.string(),
});

export const publicVerificationUpdateSchemaSchema = z.object({
  accepted_terms: z.boolean().optional().nullable(),
  created_at: z.string().optional(),
  date_modified: z.string().optional().nullable(),
  date_removed: z.string().optional().nullable(),
  id: z.number().optional(),
  is_kyc_verified: z.boolean().optional().nullable(),
  is_new_user: z.boolean().optional().nullable(),
  modified_by: z.string().optional().nullable(),
  removed_by: z.string().optional().nullable(),
  user_uid: z.string().optional(),
});

export const publicWeedmapBrandRowSchemaSchema = z.object({
  avatar_image_url: z.string().nullable(),
  description: z.string().nullable(),
  favorites_count: z.number().nullable(),
  id: z.number(),
  name: z.string(),
  slug: z.string(),
});

export const publicWeedmapBrandInsertSchemaSchema = z.object({
  avatar_image_url: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  favorites_count: z.number().optional().nullable(),
  id: z.number(),
  name: z.string(),
  slug: z.string(),
});

export const publicWeedmapBrandUpdateSchemaSchema = z.object({
  avatar_image_url: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  favorites_count: z.number().optional().nullable(),
  id: z.number().optional(),
  name: z.string().optional(),
  slug: z.string().optional(),
});

export const publicWeedmapProductRowSchemaSchema = z.object({
  avatar_image_url: z.string().nullable(),
  batch_id: z.string().nullable(),
  brand_id: z.number().nullable(),
  categories_array: z.array(z.string()).nullable(),
  category_name: z.string().nullable(),
  category_slug: z.string().nullable(),
  cbd: z.number().nullable(),
  cbd_unit: z.string().nullable(),
  created_at: z.string().nullable(),
  edge_category: z.string().nullable(),
  edge_category_ancestor: z.string().nullable(),
  edge_category_ancestor_slug: z.string().nullable(),
  edge_category_slug: z.string().nullable(),
  favorites_count: z.number().nullable(),
  feature_order: z.number().nullable(),
  genetics_tag: z.string().nullable(),
  id: z.number(),
  is_badged: z.boolean().nullable(),
  name: z.string(),
  price: z.number().nullable(),
  price_compliance_net_mg: z.number().nullable(),
  price_discount_label: z.string().nullable(),
  price_label: z.string().nullable(),
  price_max: z.number().nullable(),
  price_min: z.number().nullable(),
  price_on_sale: z.boolean().nullable(),
  price_original: z.number().nullable(),
  price_quantity: z.string().nullable(),
  price_unit: z.string().nullable(),
  price_unit_price: z.number().nullable(),
  rating: z.number().nullable(),
  reviews_count: z.number().nullable(),
  slug: z.string(),
  tag_group: z.array(z.string()).nullable(),
  tags: z.array(z.string()).nullable(),
  thc: z.number().nullable(),
  thc_unit: z.string().nullable(),
  variant_slug: z.string().nullable(),
});

export const publicWeedmapProductInsertSchemaSchema = z.object({
  avatar_image_url: z.string().optional().nullable(),
  batch_id: z.string().optional().nullable(),
  brand_id: z.number().optional().nullable(),
  categories_array: z.array(z.string()).optional().nullable(),
  category_name: z.string().optional().nullable(),
  category_slug: z.string().optional().nullable(),
  cbd: z.number().optional().nullable(),
  cbd_unit: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  edge_category: z.string().optional().nullable(),
  edge_category_ancestor: z.string().optional().nullable(),
  edge_category_ancestor_slug: z.string().optional().nullable(),
  edge_category_slug: z.string().optional().nullable(),
  favorites_count: z.number().optional().nullable(),
  feature_order: z.number().optional().nullable(),
  genetics_tag: z.string().optional().nullable(),
  id: z.number(),
  is_badged: z.boolean().optional().nullable(),
  name: z.string(),
  price: z.number().optional().nullable(),
  price_compliance_net_mg: z.number().optional().nullable(),
  price_discount_label: z.string().optional().nullable(),
  price_label: z.string().optional().nullable(),
  price_max: z.number().optional().nullable(),
  price_min: z.number().optional().nullable(),
  price_on_sale: z.boolean().optional().nullable(),
  price_original: z.number().optional().nullable(),
  price_quantity: z.string().optional().nullable(),
  price_unit: z.string().optional().nullable(),
  price_unit_price: z.number().optional().nullable(),
  rating: z.number().optional().nullable(),
  reviews_count: z.number().optional().nullable(),
  slug: z.string(),
  tag_group: z.array(z.string()).optional().nullable(),
  tags: z.array(z.string()).optional().nullable(),
  thc: z.number().optional().nullable(),
  thc_unit: z.string().optional().nullable(),
  variant_slug: z.string().optional().nullable(),
});

export const publicWeedmapProductUpdateSchemaSchema = z.object({
  avatar_image_url: z.string().optional().nullable(),
  batch_id: z.string().optional().nullable(),
  brand_id: z.number().optional().nullable(),
  categories_array: z.array(z.string()).optional().nullable(),
  category_name: z.string().optional().nullable(),
  category_slug: z.string().optional().nullable(),
  cbd: z.number().optional().nullable(),
  cbd_unit: z.string().optional().nullable(),
  created_at: z.string().optional().nullable(),
  edge_category: z.string().optional().nullable(),
  edge_category_ancestor: z.string().optional().nullable(),
  edge_category_ancestor_slug: z.string().optional().nullable(),
  edge_category_slug: z.string().optional().nullable(),
  favorites_count: z.number().optional().nullable(),
  feature_order: z.number().optional().nullable(),
  genetics_tag: z.string().optional().nullable(),
  id: z.number().optional(),
  is_badged: z.boolean().optional().nullable(),
  name: z.string().optional(),
  price: z.number().optional().nullable(),
  price_compliance_net_mg: z.number().optional().nullable(),
  price_discount_label: z.string().optional().nullable(),
  price_label: z.string().optional().nullable(),
  price_max: z.number().optional().nullable(),
  price_min: z.number().optional().nullable(),
  price_on_sale: z.boolean().optional().nullable(),
  price_original: z.number().optional().nullable(),
  price_quantity: z.string().optional().nullable(),
  price_unit: z.string().optional().nullable(),
  price_unit_price: z.number().optional().nullable(),
  rating: z.number().optional().nullable(),
  reviews_count: z.number().optional().nullable(),
  slug: z.string().optional(),
  tag_group: z.array(z.string()).optional().nullable(),
  tags: z.array(z.string()).optional().nullable(),
  thc: z.number().optional().nullable(),
  thc_unit: z.string().optional().nullable(),
  variant_slug: z.string().optional().nullable(),
});

export const publicWeedmapProductRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('fk_brand'),
    columns: z.tuple([z.literal('brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Weedmap_Brand'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('weedmap_product_brand_id_fkey'),
    columns: z.tuple([z.literal('brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Weedmap_Brand'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicWeedmapsMenuListingsRowSchemaSchema = z.object({
  has_menu: z.boolean().nullable(),
  listing_id: z.number(),
  processed_at: z.string().nullable(),
});

export const publicWeedmapsMenuListingsInsertSchemaSchema = z.object({
  has_menu: z.boolean().optional().nullable(),
  listing_id: z.number(),
  processed_at: z.string().optional().nullable(),
});

export const publicWeedmapsMenuListingsUpdateSchemaSchema = z.object({
  has_menu: z.boolean().optional().nullable(),
  listing_id: z.number().optional(),
  processed_at: z.string().optional().nullable(),
});

export const publicWeedmapsNormalizedListingsRowSchemaSchema = z.object({
  address: z.string().nullable(),
  avatar_original_url: z.string().nullable(),
  avatar_small_url: z.string().nullable(),
  city: z.string().nullable(),
  coordinates: z.string().nullable(),
  country: z.string().nullable(),
  email: z.string().nullable(),
  geog: z.unknown().nullable(),
  last_processed_at: z.string(),
  latitude: z.number().nullable(),
  license_type: z.string().nullable(),
  longitude: z.number().nullable(),
  menu_items_count: z.number().nullable(),
  name: z.string().nullable(),
  online_ordering_delivery: z.boolean().nullable(),
  online_ordering_enabled: z.boolean().nullable(),
  online_ordering_pickup: z.boolean().nullable(),
  open_now: z.boolean().nullable(),
  phone_number: z.string().nullable(),
  rating: z.number().nullable(),
  raw_created_at: z.string().nullable(),
  raw_updated_at: z.string().nullable(),
  retailer_services: jsonSchema.nullable(),
  reviews_count: z.number().nullable(),
  row_id: z.number(),
  slug: z.string().nullable(),
  source_id: z.string(),
  state: z.string().nullable(),
  timezone: z.string().nullable(),
  todays_hours_str: z.string().nullable(),
  type: z.string().nullable(),
  web_url: z.string().nullable(),
  wmid: z.number(),
  zip_code: z.string().nullable(),
});

export const publicWeedmapsNormalizedListingsInsertSchemaSchema = z.object({
  address: z.string().optional().nullable(),
  avatar_original_url: z.string().optional().nullable(),
  avatar_small_url: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  coordinates: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  geog: z.unknown().optional().nullable(),
  last_processed_at: z.string().optional(),
  latitude: z.number().optional().nullable(),
  license_type: z.string().optional().nullable(),
  longitude: z.number().optional().nullable(),
  menu_items_count: z.number().optional().nullable(),
  name: z.string().optional().nullable(),
  online_ordering_delivery: z.boolean().optional().nullable(),
  online_ordering_enabled: z.boolean().optional().nullable(),
  online_ordering_pickup: z.boolean().optional().nullable(),
  open_now: z.boolean().optional().nullable(),
  phone_number: z.string().optional().nullable(),
  rating: z.number().optional().nullable(),
  raw_created_at: z.string().optional().nullable(),
  raw_updated_at: z.string().optional().nullable(),
  retailer_services: jsonSchema.optional().nullable(),
  reviews_count: z.number().optional().nullable(),
  row_id: z.number(),
  slug: z.string().optional().nullable(),
  source_id: z.string(),
  state: z.string().optional().nullable(),
  timezone: z.string().optional().nullable(),
  todays_hours_str: z.string().optional().nullable(),
  type: z.string().optional().nullable(),
  web_url: z.string().optional().nullable(),
  wmid: z.number(),
  zip_code: z.string().optional().nullable(),
});

export const publicWeedmapsNormalizedListingsUpdateSchemaSchema = z.object({
  address: z.string().optional().nullable(),
  avatar_original_url: z.string().optional().nullable(),
  avatar_small_url: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  coordinates: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  geog: z.unknown().optional().nullable(),
  last_processed_at: z.string().optional(),
  latitude: z.number().optional().nullable(),
  license_type: z.string().optional().nullable(),
  longitude: z.number().optional().nullable(),
  menu_items_count: z.number().optional().nullable(),
  name: z.string().optional().nullable(),
  online_ordering_delivery: z.boolean().optional().nullable(),
  online_ordering_enabled: z.boolean().optional().nullable(),
  online_ordering_pickup: z.boolean().optional().nullable(),
  open_now: z.boolean().optional().nullable(),
  phone_number: z.string().optional().nullable(),
  rating: z.number().optional().nullable(),
  raw_created_at: z.string().optional().nullable(),
  raw_updated_at: z.string().optional().nullable(),
  retailer_services: jsonSchema.optional().nullable(),
  reviews_count: z.number().optional().nullable(),
  row_id: z.number().optional(),
  slug: z.string().optional().nullable(),
  source_id: z.string().optional(),
  state: z.string().optional().nullable(),
  timezone: z.string().optional().nullable(),
  todays_hours_str: z.string().optional().nullable(),
  type: z.string().optional().nullable(),
  web_url: z.string().optional().nullable(),
  wmid: z.number().optional(),
  zip_code: z.string().optional().nullable(),
});

export const publicAdminPositionStatsRowSchemaSchema = z.object({
  potentialProfit: z.number().nullable(),
  potentialProfitChange: z.number().nullable(),
  total: z.number().nullable(),
  totalRetailPrice: z.number().nullable(),
});

export const publicAdminStatsRowSchemaSchema = z.object({
  active: z.number().nullable(),
  inactive: z.number().nullable(),
  total: z.number().nullable(),
});

export const publicAdminTransactionsWithSpeculatorsRowSchemaSchema = z.object({
  created_by: z.string().nullable(),
  date_created: z.string().nullable(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_speculator_id: z.number().nullable(),
  meta_data: jsonSchema.nullable(),
  modified_by: z.string().nullable(),
  removed_by: z.string().nullable(),
  speculator_from_email: z.string().nullable(),
  speculator_from_first_name: z.string().nullable(),
  speculator_from_id: z.number().nullable(),
  speculator_from_last_name: z.string().nullable(),
  speculator_to_email: z.string().nullable(),
  speculator_to_first_name: z.string().nullable(),
  speculator_to_id: z.number().nullable(),
  speculator_to_last_name: z.string().nullable(),
  transaction_account_from: z.string().nullable(),
  transaction_account_to: z.string().nullable(),
  transaction_amount: z.number().nullable(),
  transaction_id: z.number().nullable(),
  transaction_status: publicTransactionStatusSchema.nullable(),
  transaction_type: publicTransactionTypeSchema.nullable(),
});

export const publicAdminTransactionsWithSpeculatorsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_from_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_to_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Speculator'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_dashboard_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_position_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Transaction_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_accounts_view'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
]);

export const publicBrandMarketInfoRowSchemaSchema = z.object({
  brand_id: z.number().nullable(),
  similar_distribution_inventory: z.number().nullable(),
  similar_retailer_inventory: z.number().nullable(),
});

export const publicBrandMarketInfoInsertSchemaSchema = z.object({
  brand_id: z.number().optional().nullable(),
  similar_distribution_inventory: z.never().optional(),
  similar_retailer_inventory: z.never().optional(),
});

export const publicBrandMarketInfoUpdateSchemaSchema = z.object({
  brand_id: z.number().optional().nullable(),
  similar_distribution_inventory: z.never().optional(),
  similar_retailer_inventory: z.never().optional(),
});

export const publicBrandStatsRowSchemaSchema = z.object({
  active: z.number().nullable(),
  inactive: z.number().nullable(),
  total: z.number().nullable(),
});

export const publicDataSassBillingHistoryRowSchemaSchema = z.object({
  amount: z.number().nullable(),
  billing_date: z.string().nullable(),
  description: z.string().nullable(),
  item_id: z.number().nullable(),
  item_type: publicDataSassSubscriptionTypesSchema.nullable(),
  payment_status: publicStraddlePaymentStatusSchema.nullable(),
  subscription_id: z.number().nullable(),
});

export const publicDataSassBillingHistoryInsertSchemaSchema = z.object({
  amount: z.number().optional().nullable(),
  billing_date: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  item_id: z.number().optional().nullable(),
  item_type: publicDataSassSubscriptionTypesSchema.optional().nullable(),
  payment_status: publicStraddlePaymentStatusSchema.optional().nullable(),
  subscription_id: z.number().optional().nullable(),
});

export const publicDataSassBillingHistoryUpdateSchemaSchema = z.object({
  amount: z.number().optional().nullable(),
  billing_date: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  item_id: z.number().optional().nullable(),
  item_type: publicDataSassSubscriptionTypesSchema.optional().nullable(),
  payment_status: publicStraddlePaymentStatusSchema.optional().nullable(),
  subscription_id: z.number().optional().nullable(),
});

export const publicDataSassBillingHistoryRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('billing_history_subscription_id_fkey'),
    columns: z.tuple([z.literal('subscription_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('data_sass_subscriptions'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
]);

export const publicDataSassDiscountCodeUsageViewRowSchemaSchema = z.object({
  actual_usage_count: z.number().nullable(),
  code: z.string().nullable(),
  currency: z.string().nullable(),
  description: z.string().nullable(),
  discount_type: publicDataSassDiscountTypesSchema.nullable(),
  discount_value: z.number().nullable(),
  effective_date: z.string().nullable(),
  expiration_date: z.string().nullable(),
  id: z.number().nullable(),
  invalid_reason: z.string().nullable(),
  is_active: z.boolean().nullable(),
  is_valid: z.boolean().nullable(),
  max_uses: z.number().nullable(),
  min_purchase_amount: z.number().nullable(),
  total_discount_amount_applied: z.number().nullable(),
});

export const publicDebugBalanceCalcRowSchemaSchema = z.object({
  hold_amount: z.number().nullable(),
  main_calculation: z.number().nullable(),
  transaction_account_from: z.string().nullable(),
  transaction_account_to: z.string().nullable(),
  transaction_amount: z.number().nullable(),
  transaction_id: z.number().nullable(),
  transaction_type: publicTransactionTypeSchema.nullable(),
  user_uuid: z.string().nullable(),
});

export const publicDistributorStatsRowSchemaSchema = z.object({
  active: z.number().nullable(),
  inactive: z.number().nullable(),
  total: z.number().nullable(),
});

export const publicDutchieListingsViewRowSchemaSchema = z.object({
  address_line1: z.string().nullable(),
  address_line2: z.string().nullable(),
  city: z.string().nullable(),
  created_at: z.string().nullable(),
  delivery_fee: z.number().nullable(),
  delivery_minimum: z.number().nullable(),
  duration_estimates: jsonSchema.nullable(),
  geom: z.unknown().nullable(),
  hours_settings: jsonSchema.nullable(),
  id: z.string().nullable(),
  is_medical: z.boolean().nullable(),
  latitude: z.number().nullable(),
  listing_id: z.string().nullable(),
  longitude: z.number().nullable(),
  name: z.string().nullable(),
  offers_delivery: z.boolean().nullable(),
  offers_pickup: z.boolean().nullable(),
  payment_types: jsonSchema.nullable(),
  row_id: z.number().nullable(),
  special_hours: jsonSchema.nullable(),
  state: z.string().nullable(),
  status: z.string().nullable(),
  timezone: z.string().nullable(),
  updated_at: z.string().nullable(),
  zipcode: z.string().nullable(),
});

export const publicDutchieListingsViewInsertSchemaSchema = z.object({
  address_line1: z.never().optional(),
  address_line2: z.never().optional(),
  city: z.never().optional(),
  created_at: z.string().optional().nullable(),
  delivery_fee: z.never().optional(),
  delivery_minimum: z.never().optional(),
  duration_estimates: z.never().optional(),
  geom: z.never().optional(),
  hours_settings: z.never().optional(),
  id: z.string().optional().nullable(),
  is_medical: z.never().optional(),
  latitude: z.never().optional(),
  listing_id: z.never().optional(),
  longitude: z.never().optional(),
  name: z.never().optional(),
  offers_delivery: z.never().optional(),
  offers_pickup: z.never().optional(),
  payment_types: z.never().optional(),
  row_id: z.number().optional().nullable(),
  special_hours: z.never().optional(),
  state: z.never().optional(),
  status: z.never().optional(),
  timezone: z.never().optional(),
  updated_at: z.string().optional().nullable(),
  zipcode: z.never().optional(),
});

export const publicDutchieListingsViewUpdateSchemaSchema = z.object({
  address_line1: z.never().optional(),
  address_line2: z.never().optional(),
  city: z.never().optional(),
  created_at: z.string().optional().nullable(),
  delivery_fee: z.never().optional(),
  delivery_minimum: z.never().optional(),
  duration_estimates: z.never().optional(),
  geom: z.never().optional(),
  hours_settings: z.never().optional(),
  id: z.string().optional().nullable(),
  is_medical: z.never().optional(),
  latitude: z.never().optional(),
  listing_id: z.never().optional(),
  longitude: z.never().optional(),
  name: z.never().optional(),
  offers_delivery: z.never().optional(),
  offers_pickup: z.never().optional(),
  payment_types: z.never().optional(),
  row_id: z.number().optional().nullable(),
  special_hours: z.never().optional(),
  state: z.never().optional(),
  status: z.never().optional(),
  timezone: z.never().optional(),
  updated_at: z.string().optional().nullable(),
  zipcode: z.never().optional(),
});

export const publicGeographyColumnsRowSchemaSchema = z.object({
  coord_dimension: z.number().nullable(),
  f_geography_column: z.unknown().nullable(),
  f_table_catalog: z.unknown().nullable(),
  f_table_name: z.unknown().nullable(),
  f_table_schema: z.unknown().nullable(),
  srid: z.number().nullable(),
  type: z.string().nullable(),
});

export const publicGeometryColumnsRowSchemaSchema = z.object({
  coord_dimension: z.number().nullable(),
  f_geometry_column: z.unknown().nullable(),
  f_table_catalog: z.string().nullable(),
  f_table_name: z.unknown().nullable(),
  f_table_schema: z.unknown().nullable(),
  srid: z.number().nullable(),
  type: z.string().nullable(),
});

export const publicGeometryColumnsInsertSchemaSchema = z.object({
  coord_dimension: z.number().optional().nullable(),
  f_geometry_column: z.unknown().optional().nullable(),
  f_table_catalog: z.string().optional().nullable(),
  f_table_name: z.unknown().optional().nullable(),
  f_table_schema: z.unknown().optional().nullable(),
  srid: z.number().optional().nullable(),
  type: z.string().optional().nullable(),
});

export const publicGeometryColumnsUpdateSchemaSchema = z.object({
  coord_dimension: z.number().optional().nullable(),
  f_geometry_column: z.unknown().optional().nullable(),
  f_table_catalog: z.string().optional().nullable(),
  f_table_name: z.unknown().optional().nullable(),
  f_table_schema: z.unknown().optional().nullable(),
  srid: z.number().optional().nullable(),
  type: z.string().optional().nullable(),
});

export const publicItemsSummaryRowSchemaSchema = z.object({
  brand_id: z.number().nullable(),
  brand_logo: z.string().nullable(),
  brand_name: z.string().nullable(),
  distributor_inventory: z.number().nullable(),
  distributors: jsonSchema.nullable(),
  markets: jsonSchema.nullable(),
  pending_inventory: z.number().nullable(),
  product_id: z.number().nullable(),
  product_logo: z.string().nullable(),
  product_name: z.string().nullable(),
  retailer_inventory: z.number().nullable(),
  retailers: jsonSchema.nullable(),
  total_items: z.number().nullable(),
});

export const publicItemsWithDistributorOrdersRowSchemaSchema = z.object({
  brand_logo: z.string().nullable(),
  brand_name: z.string().nullable(),
  distributor_name: z.string().nullable(),
  fk_brand_id: z.number().nullable(),
  fk_distributor_id: z.number().nullable(),
  fk_market_id: z.number().nullable(),
  fk_product_id: z.number().nullable(),
  item_count: z.number().nullable(),
  market_name: z.string().nullable(),
  product_logo: z.string().nullable(),
  product_name: z.string().nullable(),
});

export const publicItemsWithDistributorOrdersRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Brand'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('brand_market_info'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_market_id_fkey'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Product'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('product_market_info'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('shop_available_retail_products'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_fk_distributor_id_fkey'),
    columns: z.tuple([z.literal('fk_distributor_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Distributor'),
    referencedColumns: z.tuple([z.literal('distributor_id')]),
  }),
]);

export const publicItemsWithPackageAndOrderRowSchemaSchema = z.object({
  fk_distributor_id: z.number().nullable(),
  fk_distributor_metric_package_id: z.number().nullable(),
  fk_metrc_item_id: z.number().nullable(),
  fk_retailer_id: z.number().nullable(),
  fk_retailer_metric_package_id: z.number().nullable(),
  item_id: z.number().nullable(),
  order_status: publicOrderStatusSchema.nullable(),
  order_type: publicOrdertypeSchema.nullable(),
});

export const publicItemsWithPackageAndOrderRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('fk_distributor_metric_package'),
    columns: z.tuple([z.literal('fk_distributor_metric_package_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Metric_Packages'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('fk_retailer_metric_package'),
    columns: z.tuple([z.literal('fk_retailer_metric_package_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Metric_Packages'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_metrc_item_id_fkey'),
    columns: z.tuple([z.literal('fk_metrc_item_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Metrc_Items'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_fk_distributor_id_fkey'),
    columns: z.tuple([z.literal('fk_distributor_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Distributor'),
    referencedColumns: z.tuple([z.literal('distributor_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Retailer'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
]);

export const publicMarketAvailableItemsRowSchemaSchema = z.object({
  brand_id: z.number().nullable(),
  brand_logo: z.string().nullable(),
  brand_name: z.string().nullable(),
  distribution_quantity: z.number().nullable(),
  factored_price: z.number().nullable(),
  item_quantity: z.number().nullable(),
  market_id: z.number().nullable(),
  market_name: z.string().nullable(),
  market_price: z.number().nullable(),
  pending_quantity: z.number().nullable(),
  position_id: z.number().nullable(),
  position_item_unit_factored_cost: z.number().nullable(),
  position_item_unit_market_cost: z.number().nullable(),
  position_status: publicPositionStatusSchema.nullable(),
  product_id: z.number().nullable(),
  product_logo: z.string().nullable(),
  product_name: z.string().nullable(),
  retail_quantity: z.number().nullable(),
});

export const publicMarketAvailableItemsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Brand'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('brand_market_info'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_market_id_fkey'),
    columns: z.tuple([z.literal('market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Product'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('product_market_info'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('shop_available_retail_products'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
]);

export const publicMarketDepthViewRowSchemaSchema = z.object({
  cumulative_quantity: z.number().nullable(),
  fk_market_id: z.number().nullable(),
  fk_product_id: z.number().nullable(),
  position_id: z.number().nullable(),
  position_order_type: publicPositionExchangeOrderTypesSchema.nullable(),
  price: z.number().nullable(),
  quantity: z.number().nullable(),
});

export const publicMarketStatsRowSchemaSchema = z.object({
  active: z.number().nullable(),
  inactive: z.number().nullable(),
  total: z.number().nullable(),
});

export const publicOrdersWithItemCountRowSchemaSchema = z.object({
  created_by: z.string().nullable(),
  date_created: z.string().nullable(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_distributor_id: z.number().nullable(),
  fk_market_id: z.number().nullable(),
  fk_retailer_id: z.number().nullable(),
  modified_by: z.string().nullable(),
  order_accepted_timestamp: z.string().nullable(),
  order_balance: z.number().nullable(),
  order_cancel_reason: z.string().nullable(),
  order_closed_timestamp: z.string().nullable(),
  order_delivery_address: z.string().nullable(),
  order_delivery_address2: z.string().nullable(),
  order_delivery_city: z.string().nullable(),
  order_delivery_postal_code: z.string().nullable(),
  order_delivery_state: z.string().nullable(),
  order_id: z.number().nullable(),
  order_in_progress_timestamp: z.string().nullable(),
  order_item_count: z.number().nullable(),
  order_payment_method: publicOrderPaymentMethodSchema.nullable(),
  order_payment_received: z.boolean().nullable(),
  order_payment_terms: publicOrderPaymentTermsSchema.nullable(),
  order_pending_timestamp: z.string().nullable(),
  order_reject_reason: z.string().nullable(),
  order_rejected_timestamp: z.string().nullable(),
  order_status: publicOrderStatusSchema.nullable(),
  order_type: publicOrdertypeSchema.nullable(),
  removed_by: z.string().nullable(),
});

export const publicOrdersWithItemCountRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Order_fk_distributor_id_fkey'),
    columns: z.tuple([z.literal('fk_distributor_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Distributor'),
    referencedColumns: z.tuple([z.literal('distributor_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_fk_market_id_fkey'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Retailer'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_fk_retailer_id_fkey'),
    columns: z.tuple([z.literal('fk_retailer_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('retailer_id')]),
  }),
]);

export const publicPositionDetailStatsRowSchemaSchema = z.object({
  brand_daily_volume: z.number().nullable(),
  brand_monthly_volume: z.number().nullable(),
  distribution_inventory: z.number().nullable(),
  factored_margin: z.number().nullable(),
  margin: z.number().nullable(),
  market_daily_volume: z.number().nullable(),
  market_monthly_volume: z.number().nullable(),
  pending_inventory: z.number().nullable(),
  position_id: z.number().nullable(),
  position_paid: z.number().nullable(),
  position_total: z.number().nullable(),
  position_type: publicPositionExchangeOrderTypesSchema.nullable(),
  product_buy_sell_price: z.number().nullable(),
  product_daily_volume: z.number().nullable(),
  product_factored_price: z.number().nullable(),
  product_monthly_volume: z.number().nullable(),
  purchased_items: z.number().nullable(),
  retail_inventory: z.number().nullable(),
  sold_items: z.number().nullable(),
  transfer_totals: z.number().nullable(),
  unfilled_items: z.number().nullable(),
});

export const publicPositionMarketInfoRowSchemaSchema = z.object({
  fk_market_id: z.number().nullable(),
  fk_product_id: z.number().nullable(),
  position_id: z.number().nullable(),
  similar_distribution_inventory: z.number().nullable(),
  similar_market_items: z.number().nullable(),
  similar_retailer_inventory: z.number().nullable(),
});

export const publicPositionMarketInfoInsertSchemaSchema = z.object({
  fk_market_id: z.number().optional().nullable(),
  fk_product_id: z.number().optional().nullable(),
  position_id: z.number().optional().nullable(),
  similar_distribution_inventory: z.never().optional(),
  similar_market_items: z.never().optional(),
  similar_retailer_inventory: z.never().optional(),
});

export const publicPositionMarketInfoUpdateSchemaSchema = z.object({
  fk_market_id: z.number().optional().nullable(),
  fk_product_id: z.number().optional().nullable(),
  position_id: z.number().optional().nullable(),
  similar_distribution_inventory: z.never().optional(),
  similar_market_items: z.never().optional(),
  similar_retailer_inventory: z.never().optional(),
});

export const publicPositionMarketInfoRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Position_fk_market_id_fkey'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Product'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('product_market_info'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('shop_available_retail_products'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
]);

export const publicProductMarketInfoRowSchemaSchema = z.object({
  product_id: z.number().nullable(),
  similar_distribution_inventory: z.number().nullable(),
  similar_market_items: z.number().nullable(),
  similar_retailer_inventory: z.number().nullable(),
});

export const publicProductMarketInfoInsertSchemaSchema = z.object({
  product_id: z.number().optional().nullable(),
  similar_distribution_inventory: z.never().optional(),
  similar_market_items: z.never().optional(),
  similar_retailer_inventory: z.never().optional(),
});

export const publicProductMarketInfoUpdateSchemaSchema = z.object({
  product_id: z.number().optional().nullable(),
  similar_distribution_inventory: z.never().optional(),
  similar_market_items: z.never().optional(),
  similar_retailer_inventory: z.never().optional(),
});

export const publicProductStatsRowSchemaSchema = z.object({
  active: z.number().nullable(),
  inactive: z.number().nullable(),
  total: z.number().nullable(),
});

export const publicRetailOrderAvailableItemsRowSchemaSchema = z.object({
  brand_logo: z.string().nullable(),
  brand_name: z.string().nullable(),
  distributor_name: z.string().nullable(),
  fk_brand_id: z.number().nullable(),
  fk_distributor_id: z.number().nullable(),
  fk_market_id: z.number().nullable(),
  fk_product_id: z.number().nullable(),
  item_count: z.number().nullable(),
  market_name: z.string().nullable(),
  product_logo: z.string().nullable(),
  product_name: z.string().nullable(),
});

export const publicRetailOrderAvailableItemsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Brand'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('brand_market_info'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_market_id_fkey'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Product'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('product_market_info'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Item_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('shop_available_retail_products'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Order_fk_distributor_id_fkey'),
    columns: z.tuple([z.literal('fk_distributor_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Distributor'),
    referencedColumns: z.tuple([z.literal('distributor_id')]),
  }),
]);

export const publicRetailerInventoryRowSchemaSchema = z.object({
  brand_id: z.number().nullable(),
  brand_logo: z.string().nullable(),
  brand_name: z.string().nullable(),
  product_category: z.string().nullable(),
  product_cbd_content: z.string().nullable(),
  product_cbd_content_unit: publicProductContentUnitSchema.nullable(),
  product_display_name: z.string().nullable(),
  product_flavor: z.string().nullable(),
  product_id: z.number().nullable(),
  product_is_cannabis: z.boolean().nullable(),
  product_logo: z.string().nullable(),
  product_med_price: z.number().nullable(),
  product_name: z.string().nullable(),
  product_rec_price: z.number().nullable(),
  product_strain: z.string().nullable(),
  product_subcategory: z.string().nullable(),
  product_tags: jsonSchema.nullable(),
  product_thc_content: z.number().nullable(),
  product_thc_content_unit: publicProductContentUnitSchema.nullable(),
  product_wholesale_price: z.number().nullable(),
  retailer_address: z.string().nullable(),
  retailer_city: z.string().nullable(),
  retailer_email: z.string().nullable(),
  retailer_id: z.number().nullable(),
  retailer_item_count: z.number().nullable(),
  retailer_license_number: z.string().nullable(),
  retailer_name: z.string().nullable(),
  retailer_phone: z.string().nullable(),
  retailer_postal_code: z.string().nullable(),
  retailer_state: z.string().nullable(),
  retailer_status: publicRetailerstatusSchema.nullable(),
});

export const publicRetailerStatsRowSchemaSchema = z.object({
  active: z.number().nullable(),
  inactive: z.number().nullable(),
  total: z.number().nullable(),
});

export const publicShopAvailableRetailProductsRowSchemaSchema = z.object({
  created_by: z.string().nullable(),
  date_created: z.string().nullable(),
  date_modified: z.string().nullable(),
  date_removed: z.string().nullable(),
  fk_brand_id: z.number().nullable(),
  fk_weedmap_brand_id: z.number().nullable(),
  fk_weedmap_product_id: z.number().nullable(),
  genetics_tag: z.string().nullable(),
  modified_by: z.string().nullable(),
  product_ancestor_category: z.string().nullable(),
  product_categories: z.array(z.string()).nullable(),
  product_category: z.string().nullable(),
  product_cbd_content: z.string().nullable(),
  product_cbd_content_unit: publicProductContentUnitSchema.nullable(),
  product_display_name: z.string().nullable(),
  product_factored_price: z.number().nullable(),
  product_flavor: z.string().nullable(),
  product_groups: z.array(z.string()).nullable(),
  product_id: z.number().nullable(),
  product_image_url: z.string().nullable(),
  product_is_active: z.boolean().nullable(),
  product_is_cannabis: z.boolean().nullable(),
  product_med_price: z.number().nullable(),
  product_name: z.string().nullable(),
  product_rec_price: z.number().nullable(),
  product_strain: z.string().nullable(),
  product_subcategory: z.string().nullable(),
  product_tags: jsonSchema.nullable(),
  product_thc_content: z.number().nullable(),
  product_thc_content_unit: publicProductContentUnitSchema.nullable(),
  product_unit_type: publicProductContentUnitSchema.nullable(),
  product_wholesale_price: z.number().nullable(),
  removed_by: z.string().nullable(),
});

export const publicShopAvailableRetailProductsRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('fk_weedmap_product'),
    columns: z.tuple([z.literal('fk_weedmap_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Weedmap_Product'),
    referencedColumns: z.tuple([z.literal('id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Brand'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('brand_market_info'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Product_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
]);

export const publicSpeculatorDashboardPositionProductsAggViewRowSchemaSchema = z.object({
  brand_logo_url: z.string().nullable(),
  brand_name: z.string().nullable(),
  distributor_inventory_count: z.number().nullable(),
  pending_inventory_count: z.number().nullable(),
  product_id: z.number().nullable(),
  product_logo: z.string().nullable(),
  product_name: z.string().nullable(),
  retailer_inventory_count: z.number().nullable(),
  speculator_id: z.number().nullable(),
});

export const publicSpeculatorDashboardPositionProductsAggViewRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Product'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('product_market_info'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('shop_available_retail_products'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_from_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_to_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Speculator'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_dashboard_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_position_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_accounts_view'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
]);

export const publicSpeculatorDashboardStatsRowSchemaSchema = z.object({
  active_items: z.number().nullable(),
  active_positions: z.number().nullable(),
  buy_positions: z.number().nullable(),
  closed_buy_positions: z.number().nullable(),
  closed_positions: z.number().nullable(),
  closed_sell_positions: z.number().nullable(),
  distributor_count: z.number().nullable(),
  distributor_inventory: z.number().nullable(),
  retailer_count: z.number().nullable(),
  retailer_inventory: z.number().nullable(),
  sell_positions: z.number().nullable(),
  speculator_id: z.number().nullable(),
  speculator_uid: z.string().nullable(),
  total_positions: z.number().nullable(),
});

export const publicSpeculatorDashboardStatsInsertSchemaSchema = z.object({
  active_items: z.never().optional(),
  active_positions: z.never().optional(),
  buy_positions: z.never().optional(),
  closed_buy_positions: z.never().optional(),
  closed_positions: z.never().optional(),
  closed_sell_positions: z.never().optional(),
  distributor_count: z.never().optional(),
  distributor_inventory: z.never().optional(),
  retailer_count: z.never().optional(),
  retailer_inventory: z.never().optional(),
  sell_positions: z.never().optional(),
  speculator_id: z.number().optional().nullable(),
  speculator_uid: z.string().optional().nullable(),
  total_positions: z.never().optional(),
});

export const publicSpeculatorDashboardStatsUpdateSchemaSchema = z.object({
  active_items: z.never().optional(),
  active_positions: z.never().optional(),
  buy_positions: z.never().optional(),
  closed_buy_positions: z.never().optional(),
  closed_positions: z.never().optional(),
  closed_sell_positions: z.never().optional(),
  distributor_count: z.never().optional(),
  distributor_inventory: z.never().optional(),
  retailer_count: z.never().optional(),
  retailer_inventory: z.never().optional(),
  sell_positions: z.never().optional(),
  speculator_id: z.number().optional().nullable(),
  speculator_uid: z.string().optional().nullable(),
  total_positions: z.never().optional(),
});

export const publicSpeculatorItemStatsRowSchemaSchema = z.object({
  active: z.number().nullable(),
  inactive: z.number().nullable(),
  total: z.number().nullable(),
});

export const publicSpeculatorPositionStatsRowSchemaSchema = z.object({
  potentialprofit: z.number().nullable(),
  potentialprofitchange: z.number().nullable(),
  speculator_id: z.number().nullable(),
  total: z.number().nullable(),
  totalretailprice: z.number().nullable(),
});

export const publicSpeculatorPositionStatsInsertSchemaSchema = z.object({
  potentialprofit: z.never().optional(),
  potentialprofitchange: z.never().optional(),
  speculator_id: z.number().optional().nullable(),
  total: z.never().optional(),
  totalretailprice: z.never().optional(),
});

export const publicSpeculatorPositionStatsUpdateSchemaSchema = z.object({
  potentialprofit: z.never().optional(),
  potentialprofitchange: z.never().optional(),
  speculator_id: z.number().optional().nullable(),
  total: z.never().optional(),
  totalretailprice: z.never().optional(),
});

export const publicSpeculatorPositionsSummaryViewRowSchemaSchema = z.object({
  brand_logo_url: z.string().nullable(),
  brand_name: z.string().nullable(),
  date_created: z.string().nullable(),
  date_modified: z.string().nullable(),
  fk_brand_id: z.number().nullable(),
  fk_market_id: z.number().nullable(),
  fk_product_id: z.number().nullable(),
  fk_speculator_id: z.number().nullable(),
  market_name: z.string().nullable(),
  position_balance: z.number().nullable(),
  position_factored_price_total: z.number().nullable(),
  position_id: z.number().nullable(),
  position_is_filled: z.boolean().nullable(),
  position_item_quantity: z.number().nullable(),
  position_item_unit_market_cost: z.number().nullable(),
  position_order_remaining_quantity: z.number().nullable(),
  position_order_sub_type: z.string().nullable(),
  position_order_type: z.string().nullable(),
  position_price: z.number().nullable(),
  position_status: z.string().nullable(),
  postion_margin_total: z.number().nullable(),
  product_image_url: z.string().nullable(),
  product_name: z.string().nullable(),
});

export const publicSpeculatorPositionsSummaryViewRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Brand'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('brand_market_info'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_brand_id_fkey'),
    columns: z.tuple([z.literal('fk_brand_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('brand_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_market_id_fkey'),
    columns: z.tuple([z.literal('fk_market_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Market'),
    referencedColumns: z.tuple([z.literal('market_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('items_summary'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Product'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('product_market_info'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('retailer_inventory'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_product_id_fkey'),
    columns: z.tuple([z.literal('fk_product_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('shop_available_retail_products'),
    referencedColumns: z.tuple([z.literal('product_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_from_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_to_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Speculator'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_dashboard_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_position_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Position_fk_speculator_id_fkey'),
    columns: z.tuple([z.literal('fk_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_accounts_view'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
]);

export const publicSpeculatorStatsRowSchemaSchema = z.object({
  active: z.number().nullable(),
  inactive: z.number().nullable(),
  total: z.number().nullable(),
});

export const publicTncBrandsViewRowSchemaSchema = z.object({
  alias_ids: z.array(z.number()).nullable(),
  alias_names: z.array(z.string()).nullable(),
  brand_count: z.number().nullable(),
  master_id: z.number().nullable(),
  master_name: z.string().nullable(),
  platforms: z.array(z.string()).nullable(),
});

export const publicUserAccountBalancesRowSchemaSchema = z.object({
  available_balance: z.number().nullable(),
  held_balance: z.number().nullable(),
  total_deducted_funds: z.number().nullable(),
  total_earned_funds: z.number().nullable(),
  total_held_funds: z.number().nullable(),
  total_release_holds: z.number().nullable(),
  user_uuid: z.string().nullable(),
});

export const publicUserAccountsViewRowSchemaSchema = z.object({
  accepted_terms: z.boolean().nullable(),
  admin_id: z.number().nullable(),
  admin_role: z.string().nullable(),
  admin_speculator_id: z.number().nullable(),
  brands: jsonSchema.nullable(),
  date_created: z.string().nullable(),
  date_removed: z.string().nullable(),
  distributors: jsonSchema.nullable(),
  is_kyc_verified: z.boolean().nullable(),
  is_new_user: z.boolean().nullable(),
  retailers: jsonSchema.nullable(),
  speculator_address: z.string().nullable(),
  speculator_address2: z.string().nullable(),
  speculator_city: z.string().nullable(),
  speculator_country: z.string().nullable(),
  speculator_dob: z.string().nullable(),
  speculator_email: z.string().nullable(),
  speculator_id: z.number().nullable(),
  speculator_kyc: z.string().nullable(),
  speculator_last_login: z.string().nullable(),
  speculator_name_first: z.string().nullable(),
  speculator_name_last: z.string().nullable(),
  speculator_phone: z.string().nullable(),
  speculator_postal_code: z.string().nullable(),
  speculator_preferred_language: z.string().nullable(),
  speculator_profile_image_url: z.string().nullable(),
  speculator_state: z.string().nullable(),
  speculator_status: z.string().nullable(),
  speculator_stripe_customer_id: z.string().nullable(),
  speculator_timezone: z.string().nullable(),
  speculator_two_factor_enabled: z.boolean().nullable(),
  speculator_username: z.string().nullable(),
  super_admin_created_at: z.string().nullable(),
  super_admin_created_by: z.string().nullable(),
  super_admin_date_removed: z.string().nullable(),
  super_admin_id: z.number().nullable(),
  super_admin_modified_by: z.string().nullable(),
  super_admin_removed_by: z.string().nullable(),
  uid: z.string().nullable(),
  verification_created_at: z.string().nullable(),
  verification_date_modified: z.string().nullable(),
  verification_date_removed: z.string().nullable(),
});

export const publicUserAccountsViewRelationshipsSchemaSchema = z.tuple([
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_from_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('admin_transactions_with_speculators'),
    referencedColumns: z.tuple([z.literal('speculator_to_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('Speculator'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_dashboard_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('speculator_position_stats'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
  z.object({
    foreignKeyName: z.literal('Admin_admin_speculator_id_fkey'),
    columns: z.tuple([z.literal('admin_speculator_id')]),
    isOneToOne: z.literal(false),
    referencedRelation: z.literal('user_accounts_view'),
    referencedColumns: z.tuple([z.literal('speculator_id')]),
  }),
]);

export const publicWeedmapsBrandsRowSchemaSchema = z.object({
  avatar_large_url: z.string().nullable(),
  avatar_medium_url: z.string().nullable(),
  avatar_original_url: z.string().nullable(),
  avatar_small_url: z.string().nullable(),
  badges: jsonSchema.nullable(),
  batch_id: z.string().nullable(),
  best_of_weedmaps: z.boolean().nullable(),
  best_of_weedmaps_nominee: z.boolean().nullable(),
  best_of_weedmaps_nominee_years: jsonSchema.nullable(),
  best_of_weedmaps_years: jsonSchema.nullable(),
  brand_id: z.string().nullable(),
  brand_name: z.string().nullable(),
  brand_slug: z.string().nullable(),
  bucket: jsonSchema.nullable(),
  created_at: z.string().nullable(),
  document: jsonSchema.nullable(),
  favorites_count: z.number().nullable(),
  id: z.string().nullable(),
  in_region: z.boolean().nullable(),
  is_claimed: z.boolean().nullable(),
  is_premium: z.boolean().nullable(),
  nearby_deals_count: z.number().nullable(),
  position: z.number().nullable(),
  preferred_organizations: jsonSchema.nullable(),
  products_count: z.number().nullable(),
  rating: z.number().nullable(),
  reviews_count: z.number().nullable(),
  row_id: z.number().nullable(),
  timestamp: z.string().nullable(),
  timestamp_str: z.string().nullable(),
  total_products_count: z.number().nullable(),
  updated_at: z.string().nullable(),
});

export const publicWeedmapsDealsRowSchemaSchema = z.object({
  created_at: z.string().nullable(),
  doc_batch_id: z.string().nullable(),
  doc_body: z.string().nullable(),
  doc_brand_ids: jsonSchema.nullable(),
  doc_categories: jsonSchema.nullable(),
  doc_claimed_count: z.number().nullable(),
  doc_deal_date_id: z.number().nullable(),
  doc_deal_type: z.string().nullable(),
  doc_discount: z.string().nullable(),
  doc_expires_in: z.number().nullable(),
  doc_first_time_customer: z.boolean().nullable(),
  doc_id: z.number().nullable(),
  doc_likes_count: z.number().nullable(),
  doc_menu_item_category_id: z.number().nullable(),
  doc_menu_item_category_names: jsonSchema.nullable(),
  doc_menu_item_id: z.number().nullable(),
  doc_menu_item_ids: jsonSchema.nullable(),
  doc_picture: jsonSchema.nullable(),
  doc_price_rule: z.string().nullable(),
  doc_seconds_to_midnight: z.number().nullable(),
  doc_slug: z.string().nullable(),
  doc_storewide: z.boolean().nullable(),
  doc_title: z.string().nullable(),
  doc_ts: z.string().nullable(),
  geom: z.unknown().nullable(),
  id: z.string().nullable(),
  listing_avatar_image: jsonSchema.nullable(),
  listing_best_of_weedmaps: z.boolean().nullable(),
  listing_best_of_weedmaps_nominee: z.boolean().nullable(),
  listing_best_of_weedmaps_nominee_years: jsonSchema.nullable(),
  listing_best_of_weedmaps_years: jsonSchema.nullable(),
  listing_city: z.string().nullable(),
  listing_deals_enabled: z.boolean().nullable(),
  listing_distance: z.number().nullable(),
  listing_id: z.number().nullable(),
  listing_is_brand_preferred_listing: z.boolean().nullable(),
  listing_is_published: z.boolean().nullable(),
  listing_latitude: z.number().nullable(),
  listing_license_type: z.string().nullable(),
  listing_listing_type: z.string().nullable(),
  listing_longitude: z.number().nullable(),
  listing_name: z.string().nullable(),
  listing_online_ordering: jsonSchema.nullable(),
  listing_package_level: z.string().nullable(),
  listing_preferred_organization_position: z.string().nullable(),
  listing_rating: z.number().nullable(),
  listing_region_id: z.number().nullable(),
  listing_region_name: z.string().nullable(),
  listing_region_nested_name: z.string().nullable(),
  listing_region_slug: z.string().nullable(),
  listing_retailer_services: jsonSchema.nullable(),
  listing_reviews_count: z.number().nullable(),
  listing_slug: z.string().nullable(),
  listing_state: z.string().nullable(),
  listing_web_url: z.string().nullable(),
  listing_wmid: z.number().nullable(),
  row_id: z.number().nullable(),
  updated_at: z.string().nullable(),
});

export const publicWeedmapsListingsGeoViewRowSchemaSchema = z.object({
  accepts_credit_cards: z.boolean().nullable(),
  address: z.string().nullable(),
  avatar_original_url: z.string().nullable(),
  avatar_small_url: z.string().nullable(),
  batch_id: z.string().nullable(),
  best_of_weedmaps: z.boolean().nullable(),
  city: z.string().nullable(),
  coordinates: z.string().nullable(),
  country: z.string().nullable(),
  created_at: z.string().nullable(),
  distance: z.number().nullable(),
  email: z.string().nullable(),
  endorsement_badge_count: z.number().nullable(),
  feature_order: z.number().nullable(),
  geom: z.unknown().nullable(),
  has_age_gate: z.boolean().nullable(),
  has_curbside_pickup: z.boolean().nullable(),
  has_featured_deal: z.boolean().nullable(),
  has_sale_items: z.boolean().nullable(),
  id: z.string().nullable(),
  intro_body: z.string().nullable(),
  is_published: z.boolean().nullable(),
  latitude: z.number().nullable(),
  license_type: z.string().nullable(),
  listing_id: z.number().nullable(),
  longitude: z.number().nullable(),
  menu_id: z.number().nullable(),
  menu_items_count: z.number().nullable(),
  min_age: z.string().nullable(),
  name: z.string().nullable(),
  online_ordering_enabled: z.boolean().nullable(),
  online_ordering_eta_max: z.number().nullable(),
  online_ordering_eta_min: z.number().nullable(),
  online_ordering_json: jsonSchema.nullable(),
  open_now: z.boolean().nullable(),
  package_level: z.string().nullable(),
  phone_number: z.string().nullable(),
  ranking: z.number().nullable(),
  rating: z.number().nullable(),
  region_id: z.number().nullable(),
  retailer_services: jsonSchema.nullable(),
  reviews_count: z.number().nullable(),
  row_id: z.number().nullable(),
  slug: z.string().nullable(),
  social_equity: z.boolean().nullable(),
  state: z.string().nullable(),
  timezone: z.string().nullable(),
  todays_hours_str: z.string().nullable(),
  top_deals_count: z.number().nullable(),
  type: z.string().nullable(),
  updated_at: z.string().nullable(),
  web_url: z.string().nullable(),
  wmid: z.number().nullable(),
  zip_code: z.string().nullable(),
});

export const publicWeedmapsMenuGeoViewRowSchemaSchema = z.object({
  avatar_image_url: z.string().nullable(),
  batch: z.string().nullable(),
  brand_avatar_image_url: z.string().nullable(),
  brand_best_of_weedmaps: z.boolean().nullable(),
  brand_best_of_weedmaps_nominee: z.boolean().nullable(),
  brand_best_of_weedmaps_nominee_years: jsonSchema.nullable(),
  brand_best_of_weedmaps_years: jsonSchema.nullable(),
  brand_id: z.number().nullable(),
  brand_name: z.string().nullable(),
  brand_product_id: z.number().nullable(),
  brand_product_name: z.string().nullable(),
  brand_product_slug: z.string().nullable(),
  brand_slug: z.string().nullable(),
  cannabinoids_json: jsonSchema.nullable(),
  catalog_slug: z.string().nullable(),
  category_id: z.number().nullable(),
  category_name: z.string().nullable(),
  category_slug: z.string().nullable(),
  cbd_unit: z.string().nullable(),
  cbd_value: z.number().nullable(),
  cbg_unit: z.string().nullable(),
  cbg_value: z.number().nullable(),
  cbn_unit: z.string().nullable(),
  cbn_value: z.number().nullable(),
  compliance_net_mg: z.number().nullable(),
  created_at: z.string().nullable(),
  current_deal_title: z.string().nullable(),
  dispensary_address: z.string().nullable(),
  dispensary_city: z.string().nullable(),
  dispensary_country: z.string().nullable(),
  dispensary_email: z.string().nullable(),
  dispensary_image_url: z.string().nullable(),
  dispensary_latitude: z.number().nullable(),
  dispensary_longitude: z.number().nullable(),
  dispensary_name: z.string().nullable(),
  dispensary_phone: z.string().nullable(),
  dispensary_rating: z.number().nullable(),
  dispensary_slug: z.string().nullable(),
  dispensary_state: z.string().nullable(),
  dispensary_type: z.string().nullable(),
  dispensary_wmid: z.number().nullable(),
  dispensary_zip: z.string().nullable(),
  edge_category_ancestors: jsonSchema.nullable(),
  edge_category_name: z.string().nullable(),
  edge_category_slug: z.string().nullable(),
  edge_category_uuid: z.string().nullable(),
  external_ids: z.string().nullable(),
  genetics_name: z.string().nullable(),
  genetics_uuid: z.string().nullable(),
  geom: z.unknown().nullable(),
  gram_array_label_1: z.string().nullable(),
  gram_array_price_1: z.number().nullable(),
  gram_array_units_1: z.number().nullable(),
  gram_compliance_net_mg: z.number().nullable(),
  gram_label: z.string().nullable(),
  gram_on_sale: z.boolean().nullable(),
  gram_original_price: z.number().nullable(),
  gram_price: z.number().nullable(),
  gram_units: z.number().nullable(),
  grams_per_eighth: z.number().nullable(),
  id: z.string().nullable(),
  is_delivery: z.boolean().nullable(),
  is_product_online_orderable: z.boolean().nullable(),
  lab_avatar_original_url: z.string().nullable(),
  lab_avatar_small_url: z.string().nullable(),
  lab_website: z.string().nullable(),
  last_ordered_date: z.string().nullable(),
  license_type: z.string().nullable(),
  listing_id: z.number().nullable(),
  menu_id: z.number().nullable(),
  min_age: z.string().nullable(),
  on_sale: z.boolean().nullable(),
  ordered_from: z.boolean().nullable(),
  original_price: z.number().nullable(),
  ounce_array_label_1: z.string().nullable(),
  ounce_array_price_1: z.number().nullable(),
  ounce_array_units_1: z.number().nullable(),
  ounce_compliance_net_mg: z.number().nullable(),
  ounce_label: z.string().nullable(),
  ounce_on_sale: z.boolean().nullable(),
  ounce_original_price: z.number().nullable(),
  ounce_price: z.number().nullable(),
  ounce_units: z.number().nullable(),
  price: z.number().nullable(),
  price_label: z.string().nullable(),
  price_visibility: z.string().nullable(),
  price_visibility_description: z.string().nullable(),
  price_visibility_title: z.string().nullable(),
  prices_json: jsonSchema.nullable(),
  product_created_at: z.string().nullable(),
  product_id: z.number().nullable(),
  product_name: z.string().nullable(),
  product_reviews_count: z.number().nullable(),
  product_slug: z.string().nullable(),
  product_updated_at: z.string().nullable(),
  quantity: z.string().nullable(),
  rating: z.number().nullable(),
  retailer_services: jsonSchema.nullable(),
  tags_json: jsonSchema.nullable(),
  terpenes_json: jsonSchema.nullable(),
  terpenes_unit: z.string().nullable(),
  terpenes_value: z.number().nullable(),
  test_result_created_at: z.string().nullable(),
  test_result_expired: z.boolean().nullable(),
  test_result_expires_in: z.string().nullable(),
  thc_unit: z.string().nullable(),
  thc_value: z.number().nullable(),
  timezone: z.string().nullable(),
  unit: z.string().nullable(),
  unit_compliance_net_mg: z.number().nullable(),
  unit_label: z.string().nullable(),
  unit_on_sale: z.boolean().nullable(),
  unit_original_price: z.number().nullable(),
  unit_price: z.number().nullable(),
  unit_units: z.number().nullable(),
  updated_at: z.string().nullable(),
});

export const publicWeedmapsProductsRowSchemaSchema = z.object({
  affiliate_link: z.string().nullable(),
  available_for_delivery: z.boolean().nullable(),
  available_for_pickup: z.boolean().nullable(),
  avatar_image_url: z.string().nullable(),
  batch_id: z.string().nullable(),
  brand_avatar_url: z.string().nullable(),
  brand_description: z.string().nullable(),
  brand_favorites_count: z.number().nullable(),
  brand_id: z.string().nullable(),
  brand_name: z.string().nullable(),
  brand_slug: z.string().nullable(),
  categories: jsonSchema.nullable(),
  cbd_percentage: z.number().nullable(),
  cbd_unit: z.string().nullable(),
  created_at: z.string().nullable(),
  current_deal_title: z.string().nullable(),
  deal_ids: jsonSchema.nullable(),
  discount_label: z.string().nullable(),
  document: jsonSchema.nullable(),
  favorites_count: z.number().nullable(),
  id: z.string().nullable(),
  is_badged: z.boolean().nullable(),
  is_on_sale: z.boolean().nullable(),
  listing_distance: z.number().nullable(),
  listing_license_type: z.string().nullable(),
  listing_name: z.string().nullable(),
  listing_region_id: z.string().nullable(),
  listing_slug: z.string().nullable(),
  listing_state: z.string().nullable(),
  listing_type: z.string().nullable(),
  listing_wmid: z.string().nullable(),
  max_price: z.number().nullable(),
  menu_item_id: z.number().nullable(),
  min_price: z.number().nullable(),
  original_price: z.number().nullable(),
  price: z.number().nullable(),
  price_label: z.string().nullable(),
  price_quantity: z.string().nullable(),
  price_unit: z.string().nullable(),
  primary_category_name: z.string().nullable(),
  primary_category_slug: z.string().nullable(),
  primary_category_uuid: z.string().nullable(),
  product_id: z.string().nullable(),
  product_name: z.string().nullable(),
  product_slug: z.string().nullable(),
  rating: z.number().nullable(),
  reviews_count: z.number().nullable(),
  row_id: z.number().nullable(),
  terpenes_percentage: z.number().nullable(),
  terpenes_unit: z.string().nullable(),
  thc_percentage: z.number().nullable(),
  thc_unit: z.string().nullable(),
  timestamp: z.string().nullable(),
  timestamp_str: z.string().nullable(),
  updated_at: z.string().nullable(),
  variant_inner_slug: z.string().nullable(),
  variant_slug: z.string().nullable(),
});

export const publicPostgisDeprecateArgsSchemaSchema = z.object({
  newname: z.string(),
  oldname: z.string(),
  version: z.string(),
});

export const publicPostgisDeprecateReturnsSchemaSchema = z.undefined();

export const publicPostgisIndexExtentArgsSchemaSchema = z.object({
  col: z.string(),
  tbl: z.unknown(),
});

export const publicPostgisIndexExtentReturnsSchemaSchema = z.unknown();

export const publicPostgisPgsqlVersionArgsSchemaSchema = z.object({});

export const publicPostgisPgsqlVersionReturnsSchemaSchema = z.string();

export const publicPostgisScriptsPgsqlVersionArgsSchemaSchema = z.object({});

export const publicPostgisScriptsPgsqlVersionReturnsSchemaSchema = z.string();

export const publicPostgisSelectivityArgsSchemaSchema = z.object({
  att_name: z.string(),
  geom: z.unknown(),
  mode: z.string().optional(),
  tbl: z.unknown(),
});

export const publicPostgisSelectivityReturnsSchemaSchema = z.number();

export const publicSt3dintersectsArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicSt3dintersectsReturnsSchemaSchema = z.boolean();

export const publicStBestsridArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStBestsridReturnsSchemaSchema = z.number();

export const publicStContainsArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStContainsReturnsSchemaSchema = z.boolean();

export const publicStContainsproperlyArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStContainsproperlyReturnsSchemaSchema = z.boolean();

export const publicStCoveredbyArgsSchemaSchema = z.union([
  z.object({
    geog1: z.unknown(),
    geog2: z.unknown(),
  }),
  z.object({
    geom1: z.unknown(),
    geom2: z.unknown(),
  }),
]);

export const publicStCoveredbyReturnsSchemaSchema = z.boolean();

export const publicStCoversArgsSchemaSchema = z.union([
  z.object({
    geog1: z.unknown(),
    geog2: z.unknown(),
  }),
  z.object({
    geom1: z.unknown(),
    geom2: z.unknown(),
  }),
]);

export const publicStCoversReturnsSchemaSchema = z.boolean();

export const publicStCrossesArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStCrossesReturnsSchemaSchema = z.boolean();

export const publicStDwithinArgsSchemaSchema = z.object({
  geog1: z.unknown(),
  geog2: z.unknown(),
  tolerance: z.number(),
  use_spheroid: z.boolean().optional(),
});

export const publicStDwithinReturnsSchemaSchema = z.boolean();

export const publicStEqualsArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStEqualsReturnsSchemaSchema = z.boolean();

export const publicStIntersectsArgsSchemaSchema = z.union([
  z.object({
    geog1: z.unknown(),
    geog2: z.unknown(),
  }),
  z.object({
    geom1: z.unknown(),
    geom2: z.unknown(),
  }),
]);

export const publicStIntersectsReturnsSchemaSchema = z.boolean();

export const publicStLinecrossingdirectionArgsSchemaSchema = z.object({
  line1: z.unknown(),
  line2: z.unknown(),
});

export const publicStLinecrossingdirectionReturnsSchemaSchema = z.number();

export const publicStLongestlineArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStLongestlineReturnsSchemaSchema = z.unknown();

export const publicStMaxdistanceArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStMaxdistanceReturnsSchemaSchema = z.number();

export const publicStOrderingequalsArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStOrderingequalsReturnsSchemaSchema = z.boolean();

export const publicStOverlapsArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStOverlapsReturnsSchemaSchema = z.boolean();

export const publicStPointoutsideArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStPointoutsideReturnsSchemaSchema = z.unknown();

export const publicStSortablehashArgsSchemaSchema = z.object({
  geom: z.unknown(),
});

export const publicStSortablehashReturnsSchemaSchema = z.number();

export const publicStTouchesArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStTouchesReturnsSchemaSchema = z.boolean();

export const publicStVoronoiArgsSchemaSchema = z.object({
  clip: z.unknown().optional(),
  g1: z.unknown(),
  return_polygons: z.boolean().optional(),
  tolerance: z.number().optional(),
});

export const publicStVoronoiReturnsSchemaSchema = z.unknown();

export const publicStWithinArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStWithinReturnsSchemaSchema = z.boolean();

export const publicAddauthArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicAddauthReturnsSchemaSchema = z.boolean();

export const publicAddgeometrycolumnArgsSchemaSchema = z.union([
  z.object({
    catalog_name: z.string(),
    column_name: z.string(),
    new_dim: z.number(),
    new_srid_in: z.number(),
    new_type: z.string(),
    schema_name: z.string(),
    table_name: z.string(),
    use_typmod: z.boolean().optional(),
  }),
  z.object({
    column_name: z.string(),
    new_dim: z.number(),
    new_srid: z.number(),
    new_type: z.string(),
    schema_name: z.string(),
    table_name: z.string(),
    use_typmod: z.boolean().optional(),
  }),
  z.object({
    column_name: z.string(),
    new_dim: z.number(),
    new_srid: z.number(),
    new_type: z.string(),
    table_name: z.string(),
    use_typmod: z.boolean().optional(),
  }),
]);

export const publicAddgeometrycolumnReturnsSchemaSchema = z.string();

export const publicAssignPackageItemsToItemsArgsSchemaSchema = z.object({
  _metric_item_id: z.number(),
  _metric_package_id: z.number(),
  _order_id: z.number(),
  _product_id: z.number(),
  _quantity: z.number(),
});

export const publicAssignPackageItemsToItemsReturnsSchemaSchema = z.undefined();

export const publicBoxArgsSchemaSchema = z.union([
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicBoxReturnsSchemaSchema = z.unknown();

export const publicBox2dArgsSchemaSchema = z.union([
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicBox2dReturnsSchemaSchema = z.unknown();

export const publicBox2dInArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicBox2dInReturnsSchemaSchema = z.unknown();

export const publicBox2dOutArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicBox2dOutReturnsSchemaSchema = z.unknown();

export const publicBox2dfInArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicBox2dfInReturnsSchemaSchema = z.unknown();

export const publicBox2dfOutArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicBox2dfOutReturnsSchemaSchema = z.unknown();

export const publicBox3dArgsSchemaSchema = z.union([
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicBox3dReturnsSchemaSchema = z.unknown();

export const publicBox3dInArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicBox3dInReturnsSchemaSchema = z.unknown();

export const publicBox3dOutArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicBox3dOutReturnsSchemaSchema = z.unknown();

export const publicBox3dtoboxArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicBox3dtoboxReturnsSchemaSchema = z.unknown();

export const publicBrandOrderSummaryArgsSchemaSchema = z.object({
  brand_id_input: z.number(),
});

export const publicBrandOrderSummaryReturnsSchemaSchema = z.array(
  z.object({
    metrc_manifest_id: z.number(),
    order_balance: z.number(),
    order_date: z.string(),
    order_group: z.string(),
    order_id: z.number(),
    order_status: z.string(),
    order_type: z.string(),
  })
);

export const publicByteaArgsSchemaSchema = z.union([
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicByteaReturnsSchemaSchema = z.string();

export const publicCalculateProrationArgsSchemaSchema = z.object({
  p_item_type: publicDataSassSubscriptionTypesSchema,
  p_price_id: z.number(),
  p_subscription_id: z.number(),
});

export const publicCalculateProrationReturnsSchemaSchema = z.array(
  z.object({
    amount: z.number(),
    fk_pricing_id: z.number(),
  })
);

export const publicCheckPosIntegrationStatusArgsSchemaSchema = z.object({
  location_id: z.number(),
  pos_type: publicPointOfSalesSchema,
});

export const publicCheckPosIntegrationStatusReturnsSchemaSchema = z.array(
  z.object({
    integration_exists: z.boolean(),
    is_active: z.boolean(),
    store_id: z.string(),
  })
);

export const publicCleanupOldNotificationsArgsSchemaSchema = z.object({});

export const publicCleanupOldNotificationsReturnsSchemaSchema = z.undefined();

export const publicClosePositionArgsSchemaSchema = z.object({
  p_position_id: z.number(),
  p_speculator_id: z.number(),
  p_user_uid: z.string(),
});

export const publicClosePositionReturnsSchemaSchema = z.array(
  z.object({
    message: z.string(),
    position_data: jsonSchema,
  })
);

export const publicCreateBuyOrderArgsSchemaSchema = z.object({
  _fk_brand_id: z.number(),
  _fk_market_id: z.number(),
  _fk_product_id: z.number(),
  buy_type: z.string(),
  factored_price: z.number(),
  limit_price: z.number(),
  quantity: z.number(),
  user_uid: z.string(),
});

export const publicCreateBuyOrderReturnsSchemaSchema = z.undefined();

export const publicCreateDistributorOrderArgsSchemaSchema = z.object({
  p_distributor_id: z.number(),
  p_market_id: z.number(),
  p_order_items: jsonSchema,
  user_uid: z.string(),
});

export const publicCreateDistributorOrderReturnsSchemaSchema = jsonSchema;

export const publicCreateInvoiceArgsSchemaSchema = z.object({
  _invoice_data: jsonSchema,
  _invoice_items: jsonSchema,
});

export const publicCreateInvoiceReturnsSchemaSchema = jsonSchema;

export const publicCreateRetailerOrderArgsSchemaSchema = z.object({
  p_order_items: jsonSchema,
  p_retailer_id: z.number(),
  user_uid: z.string(),
});

export const publicCreateRetailerOrderReturnsSchemaSchema = jsonSchema;

export const publicCreateSellOrderArgsSchemaSchema = z.object({
  _factored_price: z.number(),
  _fk_brand_id: z.number(),
  _fk_market_id: z.number(),
  _fk_product_id: z.number(),
  _limit_price: z.number(),
  _quantity: z.number(),
  _sell_type: z.string(),
  _user_uid: z.string(),
});

export const publicCreateSellOrderReturnsSchemaSchema = jsonSchema;

export const publicCreateWholesaleOrderArgsSchemaSchema = z.object({
  _fk_brand_id: z.number(),
  _fk_market_id: z.number(),
  _fk_product_id: z.number(),
  _markup: z.number(),
  _quantity: z.number(),
  _rate_id: z.number(),
  _user_uid: z.string(),
});

export const publicCreateWholesaleOrderReturnsSchemaSchema = jsonSchema;

export const publicDataAssignLocationToSubscriptionArgsSchemaSchema = z.object({
  _subscriptionlocationid: z.number(),
  _tnclistingid: z.number(),
});

export const publicDataAssignLocationToSubscriptionReturnsSchemaSchema = z.undefined();

export const publicDataGetStraddlePaykeyByIdArgsSchemaSchema = z.object({
  p_id: z.number(),
});

export const publicDataGetStraddlePaykeyByIdReturnsSchemaSchema = z.string();

export const publicDataGetUserStraddlePaymentMethodsArgsSchemaSchema = z.object({});

export const publicDataGetUserStraddlePaymentMethodsReturnsSchemaSchema = z.array(
  z.object({
    date_created: z.string(),
    date_modified: z.string(),
    description: z.string(),
    id: z.number(),
  })
);

export const publicDataInsertStraddleAccountArgsSchemaSchema = z.object({
  p_description: z.string(),
  p_paykey: z.string(),
  p_straddle_customer_id: z.string(),
});

export const publicDataInsertStraddleAccountReturnsSchemaSchema = z.undefined();

export const publicDataSassApplyCouponUseArgsSchemaSchema = z.object({
  p_applied_amount: z.number().optional(),
  p_billing_history_id: z.number().optional(),
  p_discount_code_id: z.number(),
  p_user_id: z.number(),
});

export const publicDataSassApplyCouponUseReturnsSchemaSchema = jsonSchema;

export const publicDataSassCheckDiscountCodeValidityArgsSchemaSchema = z.object({
  code_to_check: z.string(),
});

export const publicDataSassCheckDiscountCodeValidityReturnsSchemaSchema = z.array(
  z.object({
    code: z.string(),
    currency: z.string(),
    discount_type: z.string(),
    discount_value: z.number(),
    id: z.number(),
    invalid_reason: z.string(),
    is_valid: z.boolean(),
    min_purchase_amount: z.number(),
    remaining_uses: z.number(),
  })
);

export const publicDataSassCreateAdnPaymentProfileArgsSchemaSchema = z.object({
  p_adn_customer_id: z.string().optional(),
  p_adn_customer_payment_profile_id: z.string(),
  p_description: z.string(),
  p_payment_type: publicPaymentMethodTypeSchema,
});

export const publicDataSassCreateAdnPaymentProfileReturnsSchemaSchema = z.unknown();

export const publicDataSassCreateBillingAttemptArgsSchemaSchema = z.object({
  p_amount: z.number(),
  p_description: z.string(),
  p_metadata: jsonSchema.optional(),
  p_payment_method: z.string(),
  p_provider: publicDataPaymentProvidersSchema.optional(),
  p_purchase_type: publicDataSassSubscriptionTypesSchema,
  p_user_profile_id: z.number(),
});

export const publicDataSassCreateBillingAttemptReturnsSchemaSchema = jsonSchema;

export const publicDataSassFindFuzzyListingMatchesArgsSchemaSchema = z.object({
  p_address: z.string(),
  p_name: z.string(),
  p_phone: z.string().optional(),
  p_website: z.string().optional(),
  similarity_threshold: z.number().optional(),
});

export const publicDataSassFindFuzzyListingMatchesReturnsSchemaSchema = z.array(
  z.object({
    canonical_address: z.string(),
    canonical_city: z.string(),
    canonical_country: z.string(),
    canonical_geog: z.string(),
    canonical_latitude: z.number(),
    canonical_longitude: z.number(),
    canonical_name: z.string(),
    canonical_phone: z.string(),
    canonical_slug: z.string(),
    canonical_state: z.string(),
    canonical_zipcode: z.string(),
    created_at: z.string(),
    dutchie_source_id: z.string(),
    iheartjane_source_id: z.string(),
    is_custom_addition: z.boolean(),
    last_updated_at: z.string(),
    match_confidence: z.number(),
    match_method: z.string(),
    match_reasons: z.array(z.string()),
    similarity_score: z.number(),
    tnc_id: z.number(),
    weedmaps_wmid: z.number(),
  })
);

export const publicDataSassGetActivePaymentMethodArgsSchemaSchema = z.object({
  p_user_id: z.number().optional(),
});

export const publicDataSassGetActivePaymentMethodReturnsSchemaSchema = z.array(
  z.object({
    date_created: z.string(),
    date_modified: z.string(),
    date_removed: z.string(),
    fk_payment_method_id: z.number(),
    fk_user_id: z.number(),
    id: z.number(),
    payment_type: publicPaymentMethodTypeSchema,
    provider: publicDataPaymentProvidersSchema,
  })
);

export const publicDataSassGetAdnBillingHistoryByChargeIdLatestArgsSchemaSchema = z.object({
  p_charge_id: z.string(),
});

export const publicDataSassGetAdnBillingHistoryByChargeIdLatestReturnsSchemaSchema = z.array(
  z.object({
    amount: z.number(),
    billing_date: z.string(),
    charge_method: publicPaymentChargeTypeSchema,
    currency: z.string(),
    date_created: z.string(),
    date_modified: z.string(),
    date_removed: z.string(),
    description: z.string(),
    event_type: publicBillingHistoryEventTypesSchema,
    fk_pricing_id: z.number(),
    id: z.number(),
    item_id: z.number(),
    item_type: publicDataSassSubscriptionTypesSchema,
    metadata: jsonSchema,
    payment_method: z.string(),
    payment_status: publicStraddlePaymentStatusSchema,
    provider: publicDataPaymentProvidersSchema,
    provider_charge_id: z.string(),
    provider_customer_id: z.string(),
    subscription_id: z.number(),
  })
);

export const publicDataSassGetAdnBillingProfileArgsSchemaSchema = z.object({
  p_billing_profile_id: z.number(),
  p_user_id: z.number(),
});

export const publicDataSassGetAdnBillingProfileReturnsSchemaSchema = z.array(
  z.object({
    p_adn_customer_payment_profile_id: z.string(),
    p_date_created: z.string(),
    p_date_modified: z.string(),
    p_date_removed: z.string(),
    p_description: z.string(),
    p_fk_user_id: z.number(),
    p_id: z.number(),
    p_payment_type: publicPaymentMethodTypeSchema,
  })
);

export const publicDataSassGetAdnTransactionByChargeIdArgsSchemaSchema = z.object({
  p_charge_id: z.string(),
});

export const publicDataSassGetAdnTransactionByChargeIdReturnsSchemaSchema = jsonSchema;

export const publicDataSassGetBillingRecordByChargeArgsSchemaSchema = z.object({
  p_charge_id: z.string(),
  p_provider: publicDataPaymentProvidersSchema,
});

export const publicDataSassGetBillingRecordByChargeReturnsSchemaSchema = z.array(
  z.object({
    amount: z.number(),
    billing_date: z.string(),
    description: z.string(),
    fk_pricing_id: z.number(),
    id: z.number(),
    item_id: z.number(),
    item_type: publicDataSassSubscriptionTypesSchema,
    metadata: jsonSchema,
    payment_status: publicStraddlePaymentStatusSchema,
    provider_customer_id: z.string(),
    subscription_id: z.number(),
  })
);

export const publicDataSassGetSubscriptionBillingHistoryArgsSchemaSchema = z.object({
  p_page: z.number().optional(),
  p_page_size: z.number().optional(),
  p_status: z.string().optional(),
  p_subscription_id: z.number(),
});

export const publicDataSassGetSubscriptionBillingHistoryReturnsSchemaSchema = z.array(
  z.object({
    amount: z.number(),
    billing_date: z.string(),
    currency: z.string(),
    date_created: z.string(),
    description: z.string(),
    event_type: z.string(),
    id: z.number(),
    item_id: z.number(),
    item_type: z.string(),
    metadata: jsonSchema,
    payment_method: z.string(),
    payment_status: z.string(),
    provider: z.string(),
    provider_charge_id: z.string(),
    subscription_id: z.number(),
    total_count: z.number(),
  })
);

export const publicDataSassGetSubscriptionPaymentStatusArgsSchemaSchema = z.object({
  p_subscription_id: z.number(),
});

export const publicDataSassGetSubscriptionPaymentStatusReturnsSchemaSchema = z.array(
  z.object({
    is_past_due: z.boolean(),
    last_payment_amount: z.number(),
    last_payment_date: z.string(),
    last_payment_status: z.string(),
    next_billing_date: z.string(),
    past_due_amount: z.number(),
    payment_fail_count: z.number(),
    payment_method_description: z.string(),
    payment_method_id: z.number(),
    subscription_id: z.number(),
  })
);

export const publicDataSassGetUserPaymentMethodsArgsSchemaSchema = z.object({
  p_user_id: z.number().optional(),
});

export const publicDataSassGetUserPaymentMethodsReturnsSchemaSchema = z.array(
  z.object({
    p_id: z.number(),
    p_is_active: z.boolean(),
    p_payment_description: z.string(),
    p_payment_method_id: z.number(),
    p_payment_provider: publicDataPaymentProvidersSchema,
    p_payment_type: publicPaymentMethodTypeSchema,
    p_provider_payment_identifier: z.string(),
  })
);

export const publicDataSassRecordBillingHistoryArgsSchemaSchema = z.object({
  p_amount: z.number().optional(),
  p_billing_date: z.string().optional(),
  p_charge_method: publicPaymentChargeTypeSchema.optional(),
  p_currency: z.string().optional(),
  p_description: z.string().optional(),
  p_event_type: publicBillingHistoryEventTypesSchema.optional(),
  p_fk_pricing_id: z.number().optional(),
  p_item_id: z.number().optional(),
  p_item_type: publicDataSassSubscriptionTypesSchema.optional(),
  p_metadata: jsonSchema.optional(),
  p_payment_method: z.string().optional(),
  p_payment_status: publicStraddlePaymentStatusSchema.optional(),
  p_provider: publicDataPaymentProvidersSchema.optional(),
  p_provider_charge_id: z.string().optional(),
  p_provider_customer_id: z.string().optional(),
  p_subscription_id: z.number().optional(),
});

export const publicDataSassRecordBillingHistoryReturnsSchemaSchema = z.number();

export const publicDataSassRemoveAdnPaymentProfileArgsSchemaSchema = z.object({
  p_adn_customer_payment_profile_id: z.string(),
});

export const publicDataSassRemoveAdnPaymentProfileReturnsSchemaSchema = z.unknown();

export const publicDataSassSetActivePaymentMethodArgsSchemaSchema = z.object({
  p_payment_method_id: z.number(),
  p_payment_type: publicPaymentMethodTypeSchema,
  p_provider: publicDataPaymentProvidersSchema,
  p_user_id: z.number().optional(),
});

export const publicDataSassSetActivePaymentMethodReturnsSchemaSchema = z.unknown();

export const publicDataSassUpdateBaseSubscriptionBillingRecordArgsSchemaSchema = z.object({
  p_base_subscription_id: z.number(),
  p_customer_id: z.string(),
  p_provider: publicDataPaymentProvidersSchema,
  p_provider_charge_id: z.string(),
});

export const publicDataSassUpdateBaseSubscriptionBillingRecordReturnsSchemaSchema = z.boolean();

export const publicDataSassUpdatePosIntegrationSyncArgsSchemaSchema = z.object({
  p_external_service_token_id: z.number(),
  p_last_job_id: z.number().optional(),
  p_last_scrape_date: z.string(),
  p_last_scrape_status: z.string(),
  p_metadata: jsonSchema,
  p_pos_store_id: z.string(),
  p_pos_type: publicPointOfSalesSchema,
  p_status: z.string(),
  p_token_row_id: z.number(),
});

export const publicDataSassUpdatePosIntegrationSyncReturnsSchemaSchema = z.undefined();

export const publicDblinkArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDblinkReturnsSchemaSchema = z.array(z.record(z.unknown()));

export const publicDblinkCancelQueryArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDblinkCancelQueryReturnsSchemaSchema = z.string();

export const publicDblinkCloseArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDblinkCloseReturnsSchemaSchema = z.string();

export const publicDblinkConnectArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDblinkConnectReturnsSchemaSchema = z.string();

export const publicDblinkConnectUArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDblinkConnectUReturnsSchemaSchema = z.string();

export const publicDblinkCurrentQueryArgsSchemaSchema = z.object({});

export const publicDblinkCurrentQueryReturnsSchemaSchema = z.string();

export const publicDblinkDisconnectArgsSchemaSchema = z.object({});

export const publicDblinkDisconnectReturnsSchemaSchema = z.string();

export const publicDblinkErrorMessageArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDblinkErrorMessageReturnsSchemaSchema = z.string();

export const publicDblinkExecArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDblinkExecReturnsSchemaSchema = z.string();

export const publicDblinkFdwValidatorArgsSchemaSchema = z.object({
  catalog: z.unknown(),
  options: z.array(z.string()),
});

export const publicDblinkFdwValidatorReturnsSchemaSchema = z.undefined();

export const publicDblinkGetConnectionsArgsSchemaSchema = z.object({});

export const publicDblinkGetConnectionsReturnsSchemaSchema = z.array(z.string());

export const publicDblinkGetNotifyArgsSchemaSchema = z.object({});

export const publicDblinkGetNotifyReturnsSchemaSchema = z.array(z.record(z.unknown()));

export const publicDblinkGetPkeyArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDblinkPkeyResultsSchema = z.object({
  position: z.number().nullable(),
  colname: z.string().nullable(),
});

export const publicDblinkGetResultArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDblinkGetResultReturnsSchemaSchema = z.array(z.record(z.unknown()));

export const publicDblinkIsBusyArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDblinkIsBusyReturnsSchemaSchema = z.number();

export const publicDeletePosIntegrationArgsSchemaSchema = z.object({
  p_pos_integration_id: z.number(),
});

export const publicDeletePosIntegrationReturnsSchemaSchema = z.boolean();

export const publicDisablelongtransactionsArgsSchemaSchema = z.object({});

export const publicDisablelongtransactionsReturnsSchemaSchema = z.string();

export const publicDistributorOrderSummaryArgsSchemaSchema = z.object({
  distributor_id_input: z.number(),
});

export const publicDistributorOrderSummaryReturnsSchemaSchema = z.array(
  z.object({
    metrc_manifest_id: z.number(),
    order_balance: z.number(),
    order_date: z.string(),
    order_group: z.string(),
    order_id: z.number(),
    order_status: z.string(),
    order_type: z.string(),
  })
);

export const publicDmetaphoneArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDmetaphoneReturnsSchemaSchema = z.string();

export const publicDmetaphoneAltArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicDmetaphoneAltReturnsSchemaSchema = z.string();

export const publicDropgeometrycolumnArgsSchemaSchema = z.union([
  z.object({
    catalog_name: z.string(),
    column_name: z.string(),
    schema_name: z.string(),
    table_name: z.string(),
  }),
  z.object({
    column_name: z.string(),
    schema_name: z.string(),
    table_name: z.string(),
  }),
  z.object({
    column_name: z.string(),
    table_name: z.string(),
  }),
]);

export const publicDropgeometrycolumnReturnsSchemaSchema = z.string();

export const publicDropgeometrytableArgsSchemaSchema = z.union([
  z.object({
    catalog_name: z.string(),
    schema_name: z.string(),
    table_name: z.string(),
  }),
  z.object({
    schema_name: z.string(),
    table_name: z.string(),
  }),
  z.object({
    table_name: z.string(),
  }),
]);

export const publicDropgeometrytableReturnsSchemaSchema = z.string();

export const publicEnablelongtransactionsArgsSchemaSchema = z.object({});

export const publicEnablelongtransactionsReturnsSchemaSchema = z.string();

export const publicEqualsArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicEqualsReturnsSchemaSchema = z.boolean();

export const publicFindFuzzyBrandMatchesArgsSchemaSchema = z.object({
  max_results: z.number().optional(),
  platform_filter_id: z.number().optional(),
  search_term: z.string(),
  similarity_threshold: z.number().optional(),
});

export const publicFindFuzzyBrandMatchesReturnsSchemaSchema = z.array(
  z.object({
    fk_parent_id: z.number(),
    fk_platform_id: z.number(),
    id: z.number(),
    leafly_logo_url: z.string(),
    match_source: z.string(),
    origin_source_id: z.string(),
    platform_name: z.string(),
    similarity_score: z.number(),
    source_name: z.string(),
    wm_avatar_url: z.string(),
  })
);

export const publicGeographyArgsSchemaSchema = z.union([
  z.object({
    '': z.string(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicGeographyReturnsSchemaSchema = z.unknown();

export const publicGeographyAnalyzeArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeographyAnalyzeReturnsSchemaSchema = z.boolean();

export const publicGeographyGistCompressArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeographyGistCompressReturnsSchemaSchema = z.unknown();

export const publicGeographyGistDecompressArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeographyGistDecompressReturnsSchemaSchema = z.unknown();

export const publicGeographyOutArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeographyOutReturnsSchemaSchema = z.unknown();

export const publicGeographySendArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeographySendReturnsSchemaSchema = z.string();

export const publicGeographySpgistCompressNdArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeographySpgistCompressNdReturnsSchemaSchema = z.unknown();

export const publicGeographyTypmodInArgsSchemaSchema = z.object({
  '': z.array(z.unknown()),
});

export const publicGeographyTypmodInReturnsSchemaSchema = z.number();

export const publicGeographyTypmodOutArgsSchemaSchema = z.object({
  '': z.number(),
});

export const publicGeographyTypmodOutReturnsSchemaSchema = z.unknown();

export const publicGeometryArgsSchemaSchema = z.union([
  z.object({
    '': z.string(),
  }),
  z.object({
    '': z.string(),
  }),
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicGeometryReturnsSchemaSchema = z.unknown();

export const publicGeometryAboveArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryAboveReturnsSchemaSchema = z.boolean();

export const publicGeometryAnalyzeArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometryAnalyzeReturnsSchemaSchema = z.boolean();

export const publicGeometryBelowArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryBelowReturnsSchemaSchema = z.boolean();

export const publicGeometryCmpArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryCmpReturnsSchemaSchema = z.number();

export const publicGeometryContained3dArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryContained3dReturnsSchemaSchema = z.boolean();

export const publicGeometryContainsArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryContainsReturnsSchemaSchema = z.boolean();

export const publicGeometryContains3dArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryContains3dReturnsSchemaSchema = z.boolean();

export const publicGeometryDistanceBoxArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryDistanceBoxReturnsSchemaSchema = z.number();

export const publicGeometryDistanceCentroidArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryDistanceCentroidReturnsSchemaSchema = z.number();

export const publicGeometryEqArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryEqReturnsSchemaSchema = z.boolean();

export const publicGeometryGeArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryGeReturnsSchemaSchema = z.boolean();

export const publicGeometryGistCompress2dArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometryGistCompress2dReturnsSchemaSchema = z.unknown();

export const publicGeometryGistCompressNdArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometryGistCompressNdReturnsSchemaSchema = z.unknown();

export const publicGeometryGistDecompress2dArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometryGistDecompress2dReturnsSchemaSchema = z.unknown();

export const publicGeometryGistDecompressNdArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometryGistDecompressNdReturnsSchemaSchema = z.unknown();

export const publicGeometryGistSortsupport2dArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometryGistSortsupport2dReturnsSchemaSchema = z.undefined();

export const publicGeometryGtArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryGtReturnsSchemaSchema = z.boolean();

export const publicGeometryHashArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometryHashReturnsSchemaSchema = z.number();

export const publicGeometryInArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometryInReturnsSchemaSchema = z.unknown();

export const publicGeometryLeArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryLeReturnsSchemaSchema = z.boolean();

export const publicGeometryLeftArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryLeftReturnsSchemaSchema = z.boolean();

export const publicGeometryLtArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryLtReturnsSchemaSchema = z.boolean();

export const publicGeometryOutArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometryOutReturnsSchemaSchema = z.unknown();

export const publicGeometryOveraboveArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryOveraboveReturnsSchemaSchema = z.boolean();

export const publicGeometryOverbelowArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryOverbelowReturnsSchemaSchema = z.boolean();

export const publicGeometryOverlapsArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryOverlapsReturnsSchemaSchema = z.boolean();

export const publicGeometryOverlaps3dArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryOverlaps3dReturnsSchemaSchema = z.boolean();

export const publicGeometryOverleftArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryOverleftReturnsSchemaSchema = z.boolean();

export const publicGeometryOverrightArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryOverrightReturnsSchemaSchema = z.boolean();

export const publicGeometryRecvArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometryRecvReturnsSchemaSchema = z.unknown();

export const publicGeometryRightArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryRightReturnsSchemaSchema = z.boolean();

export const publicGeometrySameArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometrySameReturnsSchemaSchema = z.boolean();

export const publicGeometrySame3dArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometrySame3dReturnsSchemaSchema = z.boolean();

export const publicGeometrySendArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometrySendReturnsSchemaSchema = z.string();

export const publicGeometrySortsupportArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometrySortsupportReturnsSchemaSchema = z.undefined();

export const publicGeometrySpgistCompress2dArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometrySpgistCompress2dReturnsSchemaSchema = z.unknown();

export const publicGeometrySpgistCompress3dArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometrySpgistCompress3dReturnsSchemaSchema = z.unknown();

export const publicGeometrySpgistCompressNdArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometrySpgistCompressNdReturnsSchemaSchema = z.unknown();

export const publicGeometryTypmodInArgsSchemaSchema = z.object({
  '': z.array(z.unknown()),
});

export const publicGeometryTypmodInReturnsSchemaSchema = z.number();

export const publicGeometryTypmodOutArgsSchemaSchema = z.object({
  '': z.number(),
});

export const publicGeometryTypmodOutReturnsSchemaSchema = z.unknown();

export const publicGeometryWithinArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicGeometryWithinReturnsSchemaSchema = z.boolean();

export const publicGeometrytypeArgsSchemaSchema = z.union([
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicGeometrytypeReturnsSchemaSchema = z.string();

export const publicGeomfromewkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicGeomfromewkbReturnsSchemaSchema = z.unknown();

export const publicGeomfromewktArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicGeomfromewktReturnsSchemaSchema = z.unknown();

export const publicGetBrandProductSummaryArgsSchemaSchema = z.object({
  brand_id_input: z.number(),
});

export const publicGetBrandProductSummaryReturnsSchemaSchema = z.array(
  z.object({
    position_count: z.number(),
    product_ancestor_category: z.string(),
    product_category: z.string(),
    product_image_url: z.string(),
    product_name: z.string(),
    product_subcategory: z.string(),
    retail_price_high: z.number(),
    retail_price_low: z.number(),
  })
);

export const publicGetBrandSummaryArgsSchemaSchema = z.object({});

export const publicGetBrandSummaryReturnsSchemaSchema = z.array(
  z.object({
    active_products: z.number(),
    brand_description: z.string(),
    brand_id: z.number(),
    brand_logo_url: z.string(),
    brand_name: z.string(),
    inactive_products: z.number(),
    total_products: z.number(),
    unique_categories: z.number(),
  })
);

export const publicGetBrandsPositionsAggregatesArgsSchemaSchema = z.object({
  distributor_ids: z.array(z.number()),
});

export const publicGetBrandsPositionsAggregatesReturnsSchemaSchema = z.array(
  z.object({
    active_position_count: z.number(),
    brand_description: z.string(),
    brand_id: z.number(),
    brand_license_number: z.string(),
    brand_logo_url: z.string(),
    brand_name: z.string(),
    total_item_count: z.number(),
  })
);

export const publicGetDistributorInventorySummaryArgsSchemaSchema = z.object({
  distributor_id_param: z.number(),
});

export const publicGetDistributorInventorySummaryReturnsSchemaSchema = z.array(
  z.object({
    active_positions_count: z.number(),
    inventory_count: z.number(),
    product_ancestor_category: z.string(),
    product_category: z.string(),
    product_id: z.number(),
    product_image_url: z.string(),
    product_name: z.string(),
    product_subcategory: z.string(),
  })
);

export const publicGetDistributorSummaryArgsSchemaSchema = z.object({});

export const publicGetDistributorSummaryReturnsSchemaSchema = z.array(
  z.object({
    distributor_city: z.string(),
    distributor_id: z.number(),
    distributor_name: z.string(),
    distributor_state: z.string(),
    total_brands: z.number(),
  })
);

export const publicGetLocationPosIntegrationsArgsSchemaSchema = z.object({
  location_id: z.number(),
});

export const publicGetLocationPosIntegrationsReturnsSchemaSchema = z.array(
  z.object({
    date_created: z.string(),
    date_modified: z.string(),
    es_index_name: z.string(),
    external_service_token_id: z.number(),
    fk_location_id: z.number(),
    id: z.number(),
    is_active: z.boolean(),
    last_job_id: z.number(),
    last_scrape_metadata: jsonSchema,
    last_scrape_status: publicPosDataScrapeStatusSchema,
    last_scraped_at: z.string(),
    metadata: jsonSchema,
    pos_type: publicPointOfSalesSchema,
    scrape_frequency: publicPosDataScrapeFrequencySchema,
    store_id: z.string(),
  })
);

export const publicGetMarketPositionAggregatesArgsSchemaSchema = z.object({});

export const publicGetMarketPositionAggregatesReturnsSchemaSchema = z.array(
  z.object({
    active_position_count: z.number(),
    market_geo_points: jsonSchema,
    market_id: z.number(),
    market_name: z.string(),
    total_item_count: z.number(),
  })
);

export const publicGetMarketSummaryArgsSchemaSchema = z.object({});

export const publicGetMarketSummaryReturnsSchemaSchema = z.array(
  z.object({
    active_positions: z.number(),
    market_id: z.number(),
    market_name: z.string(),
    total_brands: z.number(),
    total_distributors: z.number(),
  })
);

export const publicGetMetrcTransfersWithPackageCountsArgsSchemaSchema = z.object({
  p_order_id: z.number(),
  user_uid: z.string(),
});

export const publicGetMetrcTransfersWithPackageCountsReturnsSchemaSchema = z.array(
  z.object({
    actual_return_arrival_date_time: z.string(),
    actual_return_departure_date_time: z.string(),
    created_date_time: z.string(),
    delivery_date_time: z.string(),
    driver_name: z.string(),
    driver_occupational_license_number: z.string(),
    driver_vehicle_license_number: z.string(),
    manifest_number: z.string(),
    metrc_transfer_id: z.number(),
    metric_packages: jsonSchema,
    package_count: z.number(),
    received_by_facility_name: z.string(),
    received_by_license_number: z.string(),
    received_date_time: z.string(),
    shipper_facility_license_number: z.string(),
    shipper_facility_name: z.string(),
    total_items_received: z.number(),
    total_items_shipped: z.number(),
    transporter_facility_license_number: z.string(),
    vehicle_license_plate_number: z.string(),
    vehicle_make: z.string(),
    vehicle_model: z.string(),
  })
);

export const publicGetNearbyBrandProductsArgsSchemaSchema = z.object({
  p_brand_id: z.number(),
  p_category: z.string().optional(),
  p_cbd_max: z.number().optional(),
  p_cbd_min: z.number().optional(),
  p_edge_category: z.string().optional(),
  p_group_by_dispensary: z.boolean().optional(),
  p_lat: z.number(),
  p_limit_count: z.number().optional(),
  p_lng: z.number(),
  p_max_dispensaries: z.number().optional(),
  p_offset_count: z.number().optional(),
  p_price_max: z.number().optional(),
  p_price_min: z.number().optional(),
  p_radius: z.number().optional(),
  p_state_filter: z.string().optional(),
  p_thc_max: z.number().optional(),
  p_thc_min: z.number().optional(),
});

export const publicGetNearbyBrandProductsReturnsSchemaSchema = z.array(
  z.object({
    avatar_image_url: z.string(),
    brand_avatar_image_url: z.string(),
    brand_name: z.string(),
    category_name: z.string(),
    cbd_value: z.number(),
    dispensary_city: z.string(),
    dispensary_id: z.number(),
    dispensary_name: z.string(),
    dispensary_state: z.string(),
    distance_miles: z.number(),
    edge_category_name: z.string(),
    max_price: z.number(),
    min_price: z.number(),
    price: z.number(),
    product_id: z.number(),
    product_name: z.string(),
    product_slug: z.string(),
    thc_value: z.number(),
  })
);

export const publicGetNearbyListingsArgsSchemaSchema = z.object({
  city_filter: z.string().optional(),
  is_delivery: z.boolean().optional(),
  is_pickup: z.boolean().optional(),
  lat: z.number(),
  limit_count: z.number().optional(),
  lng: z.number(),
  name_search: z.string().optional(),
  offset_count: z.number().optional(),
  radius: z.number().optional(),
  state_filter: z.string().optional(),
});

export const publicGetNearbyListingsReturnsSchemaSchema = z.array(
  z.object({
    avatar_original_url: z.string(),
    avatar_small_url: z.string(),
    city: z.string(),
    distance_miles: z.number(),
    email: z.string(),
    geo_point: z.unknown(),
    is_delivery_available: z.boolean(),
    is_pickup_available: z.boolean(),
    latitude: z.number(),
    license_type: z.string(),
    listing_id: z.number(),
    longitude: z.number(),
    name: z.string(),
    online_ordering_enabled: z.boolean(),
    open_now: z.boolean(),
    phone_number: z.string(),
    rating: z.number(),
    reviews_count: z.number(),
    row_id: z.number(),
    slug: z.string(),
    social_equity: z.boolean(),
    state: z.string(),
    web_url: z.string(),
    zip_code: z.string(),
  })
);

export const publicGetNearbyListingsForBrandArgsSchemaSchema = z.object({
  p_brand_id: z.number(),
  p_lat: z.number(),
  p_limit_count: z.number().optional(),
  p_lng: z.number(),
  p_offset_count: z.number().optional(),
  p_radius: z.number().optional(),
  p_search_query: z.string().optional(),
});

export const publicGetNearbyListingsForBrandReturnsSchemaSchema = z.array(
  z.object({
    avatar_original_url: z.string(),
    avatar_small_url: z.string(),
    city: z.string(),
    distance_miles: z.number(),
    email: z.string(),
    geo_point: z.unknown(),
    is_delivery_available: z.boolean(),
    is_pickup_available: z.boolean(),
    latitude: z.number(),
    license_type: z.string(),
    listing_id: z.number(),
    longitude: z.number(),
    name: z.string(),
    online_ordering_enabled: z.boolean(),
    open_now: z.boolean(),
    phone_number: z.string(),
    rating: z.number(),
    reviews_count: z.number(),
    row_id: z.number(),
    slug: z.string(),
    social_equity: z.boolean(),
    state: z.string(),
    web_url: z.string(),
    zip_code: z.string(),
  })
);

export const publicGetNearbyProductsOptimizedUnlimitedArgsSchemaSchema = z.object({
  brand_search: z.string().optional(),
  category: z.string().optional(),
  cbd_max: z.number().optional(),
  cbd_min: z.number().optional(),
  edge_category: z.string().optional(),
  lat: z.number(),
  limit_count: z.number().optional(),
  lng: z.number(),
  max_dispensaries: z.number().optional(),
  offset_count: z.number().optional(),
  price_max: z.number().optional(),
  price_min: z.number().optional(),
  product_search: z.string().optional(),
  radius: z.number().optional(),
  state_filter: z.string().optional(),
  thc_max: z.number().optional(),
  thc_min: z.number().optional(),
  timeout_interval: z.string().optional(),
});

export const publicGetNearbyProductsOptimizedUnlimitedReturnsSchemaSchema = z.array(
  z.object({
    avatar_image_url: z.string(),
    brand_avatar_image_url: z.string(),
    brand_name: z.string(),
    category_name: z.string(),
    cbd_value: z.number(),
    dispensary_city: z.string(),
    dispensary_id: z.number(),
    dispensary_name: z.string(),
    dispensary_state: z.string(),
    distance_miles: z.number(),
    edge_category_name: z.string(),
    max_price: z.number(),
    min_price: z.number(),
    price: z.number(),
    product_id: z.number(),
    product_name: z.string(),
    product_slug: z.string(),
    thc_value: z.number(),
  })
);

export const publicGetNearbyProductsOptimizedUnlimitedTestArgsSchemaSchema = z.object({
  p_brand_ids: z.array(z.number()).optional(),
  p_brand_search: z.string().optional(),
  p_category: z.string().optional(),
  p_cbd_max: z.number().optional(),
  p_cbd_min: z.number().optional(),
  p_edge_category: z.string().optional(),
  p_group_by_dispensary: z.boolean().optional(),
  p_lat: z.number(),
  p_limit_count: z.number().optional(),
  p_lng: z.number(),
  p_max_dispensaries: z.number().optional(),
  p_offset_count: z.number().optional(),
  p_price_max: z.number().optional(),
  p_price_min: z.number().optional(),
  p_product_search: z.string().optional(),
  p_radius: z.number().optional(),
  p_state_filter: z.string().optional(),
  p_thc_max: z.number().optional(),
  p_thc_min: z.number().optional(),
});

export const publicGetNearbyProductsOptimizedUnlimitedTestReturnsSchemaSchema = z.array(
  z.object({
    avatar_image_url: z.string(),
    brand_avatar_image_url: z.string(),
    brand_name: z.string(),
    category_name: z.string(),
    cbd_value: z.number(),
    dispensary_city: z.string(),
    dispensary_id: z.number(),
    dispensary_name: z.string(),
    dispensary_state: z.string(),
    distance_miles: z.number(),
    edge_category_name: z.string(),
    max_price: z.number(),
    min_price: z.number(),
    price: z.number(),
    product_id: z.number(),
    product_name: z.string(),
    product_slug: z.string(),
    thc_value: z.number(),
  })
);

export const publicGetNotificationChannelTokenArgsSchemaSchema = z.object({
  nonce: z.string(),
});

export const publicGetNotificationChannelTokenReturnsSchemaSchema = z.string();

export const publicGetOrderProductSummaryArgsSchemaSchema = z.object({
  p_order_id: z.number(),
  user_uid: z.string(),
});

export const publicGetOrderProductSummaryReturnsSchemaSchema = z.array(
  z.object({
    brand_logo_url: z.string(),
    brand_name: z.string(),
    fk_brand_id: z.number(),
    linked_metric_item_id: z.number(),
    metrc_linked_count: z.number(),
    packages: z.array(jsonSchema),
    product_count: z.number(),
    product_id: z.number(),
    product_image_url: z.string(),
    product_name: z.string(),
  })
);

export const publicGetPlaidAccessTokenArgsSchemaSchema = z.object({});

export const publicGetPlaidAccessTokenReturnsSchemaSchema = z.string();

export const publicGetPlaidAccountIdArgsSchemaSchema = z.object({});

export const publicGetPlaidAccountIdReturnsSchemaSchema = z.string();

export const publicGetPosIntegrationsForScrapingArgsSchemaSchema = z.object({});

export const publicGetPosIntegrationsForScrapingReturnsSchemaSchema = z.array(
  z.object({
    api_key: z.string(),
    api_secret: z.string(),
    external_service_token_id: z.number(),
    fk_location_id: z.number(),
    id: z.number(),
    is_active: z.boolean(),
    last_job_id: z.number(),
    last_scrape_metadata: jsonSchema,
    last_scrape_status: publicPosDataScrapeStatusSchema,
    last_scraped_at: z.string(),
    metadata: jsonSchema,
    pos_type: publicPointOfSalesSchema,
    scrape_frequency: publicPosDataScrapeFrequencySchema,
    store_id: z.string(),
  })
);

export const publicGetPositionTimelineArgsSchemaSchema = z.object({
  __position_id: z.number(),
});

export const publicGetPositionTimelineReturnsSchemaSchema = z.array(
  z.object({
    item_distributor_quantity: z.number(),
    item_pending_quantity: z.number(),
    item_retail_quantity: z.number(),
    sale_price: z.number(),
    transaction_date: z.string(),
    transaction_id: z.number(),
    transaction_type: z.string(),
    transfer_direction: z.string(),
  })
);

export const publicGetPositionsWithQuantityArgsSchemaSchema = z.object({});

export const publicGetPositionsWithQuantityReturnsSchemaSchema = z.array(
  z.object({
    brand_logo_url: z.string(),
    brand_name: z.string(),
    date_created: z.string(),
    date_modified: z.string(),
    distributor_inventory_count: z.number(),
    fk_brand_id: z.number(),
    fk_market_id: z.number(),
    fk_product_id: z.number(),
    fk_speculator_id: z.number(),
    market_name: z.string(),
    pending_inventory_count: z.number(),
    position_balance: z.number(),
    position_factored_price_total: z.number(),
    position_id: z.number(),
    position_is_filled: z.boolean(),
    position_item_quantity: z.number(),
    position_item_unit_market_cost: z.number(),
    position_margin_total: z.number(),
    position_order_remaining_quantity: z.number(),
    position_order_sub_type: z.string(),
    position_order_type: z.string(),
    position_price: z.number(),
    position_status: z.string(),
    product_image_url: z.string(),
    product_name: z.string(),
    retail_inventory_count: z.number(),
  })
);

export const publicGetProductDetailsMapDataArgsSchemaSchema = z.object({
  product_id: z.number(),
});

export const publicGetProductDetailsMapDataReturnsSchemaSchema = z.array(
  z.object({
    distributor_count: z.number(),
    distributor_locations: jsonSchema,
    retailer_count: z.number(),
    retailer_locations: jsonSchema,
  })
);

export const publicGetProductListingsNearbyArgsSchemaSchema = z.object({
  lat: z.number(),
  lng: z.number(),
  p_slug: z.string(),
  radius: z.number().optional(),
});

export const publicGetProductListingsNearbyReturnsSchemaSchema = z.array(
  z.object({
    avatar_image_url: z.string(),
    brand_avatar_image_url: z.string(),
    dispensary_address: z.string(),
    dispensary_city: z.string(),
    dispensary_email: z.string(),
    dispensary_id: z.number(),
    dispensary_latitude: z.number(),
    dispensary_longitude: z.number(),
    dispensary_name: z.string(),
    dispensary_phone: z.string(),
    dispensary_rating: z.number(),
    dispensary_slug: z.string(),
    dispensary_state: z.string(),
    dispensary_zip: z.string(),
    distance_miles: z.number(),
    listing_id: z.number(),
    menu_id: z.number(),
    on_sale: z.boolean(),
    original_price: z.number(),
    price: z.number(),
  })
);

export const publicGetProductMarketDepthArgsSchemaSchema = z.object({
  input_market_id: z.number(),
  input_product_id: z.number(),
});

export const publicGetProductMarketDepthReturnsSchemaSchema = z.array(
  z.object({
    cumulative_quantity: z.number(),
    order_type: publicPositionExchangeOrderTypesSchema,
    price: z.number(),
    quantity: z.number(),
  })
);

export const publicGetProductPositionAggregatesArgsSchemaSchema = z.object({
  p_brand_id: z.number(),
  p_market_id: z.number(),
});

export const publicGetProductPositionAggregatesReturnsSchemaSchema = z.array(
  z.object({
    brand_id: z.number(),
    brand_logo: z.string(),
    brand_name: z.string(),
    item_count: z.number(),
    max_factored_price: z.number(),
    max_price: z.number(),
    min_factored_price: z.number(),
    min_price: z.number(),
    product_id: z.number(),
    product_logo: z.string(),
    product_name: z.string(),
  })
);

export const publicGetProductSummaryArgsSchemaSchema = z.object({});

export const publicGetProductSummaryReturnsSchemaSchema = z.array(
  z.object({
    brand_logo_url: z.string(),
    brand_name: z.string(),
    distributor_count: z.number(),
    positions_count: z.number(),
    product_ancestor_category: z.string(),
    product_category: z.string(),
    product_id: z.number(),
    product_image_url: z.string(),
    product_name: z.string(),
    product_subcategory: z.string(),
    product_tags: jsonSchema,
    retailer_count: z.number(),
    weedmaps_id: z.number(),
  })
);

export const publicGetProj4FromSridArgsSchemaSchema = z.object({
  '': z.number(),
});

export const publicGetProj4FromSridReturnsSchemaSchema = z.string();

export const publicGetRetailersWithProductsArgsSchemaSchema = z.object({
  product_ids: z.array(z.number()),
});

export const publicGetRetailersWithProductsReturnsSchemaSchema = z.array(
  z.object({
    product_quantities: jsonSchema,
    retailer_address: z.string(),
    retailer_city: z.string(),
    retailer_email: z.string(),
    retailer_geo_points: jsonSchema,
    retailer_id: z.number(),
    retailer_license_number: z.string(),
    retailer_name: z.string(),
    retailer_phone: z.string(),
    retailer_postal_code: z.string(),
    retailer_state: z.string(),
    retailer_status: publicRetailerstatusSchema,
  })
);

export const publicGetShopHomeFeaturedDataArgsSchemaSchema = z.object({
  lat: z.number(),
  lng: z.number(),
  radius: z.number().optional(),
});

export const publicGetShopHomeFeaturedDataReturnsSchemaSchema = jsonSchema;

export const publicGetSpeculatorDashboardMarketStatsArgsSchemaSchema = z.object({
  __market_id: z.number(),
});

export const publicGetSpeculatorDashboardMarketStatsReturnsSchemaSchema = jsonSchema;

export const publicGetSpeculatorPositionAggregatesArgsSchemaSchema = z.object({
  p_market_id: z.number(),
});

export const publicGetSpeculatorPositionAggregatesReturnsSchemaSchema = z.array(
  z.object({
    brand_id: z.number(),
    brand_logo: z.string(),
    brand_name: z.string(),
    distributor_quantity: z.number(),
    item_count: z.number(),
    max_factored_price: z.number(),
    max_price: z.number(),
    min_factored_price: z.number(),
    min_price: z.number(),
    pending_quantity: z.number(),
    product_id: z.number(),
    product_logo: z.string(),
    product_name: z.string(),
    retail_quantity: z.number(),
  })
);

export const publicGetSpeculatorProfileActivityTimelineArgsSchemaSchema = z.object({});

export const publicGetSpeculatorProfileActivityTimelineReturnsSchemaSchema = jsonSchema;

export const publicGetTopBrandsArgsSchemaSchema = z.object({});

export const publicGetTopBrandsReturnsSchemaSchema = z.array(
  z.object({
    brand_id: z.number(),
    brand_name: z.string(),
    brand_rank: z.number(),
    total_position_count: z.number(),
    total_position_volume: z.number(),
  })
);

export const publicGetTopDistributorsArgsSchemaSchema = z.object({});

export const publicGetTopDistributorsReturnsSchemaSchema = z.array(
  z.object({
    distributor_id: z.number(),
    distributor_name: z.string(),
    distributor_rank: z.number(),
    total_position_count: z.number(),
    total_position_volume: z.number(),
  })
);

export const publicGetTopMarketMoversArgsSchemaSchema = z.object({});

export const publicGetTopMarketMoversReturnsSchemaSchema = z.array(
  z.object({
    market_mover_rank: z.number(),
    speculator_uid: z.string(),
    speculator_username: z.string(),
    total_position_count: z.number(),
    total_position_volume: z.number(),
  })
);

export const publicGetTopRecruitersArgsSchemaSchema = z.object({});

export const publicGetTopRecruitersReturnsSchemaSchema = z.array(
  z.object({
    recruiter_rank: z.number(),
    recruiter_uid: z.string(),
    recruiter_username: z.string(),
    registration_count: z.number(),
  })
);

export const publicGetTopRetailersArgsSchemaSchema = z.object({});

export const publicGetTopRetailersReturnsSchemaSchema = z.array(
  z.object({
    retailer_id: z.number(),
    retailer_name: z.string(),
    retailer_rank: z.number(),
    total_position_count: z.number(),
    total_position_volume: z.number(),
  })
);

export const publicGetTreezBrandsForIntegrationArgsSchemaSchema = z.object({
  p_filter_by: z.string().optional(),
  p_filter_value: z.string().optional(),
  p_integration_id: z.number(),
  p_page: z.number().optional(),
  p_page_size: z.number().optional(),
  p_sort_by: z.string().optional(),
  p_sort_order: z.string().optional(),
});

export const publicGetTreezBrandsForIntegrationReturnsSchemaSchema = jsonSchema;

export const publicGetTreezCategoriesForIntegrationArgsSchemaSchema = z.object({
  p_filter_by: z.string().optional(),
  p_filter_value: z.string().optional(),
  p_integration_id: z.number(),
  p_page: z.number().optional(),
  p_page_size: z.number().optional(),
  p_sort_by: z.string().optional(),
  p_sort_order: z.string().optional(),
});

export const publicGetTreezCategoriesForIntegrationReturnsSchemaSchema = jsonSchema;

export const publicGetTreezProductsForIntegrationArgsSchemaSchema = z.object({
  p_filter_by: z.string().optional(),
  p_filter_value: z.string().optional(),
  p_integration_id: z.number(),
  p_page: z.number().optional(),
  p_page_size: z.number().optional(),
  p_sort_by: z.string().optional(),
  p_sort_order: z.string().optional(),
});

export const publicGetTreezProductsForIntegrationReturnsSchemaSchema = jsonSchema;

export const publicGetUserAccountDataArgsSchemaSchema = z.object({});

export const publicGetUserAccountDataReturnsSchemaSchema = jsonSchema;

export const publicGetUserWebhookEventsArgsSchemaSchema = z.object({
  event_type_filter: z.string().optional(),
  limit_param: z.number().optional(),
  offset_param: z.number().optional(),
  status_filter: z.string().optional(),
});

export const publicGetUserWebhookEventsReturnsSchemaSchema = z.array(
  z.object({
    date_created: z.string(),
    error_message: z.string(),
    event_data: jsonSchema,
    event_id: z.string(),
    event_type: z.string(),
    id: z.number(),
    status: z.string(),
  })
);

export const publicGetValidOrderProductsArgsSchemaSchema = z.object({
  brand_ids: z.array(z.number()),
  market_id: z.number(),
});

export const publicGetValidOrderProductsReturnsSchemaSchema = jsonSchema;

export const publicGettransactionidArgsSchemaSchema = z.object({});

export const publicGettransactionidReturnsSchemaSchema = z.unknown();

export const publicGidxInArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGidxInReturnsSchemaSchema = z.unknown();

export const publicGidxOutArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGidxOutReturnsSchemaSchema = z.unknown();

export const publicGtrgmCompressArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGtrgmCompressReturnsSchemaSchema = z.unknown();

export const publicGtrgmDecompressArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGtrgmDecompressReturnsSchemaSchema = z.unknown();

export const publicGtrgmInArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGtrgmInReturnsSchemaSchema = z.unknown();

export const publicGtrgmOptionsArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGtrgmOptionsReturnsSchemaSchema = z.undefined();

export const publicGtrgmOutArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGtrgmOutReturnsSchemaSchema = z.unknown();

export const publicInsertAdminArgsSchemaSchema = z.object({
  new_admin_role: z.string(),
  new_admin_speculator_id: z.number(),
  new_admin_uid: z.string(),
});

export const publicInsertAdminReturnsSchemaSchema = z.boolean();

export const publicIsAdminArgsSchemaSchema = z.object({});

export const publicIsAdminReturnsSchemaSchema = z.boolean();

export const publicIsSuperAdminArgsSchemaSchema = z.object({});

export const publicIsSuperAdminReturnsSchemaSchema = z.boolean();

export const publicJsonArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicJsonReturnsSchemaSchema = jsonSchema;

export const publicJsonbArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicJsonbReturnsSchemaSchema = jsonSchema;

export const publicLongtransactionsenabledArgsSchemaSchema = z.object({});

export const publicLongtransactionsenabledReturnsSchemaSchema = z.boolean();

export const publicMarkNotificationAsReadArgsSchemaSchema = z.object({
  notification_id_param: z.string(),
});

export const publicMarkNotificationAsReadReturnsSchemaSchema = z.undefined();

export const publicMarkPosIntegrationAsScrapedArgsSchemaSchema = z.object({
  integration_id: z.number(),
});

export const publicMarkPosIntegrationAsScrapedReturnsSchemaSchema = z.boolean();

export const publicMarketOrderSummaryArgsSchemaSchema = z.object({
  market_id_input: z.number(),
});

export const publicMarketOrderSummaryReturnsSchemaSchema = z.array(
  z.object({
    metrc_manifest_id: z.number(),
    order_balance: z.number(),
    order_date: z.string(),
    order_group: z.string(),
    order_id: z.number(),
    order_status: z.string(),
    order_type: z.string(),
  })
);

export const publicNormalizeCountryCodeArgsSchemaSchema = z.object({
  country_name: z.string(),
});

export const publicNormalizeCountryCodeReturnsSchemaSchema = z.string();

export const publicNormalizePhoneArgsSchemaSchema = z.object({
  phone_text: z.string(),
});

export const publicNormalizePhoneReturnsSchemaSchema = z.string();

export const publicPathArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPathReturnsSchemaSchema = z.unknown();

export const publicPgisAsflatgeobufFinalfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPgisAsflatgeobufFinalfnReturnsSchemaSchema = z.string();

export const publicPgisAsgeobufFinalfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPgisAsgeobufFinalfnReturnsSchemaSchema = z.string();

export const publicPgisAsmvtFinalfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPgisAsmvtFinalfnReturnsSchemaSchema = z.string();

export const publicPgisAsmvtSerialfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPgisAsmvtSerialfnReturnsSchemaSchema = z.string();

export const publicPgisGeometryClusterintersectingFinalfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPgisGeometryClusterintersectingFinalfnReturnsSchemaSchema = z.array(z.unknown());

export const publicPgisGeometryClusterwithinFinalfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPgisGeometryClusterwithinFinalfnReturnsSchemaSchema = z.array(z.unknown());

export const publicPgisGeometryCollectFinalfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPgisGeometryCollectFinalfnReturnsSchemaSchema = z.unknown();

export const publicPgisGeometryMakelineFinalfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPgisGeometryMakelineFinalfnReturnsSchemaSchema = z.unknown();

export const publicPgisGeometryPolygonizeFinalfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPgisGeometryPolygonizeFinalfnReturnsSchemaSchema = z.unknown();

export const publicPgisGeometryUnionParallelFinalfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPgisGeometryUnionParallelFinalfnReturnsSchemaSchema = z.unknown();

export const publicPgisGeometryUnionParallelSerialfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPgisGeometryUnionParallelSerialfnReturnsSchemaSchema = z.string();

export const publicPointArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPointReturnsSchemaSchema = z.unknown();

export const publicPolygonArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPolygonReturnsSchemaSchema = z.unknown();

export const publicPopulateGeometryColumnsArgsSchemaSchema = z.union([
  z.object({
    tbl_oid: z.unknown(),
    use_typmod: z.boolean().optional(),
  }),
  z.object({
    use_typmod: z.boolean().optional(),
  }),
]);

export const publicPopulateGeometryColumnsReturnsSchemaSchema = z.string();

export const publicPositionOrderSummaryArgsSchemaSchema = z.object({
  position_id_input: z.number(),
});

export const publicPositionOrderSummaryReturnsSchemaSchema = z.array(
  z.object({
    metrc_manifest_id: z.number(),
    order_balance: z.number(),
    order_date: z.string(),
    order_group: z.string(),
    order_id: z.number(),
    order_status: z.string(),
    order_type: z.string(),
  })
);

export const publicPostgisAddbboxArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPostgisAddbboxReturnsSchemaSchema = z.unknown();

export const publicPostgisConstraintDimsArgsSchemaSchema = z.object({
  geomcolumn: z.string(),
  geomschema: z.string(),
  geomtable: z.string(),
});

export const publicPostgisConstraintDimsReturnsSchemaSchema = z.number();

export const publicPostgisConstraintSridArgsSchemaSchema = z.object({
  geomcolumn: z.string(),
  geomschema: z.string(),
  geomtable: z.string(),
});

export const publicPostgisConstraintSridReturnsSchemaSchema = z.number();

export const publicPostgisConstraintTypeArgsSchemaSchema = z.object({
  geomcolumn: z.string(),
  geomschema: z.string(),
  geomtable: z.string(),
});

export const publicPostgisConstraintTypeReturnsSchemaSchema = z.string();

export const publicPostgisDropbboxArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPostgisDropbboxReturnsSchemaSchema = z.unknown();

export const publicPostgisExtensionsUpgradeArgsSchemaSchema = z.object({});

export const publicPostgisExtensionsUpgradeReturnsSchemaSchema = z.string();

export const publicPostgisFullVersionArgsSchemaSchema = z.object({});

export const publicPostgisFullVersionReturnsSchemaSchema = z.string();

export const publicPostgisGeosNoopArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPostgisGeosNoopReturnsSchemaSchema = z.unknown();

export const publicPostgisGeosVersionArgsSchemaSchema = z.object({});

export const publicPostgisGeosVersionReturnsSchemaSchema = z.string();

export const publicPostgisGetbboxArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPostgisGetbboxReturnsSchemaSchema = z.unknown();

export const publicPostgisHasbboxArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPostgisHasbboxReturnsSchemaSchema = z.boolean();

export const publicPostgisIndexSupportfnArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPostgisIndexSupportfnReturnsSchemaSchema = z.unknown();

export const publicPostgisLibBuildDateArgsSchemaSchema = z.object({});

export const publicPostgisLibBuildDateReturnsSchemaSchema = z.string();

export const publicPostgisLibRevisionArgsSchemaSchema = z.object({});

export const publicPostgisLibRevisionReturnsSchemaSchema = z.string();

export const publicPostgisLibVersionArgsSchemaSchema = z.object({});

export const publicPostgisLibVersionReturnsSchemaSchema = z.string();

export const publicPostgisLibjsonVersionArgsSchemaSchema = z.object({});

export const publicPostgisLibjsonVersionReturnsSchemaSchema = z.string();

export const publicPostgisLiblwgeomVersionArgsSchemaSchema = z.object({});

export const publicPostgisLiblwgeomVersionReturnsSchemaSchema = z.string();

export const publicPostgisLibprotobufVersionArgsSchemaSchema = z.object({});

export const publicPostgisLibprotobufVersionReturnsSchemaSchema = z.string();

export const publicPostgisLibxmlVersionArgsSchemaSchema = z.object({});

export const publicPostgisLibxmlVersionReturnsSchemaSchema = z.string();

export const publicPostgisNoopArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicPostgisNoopReturnsSchemaSchema = z.unknown();

export const publicPostgisProjVersionArgsSchemaSchema = z.object({});

export const publicPostgisProjVersionReturnsSchemaSchema = z.string();

export const publicPostgisScriptsBuildDateArgsSchemaSchema = z.object({});

export const publicPostgisScriptsBuildDateReturnsSchemaSchema = z.string();

export const publicPostgisScriptsInstalledArgsSchemaSchema = z.object({});

export const publicPostgisScriptsInstalledReturnsSchemaSchema = z.string();

export const publicPostgisScriptsReleasedArgsSchemaSchema = z.object({});

export const publicPostgisScriptsReleasedReturnsSchemaSchema = z.string();

export const publicPostgisSvnVersionArgsSchemaSchema = z.object({});

export const publicPostgisSvnVersionReturnsSchemaSchema = z.string();

export const publicPostgisTypeNameArgsSchemaSchema = z.object({
  coord_dimension: z.number(),
  geomname: z.string(),
  use_new_name: z.boolean().optional(),
});

export const publicPostgisTypeNameReturnsSchemaSchema = z.string();

export const publicPostgisTypmodDimsArgsSchemaSchema = z.object({
  '': z.number(),
});

export const publicPostgisTypmodDimsReturnsSchemaSchema = z.number();

export const publicPostgisTypmodSridArgsSchemaSchema = z.object({
  '': z.number(),
});

export const publicPostgisTypmodSridReturnsSchemaSchema = z.number();

export const publicPostgisTypmodTypeArgsSchemaSchema = z.object({
  '': z.number(),
});

export const publicPostgisTypmodTypeReturnsSchemaSchema = z.string();

export const publicPostgisVersionArgsSchemaSchema = z.object({});

export const publicPostgisVersionReturnsSchemaSchema = z.string();

export const publicPostgisWagyuVersionArgsSchemaSchema = z.object({});

export const publicPostgisWagyuVersionReturnsSchemaSchema = z.string();

export const publicRefreshTncBrandsViewArgsSchemaSchema = z.object({});

export const publicRefreshTncBrandsViewReturnsSchemaSchema = z.undefined();

export const publicSetLimitArgsSchemaSchema = z.object({
  '': z.number(),
});

export const publicSetLimitReturnsSchemaSchema = z.number();

export const publicShowLimitArgsSchemaSchema = z.object({});

export const publicShowLimitReturnsSchemaSchema = z.number();

export const publicShowTrgmArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicShowTrgmReturnsSchemaSchema = z.array(z.string());

export const publicSoundexArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicSoundexReturnsSchemaSchema = z.string();

export const publicSpheroidInArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicSpheroidInReturnsSchemaSchema = z.unknown();

export const publicSpheroidOutArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicSpheroidOutReturnsSchemaSchema = z.unknown();

export const publicSt3dclosestpointArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicSt3dclosestpointReturnsSchemaSchema = z.unknown();

export const publicSt3ddistanceArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicSt3ddistanceReturnsSchemaSchema = z.number();

export const publicSt3dlengthArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicSt3dlengthReturnsSchemaSchema = z.number();

export const publicSt3dlongestlineArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicSt3dlongestlineReturnsSchemaSchema = z.unknown();

export const publicSt3dmakeboxArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicSt3dmakeboxReturnsSchemaSchema = z.unknown();

export const publicSt3dmaxdistanceArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicSt3dmaxdistanceReturnsSchemaSchema = z.number();

export const publicSt3dperimeterArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicSt3dperimeterReturnsSchemaSchema = z.number();

export const publicSt3dshortestlineArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicSt3dshortestlineReturnsSchemaSchema = z.unknown();

export const publicStAddpointArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStAddpointReturnsSchemaSchema = z.unknown();

export const publicStAngleArgsSchemaSchema = z.union([
  z.object({
    line1: z.unknown(),
    line2: z.unknown(),
  }),
  z.object({
    pt1: z.unknown(),
    pt2: z.unknown(),
    pt3: z.unknown(),
    pt4: z.unknown().optional(),
  }),
]);

export const publicStAngleReturnsSchemaSchema = z.number();

export const publicStAreaArgsSchemaSchema = z.union([
  z.object({
    '': z.string(),
  }),
  z.object({
    '': z.unknown(),
  }),
  z.object({
    geog: z.unknown(),
    use_spheroid: z.boolean().optional(),
  }),
]);

export const publicStAreaReturnsSchemaSchema = z.number();

export const publicStArea2dArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStArea2dReturnsSchemaSchema = z.number();

export const publicStAsbinaryArgsSchemaSchema = z.union([
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicStAsbinaryReturnsSchemaSchema = z.string();

export const publicStAsencodedpolylineArgsSchemaSchema = z.object({
  geom: z.unknown(),
  nprecision: z.number().optional(),
});

export const publicStAsencodedpolylineReturnsSchemaSchema = z.string();

export const publicStAsewkbArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStAsewkbReturnsSchemaSchema = z.string();

export const publicStAsewktArgsSchemaSchema = z.union([
  z.object({
    '': z.string(),
  }),
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicStAsewktReturnsSchemaSchema = z.string();

export const publicStAsgeojsonArgsSchemaSchema = z.union([
  z.object({
    '': z.string(),
  }),
  z.object({
    geog: z.unknown(),
    maxdecimaldigits: z.number().optional(),
    options: z.number().optional(),
  }),
  z.object({
    geom: z.unknown(),
    maxdecimaldigits: z.number().optional(),
    options: z.number().optional(),
  }),
  z.object({
    geom_column: z.string().optional(),
    maxdecimaldigits: z.number().optional(),
    pretty_bool: z.boolean().optional(),
    r: z.record(z.unknown()),
  }),
]);

export const publicStAsgeojsonReturnsSchemaSchema = z.string();

export const publicStAsgmlArgsSchemaSchema = z.union([
  z.object({
    '': z.string(),
  }),
  z.object({
    geog: z.unknown(),
    id: z.string().optional(),
    maxdecimaldigits: z.number().optional(),
    nprefix: z.string().optional(),
    options: z.number().optional(),
  }),
  z.object({
    geog: z.unknown(),
    id: z.string().optional(),
    maxdecimaldigits: z.number().optional(),
    nprefix: z.string().optional(),
    options: z.number().optional(),
    version: z.number(),
  }),
  z.object({
    geom: z.unknown(),
    id: z.string().optional(),
    maxdecimaldigits: z.number().optional(),
    nprefix: z.string().optional(),
    options: z.number().optional(),
    version: z.number(),
  }),
  z.object({
    geom: z.unknown(),
    maxdecimaldigits: z.number().optional(),
    options: z.number().optional(),
  }),
]);

export const publicStAsgmlReturnsSchemaSchema = z.string();

export const publicStAshexewkbArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStAshexewkbReturnsSchemaSchema = z.string();

export const publicStAskmlArgsSchemaSchema = z.union([
  z.object({
    '': z.string(),
  }),
  z.object({
    geog: z.unknown(),
    maxdecimaldigits: z.number().optional(),
    nprefix: z.string().optional(),
  }),
  z.object({
    geom: z.unknown(),
    maxdecimaldigits: z.number().optional(),
    nprefix: z.string().optional(),
  }),
]);

export const publicStAskmlReturnsSchemaSchema = z.string();

export const publicStAslatlontextArgsSchemaSchema = z.object({
  geom: z.unknown(),
  tmpl: z.string().optional(),
});

export const publicStAslatlontextReturnsSchemaSchema = z.string();

export const publicStAsmarc21ArgsSchemaSchema = z.object({
  format: z.string().optional(),
  geom: z.unknown(),
});

export const publicStAsmarc21ReturnsSchemaSchema = z.string();

export const publicStAsmvtgeomArgsSchemaSchema = z.object({
  bounds: z.unknown(),
  buffer: z.number().optional(),
  clip_geom: z.boolean().optional(),
  extent: z.number().optional(),
  geom: z.unknown(),
});

export const publicStAsmvtgeomReturnsSchemaSchema = z.unknown();

export const publicStAssvgArgsSchemaSchema = z.union([
  z.object({
    '': z.string(),
  }),
  z.object({
    geog: z.unknown(),
    maxdecimaldigits: z.number().optional(),
    rel: z.number().optional(),
  }),
  z.object({
    geom: z.unknown(),
    maxdecimaldigits: z.number().optional(),
    rel: z.number().optional(),
  }),
]);

export const publicStAssvgReturnsSchemaSchema = z.string();

export const publicStAstextArgsSchemaSchema = z.union([
  z.object({
    '': z.string(),
  }),
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicStAstextReturnsSchemaSchema = z.string();

export const publicStAstwkbArgsSchemaSchema = z.union([
  z.object({
    geom: z.array(z.unknown()),
    ids: z.array(z.number()),
    prec: z.number().optional(),
    prec_m: z.number().optional(),
    prec_z: z.number().optional(),
    with_boxes: z.boolean().optional(),
    with_sizes: z.boolean().optional(),
  }),
  z.object({
    geom: z.unknown(),
    prec: z.number().optional(),
    prec_m: z.number().optional(),
    prec_z: z.number().optional(),
    with_boxes: z.boolean().optional(),
    with_sizes: z.boolean().optional(),
  }),
]);

export const publicStAstwkbReturnsSchemaSchema = z.string();

export const publicStAsx3dArgsSchemaSchema = z.object({
  geom: z.unknown(),
  maxdecimaldigits: z.number().optional(),
  options: z.number().optional(),
});

export const publicStAsx3dReturnsSchemaSchema = z.string();

export const publicStAzimuthArgsSchemaSchema = z.union([
  z.object({
    geog1: z.unknown(),
    geog2: z.unknown(),
  }),
  z.object({
    geom1: z.unknown(),
    geom2: z.unknown(),
  }),
]);

export const publicStAzimuthReturnsSchemaSchema = z.number();

export const publicStBoundaryArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStBoundaryReturnsSchemaSchema = z.unknown();

export const publicStBoundingdiagonalArgsSchemaSchema = z.object({
  fits: z.boolean().optional(),
  geom: z.unknown(),
});

export const publicStBoundingdiagonalReturnsSchemaSchema = z.unknown();

export const publicStBufferArgsSchemaSchema = z.union([
  z.object({
    geom: z.unknown(),
    options: z.string().optional(),
    radius: z.number(),
  }),
  z.object({
    geom: z.unknown(),
    quadsegs: z.number(),
    radius: z.number(),
  }),
]);

export const publicStBufferReturnsSchemaSchema = z.unknown();

export const publicStBuildareaArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStBuildareaReturnsSchemaSchema = z.unknown();

export const publicStCentroidArgsSchemaSchema = z.union([
  z.object({
    '': z.string(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicStCentroidReturnsSchemaSchema = z.unknown();

export const publicStCleangeometryArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStCleangeometryReturnsSchemaSchema = z.unknown();

export const publicStClipbybox2dArgsSchemaSchema = z.object({
  box: z.unknown(),
  geom: z.unknown(),
});

export const publicStClipbybox2dReturnsSchemaSchema = z.unknown();

export const publicStClosestpointArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStClosestpointReturnsSchemaSchema = z.unknown();

export const publicStClusterintersectingArgsSchemaSchema = z.object({
  '': z.array(z.unknown()),
});

export const publicStClusterintersectingReturnsSchemaSchema = z.array(z.unknown());

export const publicStCollectArgsSchemaSchema = z.union([
  z.object({
    '': z.array(z.unknown()),
  }),
  z.object({
    geom1: z.unknown(),
    geom2: z.unknown(),
  }),
]);

export const publicStCollectReturnsSchemaSchema = z.unknown();

export const publicStCollectionextractArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStCollectionextractReturnsSchemaSchema = z.unknown();

export const publicStCollectionhomogenizeArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStCollectionhomogenizeReturnsSchemaSchema = z.unknown();

export const publicStConcavehullArgsSchemaSchema = z.object({
  param_allow_holes: z.boolean().optional(),
  param_geom: z.unknown(),
  param_pctconvex: z.number(),
});

export const publicStConcavehullReturnsSchemaSchema = z.unknown();

export const publicStConvexhullArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStConvexhullReturnsSchemaSchema = z.unknown();

export const publicStCoorddimArgsSchemaSchema = z.object({
  geometry: z.unknown(),
});

export const publicStCoorddimReturnsSchemaSchema = z.number();

export const publicStCurvetolineArgsSchemaSchema = z.object({
  flags: z.number().optional(),
  geom: z.unknown(),
  tol: z.number().optional(),
  toltype: z.number().optional(),
});

export const publicStCurvetolineReturnsSchemaSchema = z.unknown();

export const publicStDelaunaytrianglesArgsSchemaSchema = z.object({
  flags: z.number().optional(),
  g1: z.unknown(),
  tolerance: z.number().optional(),
});

export const publicStDelaunaytrianglesReturnsSchemaSchema = z.unknown();

export const publicStDifferenceArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
  gridsize: z.number().optional(),
});

export const publicStDifferenceReturnsSchemaSchema = z.unknown();

export const publicStDimensionArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStDimensionReturnsSchemaSchema = z.number();

export const publicStDisjointArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStDisjointReturnsSchemaSchema = z.boolean();

export const publicStDistanceArgsSchemaSchema = z.union([
  z.object({
    geog1: z.unknown(),
    geog2: z.unknown(),
    use_spheroid: z.boolean().optional(),
  }),
  z.object({
    geom1: z.unknown(),
    geom2: z.unknown(),
  }),
]);

export const publicStDistanceReturnsSchemaSchema = z.number();

export const publicStDistancesphereArgsSchemaSchema = z.union([
  z.object({
    geom1: z.unknown(),
    geom2: z.unknown(),
  }),
  z.object({
    geom1: z.unknown(),
    geom2: z.unknown(),
    radius: z.number(),
  }),
]);

export const publicStDistancesphereReturnsSchemaSchema = z.number();

export const publicStDistancespheroidArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStDistancespheroidReturnsSchemaSchema = z.number();

export const publicStDumpArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicGeometryDumpSchema = z.object({
  path: z.array(z.number()).nullable(),
  geom: z.unknown().nullable(),
});

export const publicStDumppointsArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStDumppointsReturnsSchemaSchema = z.array(publicGeometryDumpSchema);

export const publicStDumpringsArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStDumpringsReturnsSchemaSchema = z.array(publicGeometryDumpSchema);

export const publicStDumpsegmentsArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStDumpsegmentsReturnsSchemaSchema = z.array(publicGeometryDumpSchema);

export const publicStEndpointArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStEndpointReturnsSchemaSchema = z.unknown();

export const publicStEnvelopeArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStEnvelopeReturnsSchemaSchema = z.unknown();

export const publicStExpandArgsSchemaSchema = z.union([
  z.object({
    box: z.unknown(),
    dx: z.number(),
    dy: z.number(),
  }),
  z.object({
    box: z.unknown(),
    dx: z.number(),
    dy: z.number(),
    dz: z.number().optional(),
  }),
  z.object({
    dm: z.number().optional(),
    dx: z.number(),
    dy: z.number(),
    dz: z.number().optional(),
    geom: z.unknown(),
  }),
]);

export const publicStExpandReturnsSchemaSchema = z.unknown();

export const publicStExteriorringArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStExteriorringReturnsSchemaSchema = z.unknown();

export const publicStFlipcoordinatesArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStFlipcoordinatesReturnsSchemaSchema = z.unknown();

export const publicStForce2dArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStForce2dReturnsSchemaSchema = z.unknown();

export const publicStForce3dArgsSchemaSchema = z.object({
  geom: z.unknown(),
  zvalue: z.number().optional(),
});

export const publicStForce3dReturnsSchemaSchema = z.unknown();

export const publicStForce3dmArgsSchemaSchema = z.object({
  geom: z.unknown(),
  mvalue: z.number().optional(),
});

export const publicStForce3dmReturnsSchemaSchema = z.unknown();

export const publicStForce3dzArgsSchemaSchema = z.object({
  geom: z.unknown(),
  zvalue: z.number().optional(),
});

export const publicStForce3dzReturnsSchemaSchema = z.unknown();

export const publicStForce4dArgsSchemaSchema = z.object({
  geom: z.unknown(),
  mvalue: z.number().optional(),
  zvalue: z.number().optional(),
});

export const publicStForce4dReturnsSchemaSchema = z.unknown();

export const publicStForcecollectionArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStForcecollectionReturnsSchemaSchema = z.unknown();

export const publicStForcecurveArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStForcecurveReturnsSchemaSchema = z.unknown();

export const publicStForcepolygonccwArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStForcepolygonccwReturnsSchemaSchema = z.unknown();

export const publicStForcepolygoncwArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStForcepolygoncwReturnsSchemaSchema = z.unknown();

export const publicStForcerhrArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStForcerhrReturnsSchemaSchema = z.unknown();

export const publicStForcesfsArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStForcesfsReturnsSchemaSchema = z.unknown();

export const publicStGeneratepointsArgsSchemaSchema = z.union([
  z.object({
    area: z.unknown(),
    npoints: z.number(),
  }),
  z.object({
    area: z.unknown(),
    npoints: z.number(),
    seed: z.number(),
  }),
]);

export const publicStGeneratepointsReturnsSchemaSchema = z.unknown();

export const publicStGeogfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeogfromtextReturnsSchemaSchema = z.unknown();

export const publicStGeogfromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeogfromwkbReturnsSchemaSchema = z.unknown();

export const publicStGeographyfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeographyfromtextReturnsSchemaSchema = z.unknown();

export const publicStGeohashArgsSchemaSchema = z.union([
  z.object({
    geog: z.unknown(),
    maxchars: z.number().optional(),
  }),
  z.object({
    geom: z.unknown(),
    maxchars: z.number().optional(),
  }),
]);

export const publicStGeohashReturnsSchemaSchema = z.string();

export const publicStGeomcollfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeomcollfromtextReturnsSchemaSchema = z.unknown();

export const publicStGeomcollfromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeomcollfromwkbReturnsSchemaSchema = z.unknown();

export const publicStGeometricmedianArgsSchemaSchema = z.object({
  fail_if_not_converged: z.boolean().optional(),
  g: z.unknown(),
  max_iter: z.number().optional(),
  tolerance: z.number().optional(),
});

export const publicStGeometricmedianReturnsSchemaSchema = z.unknown();

export const publicStGeometryfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeometryfromtextReturnsSchemaSchema = z.unknown();

export const publicStGeometrytypeArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStGeometrytypeReturnsSchemaSchema = z.string();

export const publicStGeomfromewkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeomfromewkbReturnsSchemaSchema = z.unknown();

export const publicStGeomfromewktArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeomfromewktReturnsSchemaSchema = z.unknown();

export const publicStGeomfromgeojsonArgsSchemaSchema = z.union([
  z.object({
    '': jsonSchema,
  }),
  z.object({
    '': jsonSchema,
  }),
  z.object({
    '': z.string(),
  }),
]);

export const publicStGeomfromgeojsonReturnsSchemaSchema = z.unknown();

export const publicStGeomfromgmlArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeomfromgmlReturnsSchemaSchema = z.unknown();

export const publicStGeomfromkmlArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeomfromkmlReturnsSchemaSchema = z.unknown();

export const publicStGeomfrommarc21ArgsSchemaSchema = z.object({
  marc21xml: z.string(),
});

export const publicStGeomfrommarc21ReturnsSchemaSchema = z.unknown();

export const publicStGeomfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeomfromtextReturnsSchemaSchema = z.unknown();

export const publicStGeomfromtwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeomfromtwkbReturnsSchemaSchema = z.unknown();

export const publicStGeomfromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGeomfromwkbReturnsSchemaSchema = z.unknown();

export const publicStGmltosqlArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStGmltosqlReturnsSchemaSchema = z.unknown();

export const publicStHasarcArgsSchemaSchema = z.object({
  geometry: z.unknown(),
});

export const publicStHasarcReturnsSchemaSchema = z.boolean();

export const publicStHausdorffdistanceArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStHausdorffdistanceReturnsSchemaSchema = z.number();

export const publicStHexagonArgsSchemaSchema = z.object({
  cell_i: z.number(),
  cell_j: z.number(),
  origin: z.unknown().optional(),
  size: z.number(),
});

export const publicStHexagonReturnsSchemaSchema = z.unknown();

export const publicStHexagongridArgsSchemaSchema = z.object({
  bounds: z.unknown(),
  size: z.number(),
});

export const publicStHexagongridReturnsSchemaSchema = z.array(z.record(z.unknown()));

export const publicStInterpolatepointArgsSchemaSchema = z.object({
  line: z.unknown(),
  point: z.unknown(),
});

export const publicStInterpolatepointReturnsSchemaSchema = z.number();

export const publicStIntersectionArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
  gridsize: z.number().optional(),
});

export const publicStIntersectionReturnsSchemaSchema = z.unknown();

export const publicStIsclosedArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStIsclosedReturnsSchemaSchema = z.boolean();

export const publicStIscollectionArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStIscollectionReturnsSchemaSchema = z.boolean();

export const publicStIsemptyArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStIsemptyReturnsSchemaSchema = z.boolean();

export const publicStIspolygonccwArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStIspolygonccwReturnsSchemaSchema = z.boolean();

export const publicStIspolygoncwArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStIspolygoncwReturnsSchemaSchema = z.boolean();

export const publicStIsringArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStIsringReturnsSchemaSchema = z.boolean();

export const publicStIssimpleArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStIssimpleReturnsSchemaSchema = z.boolean();

export const publicStIsvalidArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStIsvalidReturnsSchemaSchema = z.boolean();

export const publicStIsvaliddetailArgsSchemaSchema = z.object({
  flags: z.number().optional(),
  geom: z.unknown(),
});

export const publicValidDetailSchema = z.object({
  valid: z.boolean().nullable(),
  reason: z.string().nullable(),
  location: z.unknown().nullable(),
});

export const publicStIsvalidreasonArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStIsvalidreasonReturnsSchemaSchema = z.string();

export const publicStIsvalidtrajectoryArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStIsvalidtrajectoryReturnsSchemaSchema = z.boolean();

export const publicStLengthArgsSchemaSchema = z.union([
  z.object({
    '': z.string(),
  }),
  z.object({
    '': z.unknown(),
  }),
  z.object({
    geog: z.unknown(),
    use_spheroid: z.boolean().optional(),
  }),
]);

export const publicStLengthReturnsSchemaSchema = z.number();

export const publicStLength2dArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStLength2dReturnsSchemaSchema = z.number();

export const publicStLettersArgsSchemaSchema = z.object({
  font: jsonSchema.optional(),
  letters: z.string(),
});

export const publicStLettersReturnsSchemaSchema = z.unknown();

export const publicStLinefromencodedpolylineArgsSchemaSchema = z.object({
  nprecision: z.number().optional(),
  txtin: z.string(),
});

export const publicStLinefromencodedpolylineReturnsSchemaSchema = z.unknown();

export const publicStLinefrommultipointArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStLinefrommultipointReturnsSchemaSchema = z.unknown();

export const publicStLinefromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStLinefromtextReturnsSchemaSchema = z.unknown();

export const publicStLinefromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStLinefromwkbReturnsSchemaSchema = z.unknown();

export const publicStLinelocatepointArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStLinelocatepointReturnsSchemaSchema = z.number();

export const publicStLinemergeArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStLinemergeReturnsSchemaSchema = z.unknown();

export const publicStLinestringfromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStLinestringfromwkbReturnsSchemaSchema = z.unknown();

export const publicStLinetocurveArgsSchemaSchema = z.object({
  geometry: z.unknown(),
});

export const publicStLinetocurveReturnsSchemaSchema = z.unknown();

export const publicStLocatealongArgsSchemaSchema = z.object({
  geometry: z.unknown(),
  leftrightoffset: z.number().optional(),
  measure: z.number(),
});

export const publicStLocatealongReturnsSchemaSchema = z.unknown();

export const publicStLocatebetweenArgsSchemaSchema = z.object({
  frommeasure: z.number(),
  geometry: z.unknown(),
  leftrightoffset: z.number().optional(),
  tomeasure: z.number(),
});

export const publicStLocatebetweenReturnsSchemaSchema = z.unknown();

export const publicStLocatebetweenelevationsArgsSchemaSchema = z.object({
  fromelevation: z.number(),
  geometry: z.unknown(),
  toelevation: z.number(),
});

export const publicStLocatebetweenelevationsReturnsSchemaSchema = z.unknown();

export const publicStMArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStMReturnsSchemaSchema = z.number();

export const publicStMakebox2dArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStMakebox2dReturnsSchemaSchema = z.unknown();

export const publicStMakelineArgsSchemaSchema = z.union([
  z.object({
    '': z.array(z.unknown()),
  }),
  z.object({
    geom1: z.unknown(),
    geom2: z.unknown(),
  }),
]);

export const publicStMakelineReturnsSchemaSchema = z.unknown();

export const publicStMakepolygonArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStMakepolygonReturnsSchemaSchema = z.unknown();

export const publicStMakevalidArgsSchemaSchema = z.union([
  z.object({
    '': z.unknown(),
  }),
  z.object({
    geom: z.unknown(),
    params: z.string(),
  }),
]);

export const publicStMakevalidReturnsSchemaSchema = z.unknown();

export const publicStMaximuminscribedcircleArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStMaximuminscribedcircleReturnsSchemaSchema = z.record(z.unknown());

export const publicStMemsizeArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStMemsizeReturnsSchemaSchema = z.number();

export const publicStMinimumboundingcircleArgsSchemaSchema = z.object({
  inputgeom: z.unknown(),
  segs_per_quarter: z.number().optional(),
});

export const publicStMinimumboundingcircleReturnsSchemaSchema = z.unknown();

export const publicStMinimumboundingradiusArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStMinimumboundingradiusReturnsSchemaSchema = z.record(z.unknown());

export const publicStMinimumclearanceArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStMinimumclearanceReturnsSchemaSchema = z.number();

export const publicStMinimumclearancelineArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStMinimumclearancelineReturnsSchemaSchema = z.unknown();

export const publicStMlinefromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMlinefromtextReturnsSchemaSchema = z.unknown();

export const publicStMlinefromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMlinefromwkbReturnsSchemaSchema = z.unknown();

export const publicStMpointfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMpointfromtextReturnsSchemaSchema = z.unknown();

export const publicStMpointfromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMpointfromwkbReturnsSchemaSchema = z.unknown();

export const publicStMpolyfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMpolyfromtextReturnsSchemaSchema = z.unknown();

export const publicStMpolyfromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMpolyfromwkbReturnsSchemaSchema = z.unknown();

export const publicStMultiArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStMultiReturnsSchemaSchema = z.unknown();

export const publicStMultilinefromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMultilinefromwkbReturnsSchemaSchema = z.unknown();

export const publicStMultilinestringfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMultilinestringfromtextReturnsSchemaSchema = z.unknown();

export const publicStMultipointfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMultipointfromtextReturnsSchemaSchema = z.unknown();

export const publicStMultipointfromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMultipointfromwkbReturnsSchemaSchema = z.unknown();

export const publicStMultipolyfromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMultipolyfromwkbReturnsSchemaSchema = z.unknown();

export const publicStMultipolygonfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStMultipolygonfromtextReturnsSchemaSchema = z.unknown();

export const publicStNdimsArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStNdimsReturnsSchemaSchema = z.number();

export const publicStNodeArgsSchemaSchema = z.object({
  g: z.unknown(),
});

export const publicStNodeReturnsSchemaSchema = z.unknown();

export const publicStNormalizeArgsSchemaSchema = z.object({
  geom: z.unknown(),
});

export const publicStNormalizeReturnsSchemaSchema = z.unknown();

export const publicStNpointsArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStNpointsReturnsSchemaSchema = z.number();

export const publicStNringsArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStNringsReturnsSchemaSchema = z.number();

export const publicStNumgeometriesArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStNumgeometriesReturnsSchemaSchema = z.number();

export const publicStNuminteriorringArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStNuminteriorringReturnsSchemaSchema = z.number();

export const publicStNuminteriorringsArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStNuminteriorringsReturnsSchemaSchema = z.number();

export const publicStNumpatchesArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStNumpatchesReturnsSchemaSchema = z.number();

export const publicStNumpointsArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStNumpointsReturnsSchemaSchema = z.number();

export const publicStOffsetcurveArgsSchemaSchema = z.object({
  distance: z.number(),
  line: z.unknown(),
  params: z.string().optional(),
});

export const publicStOffsetcurveReturnsSchemaSchema = z.unknown();

export const publicStOrientedenvelopeArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStOrientedenvelopeReturnsSchemaSchema = z.unknown();

export const publicStPerimeterArgsSchemaSchema = z.union([
  z.object({
    '': z.unknown(),
  }),
  z.object({
    geog: z.unknown(),
    use_spheroid: z.boolean().optional(),
  }),
]);

export const publicStPerimeterReturnsSchemaSchema = z.number();

export const publicStPerimeter2dArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStPerimeter2dReturnsSchemaSchema = z.number();

export const publicStPointfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStPointfromtextReturnsSchemaSchema = z.unknown();

export const publicStPointfromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStPointfromwkbReturnsSchemaSchema = z.unknown();

export const publicStPointmArgsSchemaSchema = z.object({
  mcoordinate: z.number(),
  srid: z.number().optional(),
  xcoordinate: z.number(),
  ycoordinate: z.number(),
});

export const publicStPointmReturnsSchemaSchema = z.unknown();

export const publicStPointonsurfaceArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStPointonsurfaceReturnsSchemaSchema = z.unknown();

export const publicStPointsArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStPointsReturnsSchemaSchema = z.unknown();

export const publicStPointzArgsSchemaSchema = z.object({
  srid: z.number().optional(),
  xcoordinate: z.number(),
  ycoordinate: z.number(),
  zcoordinate: z.number(),
});

export const publicStPointzReturnsSchemaSchema = z.unknown();

export const publicStPointzmArgsSchemaSchema = z.object({
  mcoordinate: z.number(),
  srid: z.number().optional(),
  xcoordinate: z.number(),
  ycoordinate: z.number(),
  zcoordinate: z.number(),
});

export const publicStPointzmReturnsSchemaSchema = z.unknown();

export const publicStPolyfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStPolyfromtextReturnsSchemaSchema = z.unknown();

export const publicStPolyfromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStPolyfromwkbReturnsSchemaSchema = z.unknown();

export const publicStPolygonfromtextArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStPolygonfromtextReturnsSchemaSchema = z.unknown();

export const publicStPolygonfromwkbArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStPolygonfromwkbReturnsSchemaSchema = z.unknown();

export const publicStPolygonizeArgsSchemaSchema = z.object({
  '': z.array(z.unknown()),
});

export const publicStPolygonizeReturnsSchemaSchema = z.unknown();

export const publicStProjectArgsSchemaSchema = z.object({
  azimuth: z.number(),
  distance: z.number(),
  geog: z.unknown(),
});

export const publicStProjectReturnsSchemaSchema = z.unknown();

export const publicStQuantizecoordinatesArgsSchemaSchema = z.object({
  g: z.unknown(),
  prec_m: z.number().optional(),
  prec_x: z.number(),
  prec_y: z.number().optional(),
  prec_z: z.number().optional(),
});

export const publicStQuantizecoordinatesReturnsSchemaSchema = z.unknown();

export const publicStReduceprecisionArgsSchemaSchema = z.object({
  geom: z.unknown(),
  gridsize: z.number(),
});

export const publicStReduceprecisionReturnsSchemaSchema = z.unknown();

export const publicStRelateArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStRelateReturnsSchemaSchema = z.string();

export const publicStRemoverepeatedpointsArgsSchemaSchema = z.object({
  geom: z.unknown(),
  tolerance: z.number().optional(),
});

export const publicStRemoverepeatedpointsReturnsSchemaSchema = z.unknown();

export const publicStReverseArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStReverseReturnsSchemaSchema = z.unknown();

export const publicStSegmentizeArgsSchemaSchema = z.object({
  geog: z.unknown(),
  max_segment_length: z.number(),
});

export const publicStSegmentizeReturnsSchemaSchema = z.unknown();

export const publicStSetsridArgsSchemaSchema = z.union([
  z.object({
    geog: z.unknown(),
    srid: z.number(),
  }),
  z.object({
    geom: z.unknown(),
    srid: z.number(),
  }),
]);

export const publicStSetsridReturnsSchemaSchema = z.unknown();

export const publicStSharedpathsArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStSharedpathsReturnsSchemaSchema = z.unknown();

export const publicStShiftlongitudeArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStShiftlongitudeReturnsSchemaSchema = z.unknown();

export const publicStShortestlineArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStShortestlineReturnsSchemaSchema = z.unknown();

export const publicStSimplifypolygonhullArgsSchemaSchema = z.object({
  geom: z.unknown(),
  is_outer: z.boolean().optional(),
  vertex_fraction: z.number(),
});

export const publicStSimplifypolygonhullReturnsSchemaSchema = z.unknown();

export const publicStSplitArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStSplitReturnsSchemaSchema = z.unknown();

export const publicStSquareArgsSchemaSchema = z.object({
  cell_i: z.number(),
  cell_j: z.number(),
  origin: z.unknown().optional(),
  size: z.number(),
});

export const publicStSquareReturnsSchemaSchema = z.unknown();

export const publicStSquaregridArgsSchemaSchema = z.object({
  bounds: z.unknown(),
  size: z.number(),
});

export const publicStSquaregridReturnsSchemaSchema = z.array(z.record(z.unknown()));

export const publicStSridArgsSchemaSchema = z.union([
  z.object({
    geog: z.unknown(),
  }),
  z.object({
    geom: z.unknown(),
  }),
]);

export const publicStSridReturnsSchemaSchema = z.number();

export const publicStStartpointArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStStartpointReturnsSchemaSchema = z.unknown();

export const publicStSubdivideArgsSchemaSchema = z.object({
  geom: z.unknown(),
  gridsize: z.number().optional(),
  maxvertices: z.number().optional(),
});

export const publicStSubdivideReturnsSchemaSchema = z.array(z.unknown());

export const publicStSummaryArgsSchemaSchema = z.union([
  z.object({
    '': z.unknown(),
  }),
  z.object({
    '': z.unknown(),
  }),
]);

export const publicStSummaryReturnsSchemaSchema = z.string();

export const publicStSwapordinatesArgsSchemaSchema = z.object({
  geom: z.unknown(),
  ords: z.unknown(),
});

export const publicStSwapordinatesReturnsSchemaSchema = z.unknown();

export const publicStSymdifferenceArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
  gridsize: z.number().optional(),
});

export const publicStSymdifferenceReturnsSchemaSchema = z.unknown();

export const publicStSymmetricdifferenceArgsSchemaSchema = z.object({
  geom1: z.unknown(),
  geom2: z.unknown(),
});

export const publicStSymmetricdifferenceReturnsSchemaSchema = z.unknown();

export const publicStTileenvelopeArgsSchemaSchema = z.object({
  bounds: z.unknown().optional(),
  margin: z.number().optional(),
  x: z.number(),
  y: z.number(),
  zoom: z.number(),
});

export const publicStTileenvelopeReturnsSchemaSchema = z.unknown();

export const publicStTransformArgsSchemaSchema = z.union([
  z.object({
    from_proj: z.string(),
    geom: z.unknown(),
    to_proj: z.string(),
  }),
  z.object({
    from_proj: z.string(),
    geom: z.unknown(),
    to_srid: z.number(),
  }),
  z.object({
    geom: z.unknown(),
    to_proj: z.string(),
  }),
]);

export const publicStTransformReturnsSchemaSchema = z.unknown();

export const publicStTriangulatepolygonArgsSchemaSchema = z.object({
  g1: z.unknown(),
});

export const publicStTriangulatepolygonReturnsSchemaSchema = z.unknown();

export const publicStUnionArgsSchemaSchema = z.union([
  z.object({
    '': z.array(z.unknown()),
  }),
  z.object({
    geom1: z.unknown(),
    geom2: z.unknown(),
  }),
  z.object({
    geom1: z.unknown(),
    geom2: z.unknown(),
    gridsize: z.number(),
  }),
]);

export const publicStUnionReturnsSchemaSchema = z.unknown();

export const publicStVoronoilinesArgsSchemaSchema = z.object({
  extend_to: z.unknown().optional(),
  g1: z.unknown(),
  tolerance: z.number().optional(),
});

export const publicStVoronoilinesReturnsSchemaSchema = z.unknown();

export const publicStVoronoipolygonsArgsSchemaSchema = z.object({
  extend_to: z.unknown().optional(),
  g1: z.unknown(),
  tolerance: z.number().optional(),
});

export const publicStVoronoipolygonsReturnsSchemaSchema = z.unknown();

export const publicStWkbtosqlArgsSchemaSchema = z.object({
  wkb: z.string(),
});

export const publicStWkbtosqlReturnsSchemaSchema = z.unknown();

export const publicStWkttosqlArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicStWkttosqlReturnsSchemaSchema = z.unknown();

export const publicStWrapxArgsSchemaSchema = z.object({
  geom: z.unknown(),
  move: z.number(),
  wrap: z.number(),
});

export const publicStWrapxReturnsSchemaSchema = z.unknown();

export const publicStXArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStXReturnsSchemaSchema = z.number();

export const publicStXmaxArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStXmaxReturnsSchemaSchema = z.number();

export const publicStXminArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStXminReturnsSchemaSchema = z.number();

export const publicStYArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStYReturnsSchemaSchema = z.number();

export const publicStYmaxArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStYmaxReturnsSchemaSchema = z.number();

export const publicStYminArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStYminReturnsSchemaSchema = z.number();

export const publicStZArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStZReturnsSchemaSchema = z.number();

export const publicStZmaxArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStZmaxReturnsSchemaSchema = z.number();

export const publicStZmflagArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStZmflagReturnsSchemaSchema = z.number();

export const publicStZminArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicStZminReturnsSchemaSchema = z.number();

export const publicTextArgsSchemaSchema = z.object({
  '': z.unknown(),
});

export const publicTextReturnsSchemaSchema = z.string();

export const publicTextSoundexArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicTextSoundexReturnsSchemaSchema = z.string();

export const publicTransactionApprovalArgsSchemaSchema = z.object({
  _approved: z.boolean(),
  _reasoning: z.string(),
  _transaction_id: z.number(),
});

export const publicTransactionApprovalReturnsSchemaSchema = z.undefined();

export const publicTransferMarketPositionArgsSchemaSchema = z.object({
  positions: jsonSchema,
  user_uid: z.string(),
});

export const publicTransferMarketPositionReturnsSchemaSchema = jsonSchema;

export const publicUnlockrowsArgsSchemaSchema = z.object({
  '': z.string(),
});

export const publicUnlockrowsReturnsSchemaSchema = z.number();

export const publicUpdatePosIntegrationMetadataArgsSchemaSchema = z.object({
  p_integration_id: z.number(),
  p_metadata: jsonSchema,
});

export const publicUpdatePosIntegrationMetadataReturnsSchemaSchema = z.boolean();

export const publicUpdategeometrysridArgsSchemaSchema = z.object({
  catalogn_name: z.string(),
  column_name: z.string(),
  new_srid_in: z.number(),
  schema_name: z.string(),
  table_name: z.string(),
});

export const publicUpdategeometrysridReturnsSchemaSchema = z.string();

export const publicUpsertBrandsAndProductsArgsSchemaSchema = z.object({
  brands: jsonSchema,
  products: jsonSchema,
});

export const publicUpsertBrandsAndProductsReturnsSchemaSchema = z.undefined();

export const publicUpsertPlaidAccessTokenArgsSchemaSchema = z.object({
  p_access_token: z.string(),
  p_uid: z.string(),
});

export const publicUpsertPlaidAccessTokenReturnsSchemaSchema = z.undefined();

export const publicUpsertPlaidAccountIdArgsSchemaSchema = z.object({
  p_account_id: z.string(),
  p_uid: z.string(),
});

export const publicUpsertPlaidAccountIdReturnsSchemaSchema = z.undefined();

export const publicUpsertPosIntegrationArgsSchemaSchema = z.object({
  p_api_key: z.string(),
  p_api_secret: z.string(),
  p_is_active: z.boolean().optional(),
  p_location_id: z.number(),
  p_metadata: jsonSchema.optional(),
  p_pos_type: publicPointOfSalesSchema,
  p_store_id: z.string(),
});

export const publicUpsertPosIntegrationReturnsSchemaSchema = jsonSchema;

export const publicUpsertTreezBrandInterfaceArgsSchemaSchema = z.object({
  items: jsonSchema,
});

export const publicUpsertTreezBrandInterfaceReturnsSchemaSchema = jsonSchema;

export const publicUpsertTreezProductCategoriesArgsSchemaSchema = z.object({
  items: jsonSchema,
});

export const publicUpsertTreezProductCategoriesReturnsSchemaSchema = jsonSchema;

export const publicUpsertTreezProductLinksArgsSchemaSchema = z.object({
  items: jsonSchema,
});

export const publicUpsertTreezProductLinksReturnsSchemaSchema = jsonSchema;

export const publicUserHasSeatPermissionArgsSchemaSchema = z.object({
  permission_type: z.string(),
  subscription_id_param: z.number(),
  user_id_param: z.number(),
});

export const publicUserHasSeatPermissionReturnsSchemaSchema = z.boolean();

export const publicWithdrawFundsArgsSchemaSchema = z.object({
  p_user_uid: z.string(),
  p_withdraw_amount: z.number(),
});

export const publicWithdrawFundsReturnsSchemaSchema = z.undefined();

export const publicDblinkGetPkeyReturnsSchemaSchema = z.array(publicDblinkPkeyResultsSchema);

export const publicStDumpReturnsSchemaSchema = z.array(publicGeometryDumpSchema);

export const publicStIsvaliddetailReturnsSchemaSchema = publicValidDetailSchema;
